(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kearty-questionnaire-flow-1-calendly"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const questionnaireRoots = document.querySelectorAll(
      '[data-kearty-questionnaire-flow-1]:not([data-kq-flow-1-initialized])'
    );

    questionnaireRoots.forEach((root) => {
      root.setAttribute('data-kq-flow-1-initialized', 'true');

      const questionRegion = root.querySelector(
        '[data-kq-question-region]'
      );
      const form = root.querySelector('[data-kq-form]');
      const backButton = root.querySelector('[data-kq-back]');
      const nextButton = root.querySelector('[data-kq-next]');
      const helpButton = root.querySelector('[data-kq-help]');

      const homeUrl = root.dataset.homeUrl || '/';
      const contactUrl =
        root.dataset.contactUrl || '/pages/contact';
      const termsUrl =
        root.dataset.termsUrl || '/pages/algemene-voorwaarden';
      const privacyUrl =
        root.dataset.privacyUrl || '/pages/privacy-statement';

      const countryCode =
        (root.dataset.countryCode || '').toUpperCase();

      const isNetherlands = countryCode === 'NL';

      const calendlyUrl =
        'https://calendly.com/clanooij-kearty/persoonlijk-gesprek';

      const ensureCalendlyAssets = () => {
        if (
          window.Calendly &&
          typeof window.Calendly.initPopupWidget === 'function'
        ) {
          return Promise.resolve();
        }

        if (!document.querySelector('link[data-kearty-calendly-css]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href =
            'https://assets.calendly.com/assets/external/widget.css';
          stylesheet.setAttribute('data-kearty-calendly-css', 'true');
          document.head.appendChild(stylesheet);
        }

        return new Promise((resolve, reject) => {
          const existingScript = document.querySelector(
            'script[data-kearty-calendly-script]'
          );

          const onReady = () => {
            if (
              window.Calendly &&
              typeof window.Calendly.initPopupWidget === 'function'
            ) {
              resolve();
            } else {
              reject(new Error('Calendly is niet beschikbaar.'));
            }
          };

          if (existingScript) {
            existingScript.addEventListener('load', onReady, { once: true });
            existingScript.addEventListener('error', reject, { once: true });
            return;
          }

          const script = document.createElement('script');
          script.src =
            'https://assets.calendly.com/assets/external/widget.js';
          script.async = true;
          script.setAttribute('data-kearty-calendly-script', 'true');
          script.addEventListener('load', onReady, { once: true });
          script.addEventListener('error', reject, { once: true });
          document.head.appendChild(script);
        });
      };

      const openCalendlyPopup = async () => {
        await ensureCalendlyAssets();

        window.Calendly.initPopupWidget({
          url: calendlyUrl
        });
      };

      const escapeHtml = (value) =>
        String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');

      const addLowestPriceToLabel = (label, price) => {
        return price
          ? `${label} – vanaf ${price}`
          : label;
      };

      const answers = {};
      const history = [];
      const shownQuestions = new Map();
      let submissionPending = false;
      let submissionFailedDuringDispatch = false;

      let selectedTreatment = '';
      let selectedVariantId = '';

      const continuationTreatmentMap = {
        wegovy: {
          '0_25_mg': 'wegovy_0_5',
          '0_5_mg': 'wegovy_1',
          '1_0_mg': 'wegovy_1_7',
          '1_7_mg': 'wegovy_2_4',
          '2_4_mg': 'wegovy_2_4'
        },
        mounjaro: {
          '2_5_mg': 'mounjaro_5',
          '5_mg': 'mounjaro_7_5',
          '7_5_mg': 'mounjaro_10',
          '10_mg': 'mounjaro_12_5',
          '12_5_mg': 'mounjaro_15',
          '15_mg': 'mounjaro_15'
        },
        ozempic: {
          '0_25_mg': 'ozempic_0_5',
          '0_5_mg': 'ozempic_1',
          '1_0_mg': 'ozempic_2',
          '2_0_mg': 'ozempic_2'
        },
        rybelsus: {
          '1_5_mg': 'rybelsus_4',
          '4_mg': 'rybelsus_9',
          '9_mg': 'rybelsus_9'
        },
        saxenda: {
          default: 'saxenda'
        },
        mysimba: {
          default: 'mysimba'
        }
      };

      const getContinuationTreatmentKey = () => {
        const currentTreatment =
          answers.current_or_previous_treatment;

        if (!currentTreatment) {
          return '';
        }

        const treatmentMap =
          continuationTreatmentMap[currentTreatment];

        if (!treatmentMap) {
          return '';
        }

        if (treatmentMap.default) {
          return treatmentMap.default;
        }

        const dosageAnswerKey =
          `${currentTreatment}_current_dosage`;

        const currentDosage =
          answers[dosageAnswerKey];

        if (!currentDosage) {
          return '';
        }

        return treatmentMap[currentDosage] || '';
      };

      let currentQuestionId = 'dateOfBirth';
      let statusScreen = null;

      const questions = [
        {
          id: 'dateOfBirth',
          type: 'date',
          title: 'Wat is je geboortedatum?',
          help: 'Je geboortedatum gebruiken we om je leeftijd te bepalen en om deze op het e-recept te vermelden als de arts je aanvraag goedkeurt.'
        },
        {
          id: 'sex_at_birth',
          type: 'radio',
          title: 'Welk geslacht werd bij je geboorte geregistreerd?',
          options: [
            { value: 'male', label: 'Mannelijk' },
            { value: 'female', label: 'Vrouwelijk' },
            { value: 'intersex_or_other', label: 'Intersekse of anders' }
          ]
        },
        {
          id: 'pregnancy_status',
          type: 'radio',
          title: 'Probeer je op dit moment zwanger te worden, ben je zwanger of geef je borstvoeding?',
          condition: () => answers.sex_at_birth === 'female',
          options: [
            { value: 'pregnant', label: 'Ik ben zwanger' },
            { value: 'breastfeeding', label: 'Ik geef borstvoeding' },
            {
              value: 'trying_to_conceive',
              label: 'Ik probeer zwanger te worden'
            },
            {
              value: 'none',
              label: 'Nee, geen van bovenstaande'
            }
          ]
        },
        {
          id: 'body_measurements',
          type: 'measurements',
          title: 'Wat zijn je lengte en je gewicht?',
          help:
            'Met je lengte en huidige gewicht berekenen we automatisch je BMI.'
        },
        {
          id: 'previous_weight_loss_attempts',
          type: 'checkbox',
          title: 'Wat heb je eerder gedaan om af te vallen?',
          help: 'Je kunt meerdere antwoorden kiezen.',
          exclusiveValues: ['not_tried'],
          options: [
            {
              value: 'diet',
              label: 'Zelf mijn voeding of eetpatroon aangepast'
            },
            {
              value: 'exercise',
              label: 'Meer bewogen of gesport'
            },
            {
              value: 'dietitian',
              label:
                'Begeleiding gehad van een diëtist of voedingsdeskundige'
            },
            {
              value: 'gli',
              label: 'Een gecombineerde leefstijlinterventie (GLI) gevolgd'
            },
            {
              value: 'other_program',
              label: 'Een ander afvalprogramma of begeleidingstraject gevolgd'
            },
            {
              value: 'weight_loss_medication',
              label: 'Medicatie gebruikt om af te vallen'
            },
            {
              value: 'bariatric_surgery',
              label:
                'Een maagverkleining of andere operatie voor gewichtsverlies gehad'
            },
            {
              value: 'not_tried',
              label: 'Ik heb nog niet eerder geprobeerd af te vallen'
            },
            {
              value: 'other',
              label: 'Anders, namelijk'
            }
                    ]
        },
        {
          id: 'previous_weight_loss_medications',
          type: 'checkbox',
          title: 'Welke medicatie heb je eerder gebruikt om af te vallen?',
          help: 'Je kunt meerdere behandelingen selecteren.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_attempts) &&
            answers.previous_weight_loss_attempts.includes(
              'weight_loss_medication'
            ),
          options: [
            { value: 'wegovy', label: 'Wegovy®' },
            { value: 'mounjaro', label: 'Mounjaro®' },
            { value: 'ozempic', label: 'Ozempic®' },
            { value: 'saxenda', label: 'Saxenda®' },
            { value: 'mysimba', label: 'Mysimba®' },
            { value: 'rybelsus', label: 'Rybelsus®' },
            { value: 'other', label: 'Andere medicatie' }
          ]
        },
        {
          id: 'previous_weight_loss_medication_details',
          type: 'medication_history',
          title: 'Vertel ons iets meer over de medicatie die je hebt gebruikt',
          help:
            'Vul per behandeling de periode in waarin je deze hebt gebruikt. Waar relevant vragen we ook naar de laatst gebruikte dosering.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_medications) &&
            answers.previous_weight_loss_medications.length > 0
        },
        {
          id: 'weight_related_conditions',
          section: 'health',
          type: 'checkbox',
          title: 'Heb je één of meer van de volgende gewichtsgerelateerde aandoeningen of klachten?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'high_blood_pressure',
              label: 'Hoge bloeddruk'
            },
            {
              value: 'high_cholesterol',
              label: 'Verhoogd cholesterol of verhoogde bloedvetten'
            },
            {
              value: 'prediabetes',
              label: 'Prediabetes'
            },
            {
              value: 'type_2_diabetes',
              label: 'Diabetes type 2'
            },
            {
              value: 'type_1_or_other_diabetes',
              label: 'Diabetes type 1 of een andere vorm van diabetes'
            },
            {
              value: 'sleep_apnea',
              label: 'Slaapapneu (OSAS)'
            },
            {
              value: 'cardiovascular_disease',
              label: 'Een hart- of vaatziekte'
            },
            {
              value: 'fatty_liver',
              label: 'Leververvetting'
            },
            {
              value: 'pcos',
              label: 'PCOS'
            },
                        {
              value: 'osteoarthritis',
              label: 'Artrose aan de knie of heup'
            },
            {
              value: 'none',
              label: 'Geen van bovenstaande'
            },
            {
              value: 'other',
              label: 'Andere gewichtsgerelateerde aandoening, namelijk'
            }
          ]
        },
        {
          id: 'pancreas_conditions',
          section: 'health',
          type: 'checkbox',
          title:
            'Heb je één of meer van de volgende aandoeningen of behandelingen aan de alvleesklier gehad?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'pancreatitis',
              label: 'Een ontsteking van de alvleesklier (pancreatitis)'
            },
            {
              value: 'other_pancreas_condition',
              label: 'Een andere aandoening of afwijking aan de alvleesklier'
            },
            {
  value: 'pancreas_removed',
  label:
    'Mijn alvleesklier is gedeeltelijk of volledig verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'gallbladder_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende galblaasproblemen gehad?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'gallstones',
      label: 'Galstenen'
    },
    {
      value: 'gallbladder_inflammation',
      label: 'Een ontsteking van de galblaas'
    },
    {
  value: 'gallbladder_removed',
  label: 'Mijn galblaas is verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'current_gallbladder_symptoms',
  section: 'health',
  type: 'radio',
  title:
    'Heb je op dit moment klachten die mogelijk te maken hebben met je galblaas of galwegen?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.gallbladder_conditions
    )
      ? answers.gallbladder_conditions
      : [];

    return [
      'gallstones',
      'gallbladder_inflammation',
      'gallbladder_removed'
    ].some((value) => selectedConditions.includes(value));
  },
    options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'other_health_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende aandoeningen?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'severe_gastrointestinal_condition',
      label: 'Een ernstige maag- of darmaandoening'
    },
    {
      value: 'kidney_condition',
      label: 'Een nierziekte of verminderde nierfunctie'
    },
    {
      value: 'liver_condition',
      label: 'Een leverziekte'
    },
    {
      value: 'thyroid_condition',
      label:
        'Een schildklieraandoening, schildklierknobbels of schildklierkanker'
    },
    {
      value: 'epilepsy',
      label: 'Epilepsie of andere aanvallen'
    },
    {
      value: 'cancer',
      label: 'Kanker'
    },
    {
      value: 'other',
      label: 'Een andere ernstige of chronische aandoening'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'health_conditions_treatment_status',
  section: 'health',
  type: 'radio',
  title:
    'Word je hiervoor momenteel behandeld of is de aandoening onder controle?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.other_health_conditions
    )
      ? answers.other_health_conditions
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication',
  section: 'health',
  type: 'radio',
  title:
    'Gebruik je op dit moment medicijnen, anders dan medicatie om af te vallen?',
  help:
    'Denk ook aan medicijnen die je alleen af en toe of zo nodig gebruikt.',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication_details',
  section: 'health',
  type: 'textarea',
  title: 'Welke medicijnen gebruik je op dit moment?',
  help:
    'Vermeld per medicijn de naam, dosering en hoe vaak je het gebruikt.',
  label: 'Medicijn(en)',
  placeholder:
    'Bijvoorbeeld: Metformine 500 mg, twee keer per dag',
  condition: () => answers.current_medication === 'yes'
},
{
  id: 'medication_allergies',
  section: 'health',
  type: 'radio',
  title:
    'Ben je allergisch of overgevoelig voor medicijnen of andere stoffen?',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'medication_allergy_details',
  section: 'health',
  type: 'textarea',
  title: 'Waar ben je allergisch of overgevoelig voor?',
  help:
    'Vermeld het medicijn of de stof en beschrijf welke reactie je krijgt.',
  label: 'Allergie of overgevoeligheid',
  placeholder:
    'Bijvoorbeeld: penicilline – huiduitslag en zwelling',
  errorMessage:
    'Vul in waarvoor je allergisch of overgevoelig bent en welke reactie je krijgt.',
  condition: () => answers.medication_allergies === 'yes'
},
{
  id: 'eating_disorder_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden last gehad van een eetstoornis of ernstige problemen met eten?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'anorexia',
      label: 'Anorexia nervosa'
    },
    {
      value: 'bulimia',
      label: 'Boulimia nervosa'
    },
    {
      value: 'binge_eating',
      label: 'Eetbuien of een eetbuistoornis'
    },
    {
      value: 'other',
      label: 'Een andere eetstoornis of ernstige problemen met eten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'eating_disorder_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze eetproblemen of deze eetstoornis op dit moment nog?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.eating_disorder_history
    )
      ? answers.eating_disorder_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current',
      label: 'Ja, dit speelt op dit moment'
    },
    {
      value: 'past',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'mental_health_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden te maken gehad met psychische klachten of een psychische aandoening?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'depression',
      label: 'Depressie'
    },
    {
      value: 'anxiety_or_panic',
      label: 'Angstklachten of een paniekstoornis'
    },
    {
      value: 'bipolar_disorder',
      label: 'Een bipolaire stoornis'
    },
    {
      value: 'psychosis',
      label: 'Een psychose of schizofrenie'
    },
    {
      value: 'other',
      label: 'Een andere psychische aandoening of ernstige psychische klachten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'mental_health_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze psychische klachten op dit moment nog of word je hiervoor behandeld?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.mental_health_history
    )
      ? answers.mental_health_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current_or_treatment',
      label:
        'Ja, ik heb op dit moment klachten en/of word hiervoor behandeld'
    },
    {
      value: 'past_only',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'additional_health_information',
  section: 'health',
  type: 'textarea',
  title:
    'Is er nog iets over je gezondheid dat belangrijk kan zijn voor de beoordeling van je aanvraag?',
  help:
    'Denk aan klachten, onderzoeken, behandelingen of andere medische informatie die nog niet aan bod is gekomen.',
  label: 'Aanvullende informatie',
  placeholder: 'Vul hier eventueel een toelichting in',
  required: false
},
{
  id: 'treatment_goal',
  section: 'treatment',
  type: 'radio',
  title: 'Waar ben je op dit moment vooral naar op zoek?',
  options: [
    {
      value: 'start_treatment',
      label: 'Ik wil starten met een behandeling'
    },
    {
      value: 'need_guidance',
      label:
        'Ik wil weten wat een passende vervolgstap is binnen mijn huidige behandeling'
    },
    {
      value: 'switch_treatment',
      label: 'Ik wil een andere behandeling overwegen'
    }
  ]
},
{
  id: 'current_or_previous_treatment',
  section: 'treatment',
  type: 'radio',
  title:
    'Welke behandeling voor gewichtsverlies gebruik je op dit moment?',
  condition: () =>
    [
      'switch_treatment',
      'need_guidance'
    ].includes(answers.treatment_goal),
  options: [
    {
      value: 'wegovy',
      label: 'Wegovy®'
    },
    {
      value: 'mounjaro',
      label: 'Mounjaro®'
    },
    {
      value: 'ozempic',
      label: 'Ozempic®'
    },
    {
      value: 'saxenda',
      label: 'Saxenda®'
    },
    {
      value: 'mysimba',
      label: 'Mysimba®'
    },
    {
      value: 'rybelsus',
      label: 'Rybelsus®'
    },
    {
      value: 'other',
      label: 'Anders, namelijk'
    }
  ]
},
{
  id: 'wegovy_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Wegovy® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'wegovy',
  options: [
    {
      value: '0_25_mg',
      label: '0,25 mg'
    },
    {
      value: '0_5_mg',
      label: '0,5 mg'
    },
    {
      value: '1_0_mg',
      label: '1,0 mg'
    },
    {
      value: '1_7_mg',
      label: '1,7 mg'
    },
    {
      value: '2_4_mg',
      label: '2,4 mg'
    }
  ]
},
{
  id: 'mounjaro_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Mounjaro® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'mounjaro',
  options: [
    {
      value: '2_5_mg',
      label: '2,5 mg'
    },
    {
      value: '5_mg',
      label: '5 mg'
    },
    {
      value: '7_5_mg',
      label: '7,5 mg'
    },
    {
      value: '10_mg',
      label: '10 mg'
    },
    {
      value: '12_5_mg',
      label: '12,5 mg'
    },
    {
      value: '15_mg',
      label: '15 mg'
    }
  ]
},
{
  id: 'ozempic_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Ozempic® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'ozempic',
  options: [
    {
      value: '0_25_mg',
      label: '0,25 mg'
    },
    {
      value: '0_5_mg',
      label: '0,5 mg'
    },
    {
      value: '1_0_mg',
      label: '1,0 mg'
    },
    {
      value: '2_0_mg',
      label: '2,0 mg'
    }
  ]
},
{
  id: 'rybelsus_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Rybelsus® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'rybelsus',
  options: [
    {
      value: '1_5_mg',
      label: '1,5 mg'
    },
    {
      value: '4_mg',
      label: '4 mg'
    },
    {
      value: '9_mg',
      label: '9 mg'
    }
  ]
},
{
  id: 'continuation_treatment_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: () => getContinuationTreatmentKey(),
  condition: () =>
    answers.treatment_goal === 'need_guidance' &&
    Boolean(getContinuationTreatmentKey())
},
{
  id: 'preferred_treatment_form',
  section: 'treatment',
  type: 'radio',
  title:
    'Heb je op dit moment een voorkeur voor een prikpen of tabletten?',
  condition: () =>
    answers.treatment_goal === 'start_treatment' ||
    answers.treatment_goal === 'switch_treatment',
  options: [
    {
      value: 'injection_pen',
      label: 'Ik heb een voorkeur voor een prikpen'
    },
    {
      value: 'tablets',
      label: 'Ik heb een voorkeur voor tabletten'
    }
  ]
},
{
  id: 'tablet_treatment_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Geef aan waar je voorkeur naar uit gaat:',
  help:
    'Op dit moment kunnen we twee behandelopties aanbieden: Mysimba® en Rybelsus®. Deze behandelingen bevatten verschillende werkzame stoffen en verschillen in toepassing. Mysimba® is specifiek bedoeld voor gewichtsbeheersing. Rybelsus® is bedoeld voor volwassenen met type 2 diabetes en wordt in sommige situaties off label gebruikt voor gewichtsverlies.',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        )
      )
    ),
  options: [
    {
      value: 'mysimba',
      label: addLowestPriceToLabel(
        'Mysimba® lijkt het beste bij mijn situatie te passen',
        root.dataset.mysimbaLowestPrice
      )
    },
    {
      value: 'rybelsus',
      label: addLowestPriceToLabel(
        'Rybelsus® (off label) lijkt het beste bij mijn situatie te passen',
        root.dataset.rybelsusLowestPrice
      )
    }
  ]
},
{
  id: 'mysimba_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'mysimba',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      (
        answers.treatment_goal === 'start_treatment' &&
        answers.tablet_treatment_preference === 'mysimba'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        answers.current_or_previous_treatment === 'rybelsus'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        ) &&
        answers.tablet_treatment_preference === 'mysimba'
      )
    )
},
{
  id: 'rybelsus_1_5_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'rybelsus_1_5',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      (
        answers.treatment_goal === 'start_treatment' &&
        answers.tablet_treatment_preference === 'rybelsus'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        answers.current_or_previous_treatment === 'mysimba'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        ) &&
        answers.tablet_treatment_preference === 'rybelsus'
      )
    )
},
{
  id: 'injection_frequency_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Wat heeft op dit moment jouw voorkeur?',
  help:
    'De ene behandeling gebruik je dagelijks, de andere wekelijks. Met je antwoord kunnen we beter inschatten welke optie het beste bij jouw situatie past.',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen',
  options: [
    {
      value: 'daily',
      label: 'Dagelijks gebruiken past beter bij mij'
    },
    {
      value: 'weekly',
      label: 'Wekelijks gebruiken past beter bij mij'
    }
  ]
},
{
  id: 'saxenda_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'saxenda',
  condition: () =>
    answers.treatment_goal === 'start_treatment' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'daily'
},
{
  id: 'switch_saxenda_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'saxenda',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'daily'
},
{
  id: 'weekly_injection_price_preference',
  section: 'treatment',
  type: 'radio',
  title:
    'Speelt de maandelijkse prijs van een behandeling voor jou een belangrijke rol?',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly',
  options: [
    {
      value: 'faster_result_higher_cost',
      label:
        'Ik wil graag sneller resultaat en sta open voor hogere maandelijkse kosten'
    },
    {
      value: 'lower_cost_slower_pace',
      label:
        'Ik vind lagere maandelijkse kosten belangrijk en kies liever voor een rustiger tempo'
    }
  ]
},
{
  id: 'weekly_lower_cost_treatment_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Geef aan waar je voorkeur naar uit gaat:',
  help:
    'Op dit moment kunnen we twee behandelopties aanbieden, namelijk Wegovy® en Ozempic®. Beide bevatten dezelfde werkzame stof, maar verschillen in toepassing. Wegovy® is specifiek bedoeld voor gewichtsverlies. Ozempic® is in principe bedoeld voor volwassenen met type 2 diabetes en wordt in sommige situaties off-label gebruikt voor gewichtsverlies. De prijzen van beide behandelingen zijn nagenoeg gelijk.',
  condition: () =>
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ),
  options: [
    {
      value: 'wegovy',
      label: addLowestPriceToLabel(
        'Wegovy® lijkt het beste bij mijn situatie te passen',
        root.dataset.wegovyLowestPrice
      )
    },
    {
      value: 'ozempic',
      label: addLowestPriceToLabel(
        'Ozempic® lijkt het beste bij mijn situatie te passen',
        root.dataset.ozempicLowestPrice
      )
    }
  ]
},
{
  id: 'mounjaro_2_5_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'mounjaro_2_5',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'faster_result_higher_cost'
},
{
  id: 'wegovy_0_25_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_25',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    answers.weekly_lower_cost_treatment_preference ===
      'wegovy'
},
{
  id: 'ozempic_0_25_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_25',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    answers.weekly_lower_cost_treatment_preference ===
      'ozempic'
},
{
  id: 'switch_wegovy_0_25_to_ozempic_0_25',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_25',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '0_25_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_0_5_to_ozempic_0_5',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_5',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '0_5_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_1_to_ozempic_1',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_1',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '1_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_high_dose_to_ozempic_2',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_2',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    ['1_7_mg', '2_4_mg'].includes(
      answers.wegovy_current_dosage
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_0_25_to_wegovy_0_25',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_25',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '0_25_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_0_5_to_wegovy_0_5',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_5',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '0_5_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_1_to_wegovy_1',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_1',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '1_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_2_to_wegovy_1_7',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_1_7',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '2_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'lsp_consent',
  section: 'treatment',
  condition: () =>
    Boolean(selectedTreatment) &&
    isNetherlands,
  type: 'radio',
  title:
    'Geef je toestemming voor het delen van je medische gegevens via het Landelijk Schakelpunt?',
  help:
    'Het LSP (Landelijk Schakelpunt) is een beveiligd netwerk waarmee je arts en apotheek relevante medische gegevens kunnen uitwisselen. Met jouw toestemming kunnen zij je belangrijkste medische gegevens en medicatieoverzicht raadplegen. Dit helpt om te controleren of de behandeling veilig bij jouw situatie past. Let op: geef je geen toestemming, dan kan de apotheek je behandeling mogelijk niet uitleveren of kan er vertraging ontstaan.',
  defaultValue: 'yes',
    options: [
    {
      value: 'yes',
      label: 'Ja, ik geef toestemming'
    },
    {
      value: 'no',
      label: 'Nee, ik geef geen toestemming'
    }
  ]
},
{
  id: 'bsn',
  section: 'treatment',
  condition: () =>
    Boolean(selectedTreatment) &&
    isNetherlands,
  type: 'bsn',
  title: 'Wat is je burgerservicenummer (BSN)?',
  help:
    'Je BSN bestaat uit 9 cijfers. Je vindt het onder andere op je paspoort, identiteitskaart of rijbewijs.'
},
{
  id: 'final_declarations',
  section: 'treatment',
  condition: () => Boolean(selectedTreatment),
  type: 'checkbox',
  title: 'Bevestig de volgende verklaringen',
  help:
    'Vink alle verklaringen aan om verder te gaan.',
  requireAll: true,
  options: [
    {
      value: 'truthful_and_complete',
      label:
        'Ik verklaar dat ik alle vragen naar waarheid en zo volledig mogelijk heb beantwoord.'
    },
    {
      value: 'doctor_review',
      label:
        'Ik begrijp dat een arts mijn aanvraag beoordeelt en dat deze beoordeling niet automatisch betekent dat een behandeling wordt voorgeschreven.'
    },
        {
      value: 'personal_use',
      label:
        'Ik verklaar dat deze aanvraag uitsluitend voor mijzelf is en dat een eventueel voorgeschreven behandeling alleen door mij wordt gebruikt.'
    },
    {
      value: 'terms_and_privacy',
      label:
        'Ik ga akkoord met de Kearty algemene voorwaarden en het privacy statement.',
      labelHtml:
        `Ik ga akkoord met de <a class="kq__answer-link" href="${escapeHtml(termsUrl)}" target="_blank" rel="noopener noreferrer">Kearty algemene voorwaarden</a> en het <a class="kq__answer-link" href="${escapeHtml(privacyUrl)}" target="_blank" rel="noopener noreferrer">privacy statement</a>.`
    }
  ]
},
];

      const previousMedicationLabels = {
        wegovy: 'Wegovy®',
        mounjaro: 'Mounjaro®',
        ozempic: 'Ozempic®',
        saxenda: 'Saxenda®',
        mysimba: 'Mysimba®',
        rybelsus: 'Rybelsus®'
      };

      const previousMedicationDosages = {
        wegovy: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '1_7_mg', label: '1,7 mg' },
          { value: '2_4_mg', label: '2,4 mg' }
        ],
        mounjaro: [
          { value: '2_5_mg', label: '2,5 mg' },
          { value: '5_mg', label: '5 mg' },
          { value: '7_5_mg', label: '7,5 mg' },
          { value: '10_mg', label: '10 mg' },
          { value: '12_5_mg', label: '12,5 mg' },
          { value: '15_mg', label: '15 mg' }
        ],
        ozempic: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '2_0_mg', label: '2 mg' }
        ],
        rybelsus: [
          { value: '1_5_mg', label: '1,5 mg' },
          { value: '4_mg', label: '4 mg' },
          { value: '9_mg', label: '9 mg' }
        ]
      };

      const medicationMonthOptions = [
        { value: '1', label: 'Januari' },
        { value: '2', label: 'Februari' },
        { value: '3', label: 'Maart' },
        { value: '4', label: 'April' },
        { value: '5', label: 'Mei' },
        { value: '6', label: 'Juni' },
        { value: '7', label: 'Juli' },
        { value: '8', label: 'Augustus' },
        { value: '9', label: 'September' },
        { value: '10', label: 'Oktober' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
      ];

      const getVisibleQuestions = () =>
        questions.filter(
          (question) =>
            typeof question.condition !== 'function' || question.condition()
        );

      const getQuestion = (questionId) =>
        questions.find((question) => question.id === questionId);

      const getFirstFinalQuestionId = () =>
        isNetherlands
          ? 'lsp_consent'
          : 'final_declarations';

      const setActiveSection = (sectionKey) => {
        const sectionOrder = ['about', 'health', 'treatment'];
        const activeIndex = sectionOrder.indexOf(sectionKey);

        root.querySelectorAll('[data-kq-progress-step]').forEach((step) => {
          const stepIndex = sectionOrder.indexOf(
            step.getAttribute('data-kq-progress-step')
          );

          step.classList.toggle('is-active', stepIndex === activeIndex);
          step.classList.toggle('is-complete', stepIndex < activeIndex);

          if (stepIndex === activeIndex) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });

        const progressFill = root.querySelector('[data-kq-progress-fill]');

        if (progressFill) {
          progressFill.style.width =
            activeIndex === 0 ? '0%' : activeIndex === 1 ? '50%' : '100%';
        }
      };

      const renderError = (message) => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = message;
        errorElement.hidden = false;
      };

      const clearError = () => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = '';
        errorElement.hidden = true;

        questionRegion
          .querySelectorAll('.has-error')
          .forEach((field) => field.classList.remove('has-error'));
      };

      const updateSelectedRows = () => {
        questionRegion
          .querySelectorAll('.kq__answer-row')
          .forEach((row) => {
            const input = row.querySelector('input');
            row.classList.toggle('is-selected', Boolean(input?.checked));
          });
      };

      const calculateAge = (day, month, year) => {
        const today = new Date();
        let age = today.getFullYear() - year;

        const birthdayPassed =
          today.getMonth() + 1 > month ||
          (today.getMonth() + 1 === month && today.getDate() >= day);

        if (!birthdayPassed) age -= 1;

        return age;
      };

      const isValidDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);

        return (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        );
      };

      const isPastDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return date < today;
      };

      const padDatePart = (value) =>
        String(value).padStart(2, '0');

      const formatDateOfBirth = (day, month, year) =>
        `${padDatePart(day)}-${padDatePart(month)}-${year}`;

      const parseDateOfBirth = (value) => {
        const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(
          String(value || '')
        );

        if (!match) return null;

        return {
          day: Number.parseInt(match[1], 10),
          month: Number.parseInt(match[2], 10),
          year: Number.parseInt(match[3], 10)
        };
      };

      const isValidBsn = (value) => {
        const bsn = String(value || '').replace(/\D/g, '');

        if (!/^\d{9}$/.test(bsn)) {
          return false;
        }

        if (bsn === '000000000') {
          return false;
        }

        const digits = bsn.split('').map(Number);

        const sum =
          digits[0] * 9 +
          digits[1] * 8 +
          digits[2] * 7 +
          digits[3] * 6 +
          digits[4] * 5 +
          digits[5] * 4 +
          digits[6] * 3 +
          digits[7] * 2 -
          digits[8];

        return sum % 11 === 0;
      };

      const renderDateQuestion = (question) => {
        const saved = parseDateOfBirth(answers[question.id]) || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__field-group">
            <div class="kq__date-grid">
              <label>
                <span class="kq__field-label">Dag</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-day"
                  maxlength="2"
                  placeholder="DD"
                  value="${escapeHtml(saved.day || '')}"
                  data-kq-date-day
                >
              </label>

              <label>
                <span class="kq__field-label">Maand</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-month"
                  maxlength="2"
                  placeholder="MM"
                  value="${escapeHtml(saved.month || '')}"
                  data-kq-date-month
                >
              </label>

              <label class="kq__date-year">
                <span class="kq__field-label">Jaar</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-year"
                  maxlength="4"
                  placeholder="JJJJ"
                  value="${escapeHtml(saved.year || '')}"
                  data-kq-date-year
                >
              </label>
            </div>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderRadioQuestion = (question) => {
        const selectedValue =
  answers[question.id] ?? question.defaultValue ?? '';

  const options = question.options
    .map(
      (option) => `
        <label class="kq__answer-row ${
          selectedValue === option.value
            ? 'is-selected'
            : ''
        }">
          <input
            type="radio"
            name="kq-${question.id}"
            value="${escapeHtml(option.value)}"
            ${selectedValue === option.value ? 'checked' : ''}
          >

          <span class="kq__answer-label">
            ${escapeHtml(option.label)}
          </span>
        </label>
      `
    )
    .join('');

  const hasOtherOption = question.options.some(
    (option) => option.value === 'other'
  );

  const otherValue =
    answers[`${question.id}_other`] || '';

  const otherVisible =
    selectedValue === 'other';

  const otherFieldHtml = hasOtherOption
    ? `
      <div
        class="kq__other-field ${
          otherVisible ? 'is-visible' : ''
        }"
        data-kq-other-field
      >
        <label>
          <span class="kq__field-label">
            Welke behandeling heb je gebruikt?
          </span>

          <input
            class="kq__field"
            type="text"
            value="${escapeHtml(otherValue)}"
            placeholder="Vul de naam van de behandeling in"
            data-kq-other-input
          >
        </label>
      </div>
    `
    : '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `
          <p class="kq__question-help">
            ${escapeHtml(question.help)}
          </p>
        `
        : ''
    }

    <div class="kq__answer-list">
      ${options}
    </div>

    ${otherFieldHtml}

    <p
      class="kq__error"
      data-kq-error
      hidden
    ></p>
  `;
};

      const renderCheckboxQuestion = (question) => {
        const selectedValues = Array.isArray(answers[question.id])
          ? answers[question.id]
          : [];

        const options = question.options
          .map(
            (option) => `
              <label class="kq__answer-row ${
                selectedValues.includes(option.value) ? 'is-selected' : ''
              }">
                <input
                  type="checkbox"
                  name="kq-${question.id}"
                  value="${escapeHtml(option.value)}"
                  ${
                    selectedValues.includes(option.value)
                      ? 'checked'
                      : ''
                  }
                >
                <span class="kq__answer-label">
                  ${
                    option.labelHtml
                      ? option.labelHtml
                      : escapeHtml(option.label)
                  }
                </span>
              </label>
            `
          )
          .join('');

        const otherValue = answers[`${question.id}_other`] || '';
        const otherVisible = selectedValues.includes('other');

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

          ${
            question.help
              ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
              : ''
          }

          <div class="kq__answer-list">
            ${options}
          </div>

          <div class="kq__other-field ${
            otherVisible ? 'is-visible' : ''
          }" data-kq-other-field>
            <label>
              <span class="kq__field-label">Anders, namelijk</span>
              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(otherValue)}"
                data-kq-other-input
              >
            </label>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };
const renderMedicationHistoryQuestion = (question) => {
  const selectedMedications = Array.isArray(
    answers.previous_weight_loss_medications
  )
    ? answers.previous_weight_loss_medications
    : [];

  const savedHistory = Array.isArray(answers[question.id])
    ? answers[question.id]
    : [];

  const monthOptionsHtml = (selectedValue = '') =>
    `
      <option value="">Kies maand</option>
      ${medicationMonthOptions
        .map(
          (month) => `
            <option
              value="${escapeHtml(month.value)}"
              ${String(selectedValue) === month.value ? 'selected' : ''}
            >
              ${escapeHtml(month.label)}
            </option>
          `
        )
        .join('')}
    `;

  const cards = selectedMedications
    .map((medicationKey) => {
      const saved =
        savedHistory.find(
          (item) => item.treatment === medicationKey
        ) || {};

      const medicationName =
        medicationKey === 'other'
          ? answers.previous_weight_loss_medications_other?.trim() ||
            'Andere medicatie'
          : previousMedicationLabels[medicationKey] || medicationKey;

      const dosageOptions =
        previousMedicationDosages[medicationKey] || null;

      const dosageNotApplicable =
        ['saxenda', 'mysimba'].includes(medicationKey);

      const dosageField = dosageNotApplicable
        ? ''
        : dosageOptions
          ? `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <select
                class="kq__field"
                data-kq-medication-dosage
              >
                <option value="">Kies dosering</option>
                ${dosageOptions
                  .map(
                    (option) => `
                      <option
                        value="${escapeHtml(option.value)}"
                        ${saved.last_dosage === option.value ? 'selected' : ''}
                      >
                        ${escapeHtml(option.label)}
                      </option>
                    `
                  )
                  .join('')}
              </select>
            </label>
          `
          : `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(saved.last_dosage || '')}"
                placeholder="Vul de dosering in"
                data-kq-medication-dosage
              >
            </label>
          `;

      const usageStatus = saved.still_using
        ? 'still_using'
        : saved.usage_status || '';

      return `
        <div
          class="kq__medication-card"
          data-kq-medication-card
          data-medication-key="${escapeHtml(medicationKey)}"
          data-medication-name="${escapeHtml(medicationName)}"
        >
          <h2 class="kq__medication-card-title">
            ${escapeHtml(medicationName)}
          </h2>

          <div class="kq__medication-fields">
            ${dosageField}

            <div>
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestart?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-start-month
                  >
                    ${monthOptionsHtml(saved.started_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.started_year || '')}"
                    data-kq-medication-start-year
                  >
                </label>
              </div>

              <p class="kq__medication-help">
                Een schatting van de maand is voldoende.
              </p>
            </div>

            <label class="kq__medication-status">
              <span class="kq__field-label">
                Gebruik je deze behandeling op dit moment nog?
              </span>

              <select
                class="kq__field"
                data-kq-medication-status
              >
                <option value="">Maak een keuze</option>
                <option
                  value="still_using"
                  ${usageStatus === 'still_using' ? 'selected' : ''}
                >
                  Ja, ik gebruik deze behandeling nog
                </option>
                <option
                  value="stopped"
                  ${usageStatus === 'stopped' ? 'selected' : ''}
                >
                  Nee, ik ben hiermee gestopt
                </option>
              </select>
            </label>

            <div
              class="kq__medication-end-date"
              data-kq-medication-end-date
              ${usageStatus === 'stopped' ? '' : 'hidden'}
            >
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestopt?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-end-month
                  >
                    ${monthOptionsHtml(saved.ended_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.ended_year || '')}"
                    data-kq-medication-end-year
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join('');

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__medication-history">
      ${cards}
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const saveMedicationHistoryDraft = (question) => {
  if (question.type !== 'medication_history') return;

  const historyItems = Array.from(
    questionRegion.querySelectorAll('[data-kq-medication-card]')
  ).map((card) => {
    const usageStatus =
      card.querySelector('[data-kq-medication-status]')?.value || '';

    const dosageField = card.querySelector(
      '[data-kq-medication-dosage]'
    );

    const item = {
      treatment: card.dataset.medicationKey || '',
      started_month:
        card.querySelector('[data-kq-medication-start-month]')?.value || '',
      started_year:
        card.querySelector('[data-kq-medication-start-year]')?.value.trim() || '',
      usage_status: usageStatus,
      still_using: usageStatus === 'still_using',
      ended_month:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-month]')?.value || ''
          : '',
      ended_year:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-year]')?.value.trim() || ''
          : ''
    };

    if (dosageField) {
      item.last_dosage = dosageField.value.trim();
    }

    return item;
  });

  answers[question.id] = historyItems;
};

const renderBsnQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group kq__bsn-field">
      <label>
        <span class="kq__field-label">
          Burgerservicenummer
        </span>

        <input
          class="kq__field"
          type="text"
          inputmode="numeric"
          maxlength="9"
          autocomplete="off"
          placeholder="123456789"
          value="${escapeHtml(savedValue)}"
          data-kq-bsn
        >
      </label>
    </div>

    <div class="kq__bsn-info">
      <span
        class="kq__bsn-info-icon"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          fill="none"
        >
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M12 10.5v6"></path>
          <circle
            cx="12"
            cy="7.5"
            r=".8"
            fill="currentColor"
            stroke="none"
          ></circle>
        </svg>
      </span>

      <div>
        <p class="kq__bsn-info-title">
          Waarom vragen we je BSN?
        </p>

        <p class="kq__bsn-info-text">
          Voor de uitvoering van medische zorg zijn de arts en apotheek wettelijk verplicht je BSN te gebruiken. Met je BSN kunnen zij controleren dat je aanvraag, medische gegevens en eventuele recept bij de juiste persoon horen.
          <br><br>
          Voor jouw veiligheid en om zorgvuldig met je gegevens om te gaan, slaat Kearty je BSN niet zelf op. Het nummer wordt alleen veilig doorgegeven aan de betrokken zorgverleners binnen jouw behandeling.
        </p>
      </div>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const renderTextareaQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group">
      <label>
        ${
          question.label
            ? `<span class="kq__field-label">${escapeHtml(question.label)}</span>`
            : ''
        }

        <textarea
          class="kq__field kq__textarea"
          rows="6"
          placeholder="${escapeHtml(question.placeholder || '')}"
          data-kq-textarea
        >${escapeHtml(savedValue)}</textarea>
      </label>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};
const treatmentProfiles = {
  saxenda: {
    summaryTitle: 'Saxenda® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Liraglutide'
      },
      {
        label: 'Toediening',
        value: 'Dagelijks als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gemiddeld gewichtsverlies',
        value:
          'In studies verloren mensen gemiddeld ongeveer 7,5% van hun lichaamsgewicht in 56 weken, in combinatie met voeding en beweging'
      },
      {
        label: 'Gebruik',
        value: 'In combinatie met voeding en beweging'
      },
      {
        label: 'Werking',
        value:
          'Werkt als GLP-1-receptoragonist en helpt de eetlust te verminderen en het verzadigingsgevoel te vergroten'
      },
      {
        label: 'Veelvoorkomende bijwerkingen',
        value: 'Misselijkheid, braken, diarree en verstopping'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Saxenda®'
  },

  mounjaro: {
    summaryTitle: 'Mounjaro® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Tirzepatide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gebruik',
        value:
          'In combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Mounjaro®'
  },

  wegovy: {
    summaryTitle: 'Wegovy® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Semaglutide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gebruik',
        value:
          'In combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Wegovy®'
  },

  ozempic: {
    summaryTitle: 'Ozempic® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Semaglutide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Geregistreerde toepassing',
        value:
          'Voor de behandeling van volwassenen met onvoldoende gereguleerde type 2-diabetes'
      },
      {
        label: 'Gebruik bij gewichtsverlies',
        value:
          'Bij gebruik voor gewichtsverlies wordt Ozempic® off-label voorgeschreven'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Ozempic®'
  },
  mysimba: {
  summaryTitle: 'Mysimba® in het kort',
  facts: [
    {
      label: 'Werkzame stoffen',
      value: 'Naltrexon en bupropion'
    },
    {
      label: 'Toediening',
      value: 'Tabletten met verlengde afgifte voor oraal gebruik'
    },
    {
      label: 'Toepassing',
      value:
        'Voor gewichtsbeheersing in combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
    },
    {
      label: 'Verkrijgbaarheid',
      value: 'Alleen op recept'
    }
  ],
  source:
    'Bron: European Medicines Agency, productinformatie Mysimba®'
},

rybelsus: {
  summaryTitle: 'Rybelsus® in het kort',
  facts: [
    {
      label: 'Werkzame stof',
      value: 'Semaglutide'
    },
    {
      label: 'Toediening',
      value: 'Eén keer per dag als tablet'
    },
    {
      label: 'Geregistreerde toepassing',
      value:
        'Voor de behandeling van volwassenen met onvoldoende gereguleerde type 2-diabetes'
    },
    {
      label: 'Gebruik bij gewichtsverlies',
      value:
        'Gebruik voor gewichtsverlies valt buiten de geregistreerde toepassing'
    },
    {
      label: 'Verkrijgbaarheid',
      value: 'Alleen op recept'
    }
  ],
  source:
    'Bron: European Medicines Agency, productinformatie Rybelsus®'
}
};

const treatmentRecommendations = {
  saxenda: {
    profile: 'saxenda',
    shopifyKey: 'saxenda',
    displayName: 'Saxenda®',
    dosage: '',
    subtitle: 'Dagelijkse injectie',
    quantity: '5 prikpennen'
  },

  mounjaro_2_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro25',
    displayName: 'Mounjaro®',
    dosage: '2,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro5',
    displayName: 'Mounjaro®',
    dosage: '5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_7_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro75',
    displayName: 'Mounjaro®',
    dosage: '7,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_10: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro10',
    displayName: 'Mounjaro®',
    dosage: '10 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_12_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro125',
    displayName: 'Mounjaro®',
    dosage: '12,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_15: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro15',
    displayName: 'Mounjaro®',
    dosage: '15 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  wegovy_0_25: {
    profile: 'wegovy',
    shopifyKey: 'wegovy025',
    displayName: 'Wegovy®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  wegovy_0_5: {
  profile: 'wegovy',
  shopifyKey: 'wegovy05',
  displayName: 'Wegovy®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1: {
  profile: 'wegovy',
  shopifyKey: 'wegovy1',
  displayName: 'Wegovy®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1_7: {
  profile: 'wegovy',
  shopifyKey: 'wegovy17',
  displayName: 'Wegovy®',
  dosage: '1,7 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_2_4: {
  profile: 'wegovy',
  shopifyKey: 'wegovy24',
  displayName: 'Wegovy®',
  dosage: '2,4 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

  ozempic_0_25: {
    profile: 'ozempic',
    shopifyKey: 'ozempic025',
    displayName: 'Ozempic®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  ozempic_0_5: {
  profile: 'ozempic',
  shopifyKey: 'ozempic05',
  displayName: 'Ozempic®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_1: {
  profile: 'ozempic',
  shopifyKey: 'ozempic1',
  displayName: 'Ozempic®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_2: {
  profile: 'ozempic',
  shopifyKey: 'ozempic2',
  displayName: 'Ozempic®',
  dosage: '2 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},
  mysimba: {
  profile: 'mysimba',
  shopifyKey: 'mysimba',
  displayName: 'Mysimba®',
  dosage: '',
  subtitle: 'Behandeling met tabletten',
  quantity: '112 tabletten'
},

rybelsus_1_5: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus15',
  displayName: 'Rybelsus®',
  dosage: '1,5 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_4: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus4',
  displayName: 'Rybelsus®',
  dosage: '4 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_9: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus9',
  displayName: 'Rybelsus®',
  dosage: '9 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
}
};

const getTreatmentDatasetValue = (shopifyKey, field) => {
  const datasetKey =
    shopifyKey +
    field.charAt(0).toUpperCase() +
    field.slice(1);

  return root.dataset[datasetKey] || '';
};

const renderTreatmentRecommendation = (question) => {
  const treatmentKey =
    typeof question.treatment === 'function'
      ? question.treatment()
      : question.treatment;

  const treatmentConfig =
    treatmentRecommendations[treatmentKey];

  if (!treatmentConfig) {
    return `
      <p class="kq__error">
        Deze behandelaanbeveling kon niet worden geladen.
      </p>
    `;
  }

  const treatmentProfile =
    treatmentProfiles[treatmentConfig.profile];

  if (!treatmentProfile) {
    return `
      <p class="kq__error">
        De informatie over deze behandeling kon niet worden geladen.
      </p>
    `;
  }

  const shopifyKey = treatmentConfig.shopifyKey;

  const shopifyProductTitle =
    getTreatmentDatasetValue(shopifyKey, 'title');

  const productPrice =
    getTreatmentDatasetValue(shopifyKey, 'price');

  const productImage =
    getTreatmentDatasetValue(shopifyKey, 'image');

  const productInfoUrl =
    getTreatmentDatasetValue(shopifyKey, 'infoUrl');

  const variantId =
    getTreatmentDatasetValue(shopifyKey, 'variantId');

  const isAvailable =
    getTreatmentDatasetValue(shopifyKey, 'available') === 'true';

  const recommendationName = [
    treatmentConfig.displayName,
    treatmentConfig.dosage
  ]
    .filter(Boolean)
    .join(' ');

  const isContinuationRecommendation =
    answers.treatment_goal === 'need_guidance';

  const recommendationTitle =
    isContinuationRecommendation
      ? 'Jouw passende vervolgstap'
      : 'Jouw behandeladvies';

  const recommendationIntro =
    isContinuationRecommendation
      ? 'Op basis van je antwoorden lijkt onderstaande dosering een passende vervolgstap binnen je huidige behandeling. De uiteindelijke medische beoordeling en verantwoordelijkheid liggen altijd bij de arts.'
      : 'Op basis van je antwoorden lijkt onderstaande behandeling het beste aan te sluiten bij jouw situatie. De uiteindelijke medische beoordeling en verantwoordelijkheid liggen altijd bij de arts.';

  const recommendationNoticeText =
    isContinuationRecommendation
      ? 'De voorgestelde vervolgstap binnen je huidige behandeling is:'
      : 'Het advies is om je behandeling voor gewichtsverlies te starten met de volgende behandeling:';

  const recommendationBadge =
    isContinuationRecommendation
      ? 'Voorgestelde vervolgstap'
      : 'Geadviseerde behandeling';

  const productTitle =
    treatmentConfig.dosage
      ? recommendationName
      : shopifyProductTitle || treatmentConfig.displayName;

  const canApply =
    Boolean(variantId) && isAvailable;

  const applyButtonLabel = canApply
    ? 'Behandeling aanvragen'
    : 'Tijdelijk niet beschikbaar';

  const applyButtonDisabled = canApply
    ? ''
    : 'disabled';

  const imageHtml = productImage
    ? `
      <img
        src="${escapeHtml(productImage)}"
        alt="${escapeHtml(productTitle)}"
        loading="lazy"
      >
    `
    : '';

  const factsHtml = treatmentProfile.facts
    .map(
      (fact) => `
        <div class="kq__treatment-fact">
          <dt>${escapeHtml(fact.label)}</dt>
          <dd>${escapeHtml(fact.value)}</dd>
        </div>
      `
    )
    .join('');

  return `
    <div class="kq__recommendation">
      <h1 class="kq__question-title">
        ${escapeHtml(recommendationTitle)}
      </h1>

      <p class="kq__recommendation-intro">
        ${escapeHtml(recommendationIntro)}
      </p>

      <div class="kq__recommendation-notice">
        <span
          class="kq__recommendation-check"
          aria-hidden="true"
        >
          ✓
        </span>

        <p>
          ${escapeHtml(recommendationNoticeText)}
          <strong>${escapeHtml(recommendationName)}</strong>
        </p>
      </div>

      <div class="kq__product-card">
        <div class="kq__product-image">
          ${imageHtml}
        </div>

        <div class="kq__product-content">
          <span class="kq__product-badge">
            ${escapeHtml(recommendationBadge)}
          </span>

          <h2 class="kq__product-title">
            ${escapeHtml(productTitle)}
          </h2>

          <p class="kq__product-subtitle">
            ${escapeHtml(treatmentConfig.subtitle)}
          </p>

          ${
            productPrice
              ? `
                <p class="kq__product-price">
                  ${escapeHtml(productPrice)}
                </p>
              `
              : ''
          }

         ${
  treatmentConfig.quantity
    ? `
      <p class="kq__product-quantity">
        ${escapeHtml(treatmentConfig.quantity)}
      </p>
    `
    : ''
}

          <button
            type="button"
            class="kq__product-cta"
            data-kq-treatment-select
            data-treatment="${escapeHtml(treatmentKey)}"
            data-variant-id="${escapeHtml(variantId)}"
            ${applyButtonDisabled}
          >
            ${escapeHtml(applyButtonLabel)}
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <div class="kq__treatment-summary">
        <h2 class="kq__treatment-summary-title">
          ${escapeHtml(treatmentProfile.summaryTitle)}
        </h2>

        <dl class="kq__treatment-facts">
          ${factsHtml}
        </dl>

        <p class="kq__treatment-source">
          ${escapeHtml(treatmentProfile.source)}
        </p>
      </div>

      <div class="kq__recommendation-actions">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-treatment-select
          data-treatment="${escapeHtml(treatmentKey)}"
          data-variant-id="${escapeHtml(variantId)}"
          ${applyButtonDisabled}
        >
          ${escapeHtml(applyButtonLabel)}
          <span aria-hidden="true">→</span>
        </button>

        ${
          productInfoUrl
            ? `
              <a
                href="${escapeHtml(productInfoUrl)}"
                class="kq__status-button kq__status-button--secondary"
              >
                Meer informatie
                <span aria-hidden="true">→</span>
              </a>
            `
            : ''
        }
      </div>

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>
    </div>
  `;
};
      const renderMeasurementsQuestion = (question) => {
      const saved = answers[question.id] || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__measurement-list">
            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Hoe lang ben je?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="numeric"
                min="120"
                max="230"
                step="1"
                value="${escapeHtml(saved.height || '')}"
                data-kq-height
              >
              <span class="kq__measurement-unit">cm</span>
            </label>

            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Wat is je huidige gewicht?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="decimal"
                min="35"
                max="350"
                step="0.1"
                value="${escapeHtml(saved.weight || '')}"
                data-kq-weight
              >
              <span class="kq__measurement-unit">kg</span>
            </label>
          </div>

          <div class="kq__bmi-result" data-kq-bmi-result>
            <p class="kq__bmi-value" data-kq-bmi-value></p>
            <p class="kq__bmi-description" data-kq-bmi-description></p>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderQuestion = () => {
  statusScreen = null;

  const question = getQuestion(currentQuestionId);

  if (!question) return;

  setActiveSection(question.section || 'about');

  if (question.type === 'date') {
    questionRegion.innerHTML = renderDateQuestion(question);
  }

  if (question.type === 'radio') {
    questionRegion.innerHTML = renderRadioQuestion(question);
  }

  if (question.type === 'checkbox') {
    questionRegion.innerHTML = renderCheckboxQuestion(question);
  }

  if (question.type === 'medication_history') {
    questionRegion.innerHTML =
      renderMedicationHistoryQuestion(question);
  }

  if (question.type === 'bsn') {
    questionRegion.innerHTML = renderBsnQuestion(question);
  }

  if (question.type === 'textarea') {
    questionRegion.innerHTML = renderTextareaQuestion(question);
  }

  if (question.type === 'treatment_recommendation') {
  questionRegion.innerHTML =
    renderTreatmentRecommendation(question);
  }

  if (question.type === 'measurements') {
    questionRegion.innerHTML = renderMeasurementsQuestion(question);
  }

  if (question.type !== 'treatment_recommendation') {
    shownQuestions.set(question.id, {
      id: question.id,
      type: question.type === 'bsn' ? 'textarea' : question.type,
      question: question.title,
      help: question.help ?? null,
      answers: question.options
        ? Object.fromEntries(
            question.options.map((option) => [option.value, option.label])
          )
        : null,
      ...(question.type === 'medication_history' ? { subquestions: [] } : {})
    });
  }

  backButton.hidden = history.length === 0;

if (question.type === 'treatment_recommendation') {
  nextButton.hidden = true;
} else {
  nextButton.hidden = false;
  nextButton.innerHTML =
    'Verder <span aria-hidden="true">→</span>';

  bindQuestionEvents(question);
}

  if (question.type === 'measurements') {
    updateBmiPreview();
  }
};

    const renderStatus = ({
  title,
  message,
  type = 'stop',
  nextQuestionId = null,
  nextSection = null,
  nextButtonLabel = null
}) => {
  statusScreen = {
    title,
    message,
    type,
    nextQuestionId,
    nextSection,
    nextButtonLabel
  };

  const isAboutComplete =
    type === 'complete' &&
    nextSection === 'health';

  const isHealthComplete =
    type === 'complete' &&
    nextSection === 'treatment';

  const isOtherTreatment =
    type === 'other_treatment';

  const isConsentIntro =
    type === 'consent_intro';

  const isCheckoutReady =
    type === 'checkout_ready';

  const stopActions =
    type === 'stop'
      ? `
        <div class="kq__status-actions">
          <a
            class="kq__status-button kq__status-button--secondary"
            href="${escapeHtml(homeUrl)}"
          >
            Naar de homepage
          </a>

          <a
            class="kq__status-button kq__status-button--primary"
            href="${escapeHtml(contactUrl)}"
          >
            Neem contact op
            <span aria-hidden="true">→</span>
          </a>
        </div>
      `
      : '';

  const aboutCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent al goed op weg!
          </p>

          <p class="kq__status-motivation-text">
            Samen zetten we de volgende stap naar de behandeling die bij jou past.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <path
                d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"
              ></path>
              <rect
                x="9"
                y="10.5"
                width="6"
                height="5"
                rx="1"
              ></rect>
              <path d="M10.5 10.5V9a1.5 1.5 0 0 1 3 0v1.5"></path>
            </svg>
          </span>

          <p>100% vertrouwelijk en veilig</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>

          <p>Slechts enkele minuten</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path
                d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"
              ></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>

          <p>Beoordeeld door een arts</p>
        </div>
      </div>
    </div>
  `;

  const healthCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete kq__status-card--health-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent bijna bij je behandeladvies
          </p>

          <p class="kq__status-motivation-text">
            Met je laatste antwoorden kunnen we beter inschatten welke behandeling of vervolgstap bij jouw situatie kan passen.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <path d="M4 7h10"></path>
              <path d="M18 7h2"></path>
              <circle cx="16" cy="7" r="2"></circle>
              <path d="M4 12h3"></path>
              <path d="M11 12h9"></path>
              <circle cx="9" cy="12" r="2"></circle>
              <path d="M4 17h8"></path>
              <path d="M16 17h4"></path>
              <circle cx="14" cy="17" r="2"></circle>
            </svg>
          </span>

          <p>Afgestemd op jouw situatie</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>

          <p>Nog enkele korte vragen</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path
                d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"
              ></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>

          <p>Altijd beoordeeld door een BIG geregistreerde arts</p>
        </div>
      </div>
    </div>
  `;
  
  const consentIntroText = isNetherlands
    ? 'Voordat je verdergaat naar betalen, vragen we nog om toestemming voor gegevensuitwisseling via het LSP, je BSN en een laatste bevestiging van je antwoorden. Nieuw bij Kearty? Dan rond je na de betaling eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.'
    : 'Voordat je verdergaat naar betalen, vragen we nog om een laatste bevestiging van je antwoorden. Nieuw bij Kearty? Dan rond je na de betaling eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.';

  const consentIntroContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"></path>
            <path d="m9 12 2 2 4-4"></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Bijna klaar
          </p>

          <p class="kq__status-motivation-text">
            ${escapeHtml(consentIntroText)}
          </p>
        </div>
      </div>
    </div>
  `;
  
  const selectedTreatmentConfig =
    treatmentRecommendations[selectedTreatment] || null;

  const selectedTreatmentName = selectedTreatmentConfig
    ? [
        selectedTreatmentConfig.displayName,
        selectedTreatmentConfig.dosage
      ]
        .filter(Boolean)
        .join(' ')
    : '';

  const checkoutReadyContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${
        selectedTreatmentName
          ? `
            <div class="kq__recommendation-notice" style="margin-top: 28px; text-align: left;">
              <span
                class="kq__recommendation-check"
                aria-hidden="true"
              >
                ✓
              </span>

              <p>
                Je vraagt aan: <strong>${escapeHtml(selectedTreatmentName)}</strong>
              </p>
            </div>
          `
          : ''
      }

      <div class="kq__status-actions kq__checkout-actions">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-final-checkout
          data-kq-treatment-apply
          data-treatment="${escapeHtml(selectedTreatment)}"
          data-variant-id="${escapeHtml(selectedVariantId)}"
        >
          Behandeling aanvragen
          <span aria-hidden="true">→</span>
        </button>

        <button
          type="button"
          class="kq__status-button kq__status-button--secondary kq__calendly-button"
          data-kq-calendly
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <rect x="4" y="5.5" width="16" height="14" rx="2"></rect>
            <path d="M8 3.5v4"></path>
            <path d="M16 3.5v4"></path>
            <path d="M4 9.5h16"></path>
          </svg>
          Adviesgesprek inplannen
        </button>
      </div>

      <p class="kq__calendly-copy">
        <strong>Liever eerst persoonlijk contact?</strong> Plan dan een gratis telefonisch gesprek van 10 minuten met Kearty. We leggen je graag uit hoe Kearty werkt, nemen je mee in het aanvraagproces en helpen je verder met je vragen.
      </p>

      <p
        class="kq__error kq__calendly-error"
        data-kq-calendly-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>
    </div>
  `;
  
  const otherTreatmentContent = `
  <div class="kq__status-card">
    <h1 class="kq__status-title">
      ${escapeHtml(title)}
    </h1>

    <p class="kq__status-message">
      ${escapeHtml(message)}
    </p>

    <div class="kq__status-actions">
      <button
        type="button"
        class="kq__status-button kq__status-button--primary"
        data-kq-switch-from-other
      >
        Ik wil een andere behandeling overwegen
        <span aria-hidden="true">→</span>
      </button>

      <a
        class="kq__status-button kq__status-button--secondary"
        href="${escapeHtml(contactUrl)}"
      >
        Neem contact op
      </a>
    </div>
  </div>
`;

  const defaultStatusContent = `
    <div class="kq__status-card">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${stopActions}
    </div>
  `;

  questionRegion.innerHTML =
  isAboutComplete
    ? aboutCompleteContent
    : isHealthComplete
      ? healthCompleteContent
      : isConsentIntro
        ? consentIntroContent
        : isCheckoutReady
          ? checkoutReadyContent
          : isOtherTreatment
            ? otherTreatmentContent
            : defaultStatusContent;

  if (isOtherTreatment) {
  setActiveSection('treatment');
}

  if (
    type === 'complete' ||
    type === 'consent_intro'
  ) {
    setActiveSection(nextSection || 'health');

    nextButton.hidden = false;
    nextButton.innerHTML = `
      ${escapeHtml(nextButtonLabel || 'Verder')}
      <span aria-hidden="true">→</span>
    `;
  } else {
    nextButton.hidden = true;
  }
};

      const updateBmiPreview = () => {
        const heightInput = questionRegion.querySelector('[data-kq-height]');
        const weightInput = questionRegion.querySelector('[data-kq-weight]');
        const result = questionRegion.querySelector('[data-kq-bmi-result]');
        const valueElement = questionRegion.querySelector(
          '[data-kq-bmi-value]'
        );
        const descriptionElement = questionRegion.querySelector(
          '[data-kq-bmi-description]'
        );

        if (
          !heightInput ||
          !weightInput ||
          !result ||
          !valueElement ||
          !descriptionElement
        ) {
          return;
        }

        const height = Number.parseFloat(heightInput.value);
        const weight = Number.parseFloat(weightInput.value);

        if (!height || !weight || height <= 0 || weight <= 0) {
          result.classList.remove('is-visible');
          return;
        }

        const bmi = weight / Math.pow(height / 100, 2);
        const roundedBmi = bmi.toFixed(1);

      valueElement.textContent = `Jouw BMI is ${roundedBmi}`;

result.classList.remove('is-stop');

let bmiCategory = '';

if (bmi < 19) {
  bmiCategory = 'ondergewicht';
} else if (bmi < 25) {
  bmiCategory = 'gezond gewicht';
} else if (bmi < 30) {
  bmiCategory = 'overgewicht';
} else if (bmi < 35) {
  bmiCategory = 'obesitas';
} else if (bmi < 40) {
  bmiCategory = 'ernstige obesitas';
} else {
  bmiCategory = 'zeer ernstige obesitas';
}

descriptionElement.textContent =
  `Je BMI valt in de categorie ${bmiCategory}.`;

if (bmi < 25) {
  result.classList.add('is-stop');
}

result.classList.add('is-visible');
      };

      const bindQuestionEvents = (question) => {
        clearError();

        if (question.type === 'medication_history') {
          questionRegion
            .querySelectorAll(
              '[data-kq-medication-dosage], [data-kq-medication-start-month], [data-kq-medication-start-year], [data-kq-medication-status], [data-kq-medication-end-month], [data-kq-medication-end-year]'
            )
            .forEach((field) => {
              const eventName =
                field.tagName === 'SELECT' ? 'change' : 'input';

              field.addEventListener(eventName, () => {
                if (
                  field.matches(
                    '[data-kq-medication-start-year], [data-kq-medication-end-year]'
                  )
                ) {
                  field.value = field.value
                    .replace(/\D/g, '')
                    .slice(0, 4);
                }

                if (field.matches('[data-kq-medication-status]')) {
                  const card = field.closest(
                    '[data-kq-medication-card]'
                  );
                  const endDate = card?.querySelector(
                    '[data-kq-medication-end-date]'
                  );

                  if (endDate) {
                    endDate.hidden = field.value !== 'stopped';
                  }

                  if (field.value !== 'stopped' && card) {
                    const endMonth = card.querySelector(
                      '[data-kq-medication-end-month]'
                    );
                    const endYear = card.querySelector(
                      '[data-kq-medication-end-year]'
                    );

                    if (endMonth) endMonth.value = '';
                    if (endYear) endYear.value = '';
                  }
                }

                field.classList.remove('has-error');
                saveMedicationHistoryDraft(question);
                clearError();
              });
            });
        }

        questionRegion
  .querySelectorAll('input[type="radio"]')
  .forEach((input) => {
    input.addEventListener('change', () => {
      answers[question.id] = input.value;

      const otherField = questionRegion.querySelector(
        '[data-kq-other-field]'
      );

      const otherInput = questionRegion.querySelector(
        '[data-kq-other-input]'
      );

      otherField?.classList.toggle(
        'is-visible',
        input.value === 'other'
      );

      if (input.value === 'other') {
        otherInput?.focus();
      }

      updateSelectedRows();
      clearError();
    });
  });

        questionRegion
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            input.addEventListener('change', () => {
              const selectedInputs = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              );

              if (
                input.checked &&
                question.exclusiveValues?.includes(input.value)
              ) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    otherInput.checked = otherInput === input;
                  });
              } else if (input.checked) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    if (
                      question.exclusiveValues?.includes(otherInput.value)
                    ) {
                      otherInput.checked = false;
                    }
                  });
              }

              answers[question.id] = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              ).map((checkedInput) => checkedInput.value);

              const otherField = questionRegion.querySelector(
                '[data-kq-other-field]'
              );

              otherField?.classList.toggle(
                'is-visible',
                answers[question.id].includes('other')
              );

              updateSelectedRows();
              clearError();
            });
          });

        const bsnInput = questionRegion.querySelector(
          '[data-kq-bsn]'
        );

        bsnInput?.addEventListener('input', () => {
          bsnInput.value = bsnInput.value
            .replace(/\D/g, '')
            .slice(0, 9);

          clearError();
        });

        const dateInputs = Array.from(
  questionRegion.querySelectorAll(
    '[data-kq-date-day], [data-kq-date-month], [data-kq-date-year]'
  )
);

dateInputs.forEach((input, index) => {
  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '');

    const maxLength = Number.parseInt(
      input.getAttribute('maxlength'),
      10
    );

    if (
      input.value.length === maxLength &&
      dateInputs[index + 1]
    ) {
      dateInputs[index + 1].focus();
    }

    clearError();
  });

  input.addEventListener('keydown', (event) => {
    if (
      event.key === 'Backspace' &&
      input.value === '' &&
      dateInputs[index - 1]
    ) {
      dateInputs[index - 1].focus();
    }
  });
});

        questionRegion
          .querySelectorAll('[data-kq-height], [data-kq-weight]')
          .forEach((input) => {
            input.addEventListener('input', () => {
              updateBmiPreview();
              clearError();
            });
          });

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          textarea?.addEventListener('input', () => {
            answers[question.id] = textarea.value;
            textarea.classList.remove('has-error');
            clearError();
          });
        }

        questionRegion
          .querySelector('[data-kq-other-input]')
          ?.addEventListener('input', (event) => {
            answers[`${question.id}_other`] = event.target.value;
            clearError();
          });
      };

      const validateCurrentQuestion = () => {
        clearError();

        const question = getQuestion(currentQuestionId);

        if (!question) return false;

        if (question.type === 'date') {
  const dayInput = questionRegion.querySelector('[data-kq-date-day]');
  const monthInput = questionRegion.querySelector(
    '[data-kq-date-month]'
  );
  const yearInput = questionRegion.querySelector(
    '[data-kq-date-year]'
  );

  const day = Number.parseInt(dayInput.value, 10);
  const month = Number.parseInt(monthInput.value, 10);
  const year = Number.parseInt(yearInput.value, 10);

  if (!day || !month || !year) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul je volledige geboortedatum in.');
    return false;
  }

  if (!isValidDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geldige geboortedatum in.');
    return false;
  }

  if (!isPastDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geboortedatum in het verleden in.');
    return false;
  }

  const age = calculateAge(day, month, year);

  answers[question.id] = formatDateOfBirth(day, month, year);

  if (age < 18) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
    });

    return false;
  }

  if (age > 76) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
    });

    return false;
  }

  return true;
}

        if (question.type === 'bsn') {
          const bsnInput = questionRegion.querySelector(
            '[data-kq-bsn]'
          );

          const bsn = bsnInput?.value
            .replace(/\D/g, '')
            .trim() || '';

          if (bsn.length !== 9) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Vul je BSN van 9 cijfers in.'
            );

            return false;
          }

          if (!isValidBsn(bsn)) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Dit lijkt geen geldig BSN. Controleer de 9 cijfers en probeer het opnieuw.'
            );

            return false;
          }

          answers[question.id] = bsn;

          return true;
        }

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          const value = textarea?.value.trim() || '';

          // Synchronize the latest DOM value before validation/navigation.
          answers[question.id] = value;

          if (!value && question.required !== false) {
            textarea?.classList.add('has-error');

            renderError(
              question.errorMessage ||
                'Vul de gevraagde informatie in om verder te gaan.'
            );

            return false;
          }

          return true;
        }

        if (question.type === 'radio') {
  const checkedInput = questionRegion.querySelector(
    'input[type="radio"]:checked'
  );

  if (!checkedInput) {
    renderError('Kies één antwoord om verder te gaan.');
    return false;
  }

  answers[question.id] = checkedInput.value;

  if (checkedInput.value === 'other') {
    const otherInput = questionRegion.querySelector(
      '[data-kq-other-input]'
    );

    const otherValue =
      otherInput?.value.trim() || '';

    if (!otherValue) {
      otherInput?.classList.add('has-error');

      renderError(
        'Vul bij “Anders, namelijk” de naam van de behandeling in.'
      );

      return false;
    }

    answers[`${question.id}_other`] = otherValue;
  }

  return true;
}

        if (question.type === 'checkbox') {
          const checkedInputs = Array.from(
            questionRegion.querySelectorAll(
              'input[type="checkbox"]:checked'
            )
          );

          if (checkedInputs.length === 0) {
  renderError(
    question.requireAll
      ? 'Vink alle verklaringen aan om verder te gaan.'
      : 'Kies minimaal één antwoord om verder te gaan.'
  );

  return false;
}

if (
  question.requireAll &&
  checkedInputs.length !== question.options.length
) {
  renderError('Vink alle verklaringen aan om verder te gaan.');
  return false;
}

answers[question.id] = checkedInputs.map(
  (input) => input.value
);

if (question.id === 'previous_weight_loss_attempts') {
  if (!answers[question.id].includes('weight_loss_medication')) {
    delete answers.previous_weight_loss_medications;
    delete answers.previous_weight_loss_medications_other;
    delete answers.previous_weight_loss_medication_details;
  }
}

if (question.id === 'previous_weight_loss_medications') {
  const selectedTreatments = answers[question.id];

  if (!selectedTreatments.includes('other')) {
    delete answers.previous_weight_loss_medications_other;
  }

  if (
    Array.isArray(answers.previous_weight_loss_medication_details)
  ) {
    answers.previous_weight_loss_medication_details =
      answers.previous_weight_loss_medication_details.filter(
        (item) => selectedTreatments.includes(item.treatment)
      );
  }
}

          if (
            answers[question.id].includes('other') &&
            !questionRegion
              .querySelector('[data-kq-other-input]')
              ?.value.trim()
          ) {
            renderError('Vul bij “Anders, namelijk” een korte toelichting in.');
            return false;
          }

          return true;
        }

        if (question.type === 'medication_history') {
          const cards = Array.from(
            questionRegion.querySelectorAll(
              '[data-kq-medication-card]'
            )
          );

          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;
          const validatedHistory = [];

          const markError = (field) => {
            field?.classList.add('has-error');
          };

          const isValidMonthYear = (month, year) => {
            return (
              month >= 1 &&
              month <= 12 &&
              year >= 1900 &&
              year <= currentYear
            );
          };

          const isFutureMonth = (month, year) => {
            return (
              year > currentYear ||
              (year === currentYear && month > currentMonth)
            );
          };

          for (const card of cards) {
            const treatment = card.dataset.medicationKey || '';
            const medicationName =
              card.dataset.medicationName || treatment;

            const dosageField = card.querySelector(
              '[data-kq-medication-dosage]'
            );
            const startMonthField = card.querySelector(
              '[data-kq-medication-start-month]'
            );
            const startYearField = card.querySelector(
              '[data-kq-medication-start-year]'
            );
            const statusField = card.querySelector(
              '[data-kq-medication-status]'
            );
            const endMonthField = card.querySelector(
              '[data-kq-medication-end-month]'
            );
            const endYearField = card.querySelector(
              '[data-kq-medication-end-year]'
            );

            const lastDosage = dosageField?.value.trim() || '';
            const startedMonth = Number.parseInt(
              startMonthField?.value || '',
              10
            );
            const startedYear = Number.parseInt(
              startYearField?.value || '',
              10
            );
            const usageStatus = statusField?.value || '';
            const stillUsing = usageStatus === 'still_using';

            if (dosageField && !lastDosage) {
              markError(dosageField);
              renderError(
                `Vul voor ${medicationName} de laatst gebruikte dosering in.`
              );
              return false;
            }

            if (
              !isValidMonthYear(startedMonth, startedYear) ||
              isFutureMonth(startedMonth, startedYear)
            ) {
              markError(startMonthField);
              markError(startYearField);
              renderError(
                `Vul voor ${medicationName} een geldige startmaand en een geldig startjaar in.`
              );
              return false;
            }

            if (!usageStatus) {
              markError(statusField);
              renderError(
                `Geef voor ${medicationName} aan of je deze behandeling nog gebruikt.`
              );
              return false;
            }

            let endedMonth = null;
            let endedYear = null;

            if (!stillUsing) {
              endedMonth = Number.parseInt(
                endMonthField?.value || '',
                10
              );
              endedYear = Number.parseInt(
                endYearField?.value || '',
                10
              );

              if (
                !isValidMonthYear(endedMonth, endedYear) ||
                isFutureMonth(endedMonth, endedYear)
              ) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `Vul voor ${medicationName} een geldige stopmaand en een geldig stopjaar in.`
                );
                return false;
              }

              const startValue = startedYear * 12 + startedMonth;
              const endValue = endedYear * 12 + endedMonth;

              if (endValue < startValue) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `De stopdatum van ${medicationName} kan niet vóór de startdatum liggen.`
                );
                return false;
              }
            }

            const historyItem = {
              treatment,
              started_month: startedMonth,
              started_year: startedYear,
              usage_status: usageStatus,
              still_using: stillUsing,
              ended_month: stillUsing ? null : endedMonth,
              ended_year: stillUsing ? null : endedYear
            };

            if (dosageField) {
              historyItem.last_dosage = lastDosage;
            }

            validatedHistory.push(historyItem);
          }

          shownQuestions.get(question.id).subquestions =
            serializeMedicationSubquestions(cards);
          answers[question.id] = validatedHistory;
          return true;
        }

        if (question.type === 'measurements') {
          const heightInput = questionRegion.querySelector('[data-kq-height]');
          const weightInput = questionRegion.querySelector('[data-kq-weight]');

          const height = Number.parseFloat(heightInput.value);
          const weight = Number.parseFloat(weightInput.value);

          if (!height || height < 120 || height > 230) {
            heightInput.classList.add('has-error');
            renderError('Vul een geldige lengte tussen 120 en 230 cm in.');
            return false;
          }

          if (!weight || weight < 35 || weight > 350) {
            weightInput.classList.add('has-error');
            renderError('Vul een geldig gewicht tussen 35 en 350 kg in.');
            return false;
          }

          const bmi = weight / Math.pow(height / 100, 2);

          answers[question.id] = {
            height,
            weight,
            bmi: Number.parseFloat(bmi.toFixed(1))
          };

          return true;
        }

        return true;
      };

      const getStopStatus = () => {
        if (currentQuestionId === 'dateOfBirth') {
          const birthDate = parseDateOfBirth(answers.dateOfBirth);

          if (!birthDate) return null;

          const age = calculateAge(
            birthDate.day,
            birthDate.month,
            birthDate.year
          );

          if (age < 18) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
            };
          }

          if (age > 76) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
            };
          }
        }

        if (currentQuestionId === 'pregnancy_status') {
          const excludedStatuses = [
            'pregnant',
            'breastfeeding',
            'trying_to_conceive'
          ];

          if (excludedStatuses.includes(answers.pregnancy_status)) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'Je hebt aangegeven dat je zwanger bent, borstvoeding geeft of probeert zwanger te worden. Daarom kun je via het huidige Kearty-traject geen gewichtsverliesbehandeling met medicatie aanvragen. Bespreek met je huisarts of behandelend arts welke ondersteuning in jouw situatie passend is.'
            };
          }
        }

        if (currentQuestionId === 'body_measurements') {
  const bmi = answers.body_measurements?.bmi;

  if (bmi < 19) {
    return {
      title: 'Op dit moment geen passende behandeling met medicatie',
      message:
        'Je BMI is lager dan 19. Op basis van deze uitkomst is een behandeling gericht op gewichtsverlies niet passend. Daarom kan Kearty je via deze route geen behandeling aanbieden. Bespreek met je huisarts welke ondersteuning in jouw situatie passend is.'
    };
  }

  if (bmi < 25) {
  return {
    title: 'Op dit moment geen passende behandeling met medicatie',
    message:
      'Je BMI valt binnen de categorie gezond gewicht. Op basis van deze uitkomst lijkt een behandeling met gewichtsverliesmedicatie op dit moment niet passend. Daarom kan Kearty je via deze route geen passende behandeling aanbieden.'
  };
}
}

if (currentQuestionId === 'pancreas_conditions') {
  const selectedConditions = Array.isArray(answers.pancreas_conditions)
    ? answers.pancreas_conditions
    : [];

  const stopValues = [
    'pancreatitis',
    'other_pancreas_condition',
    'pancreas_removed'
  ];

  const shouldStop = selectedConditions.some((value) =>
    stopValues.includes(value)
  );

  if (shouldStop) {
  return {
    type: 'stop',
    title: 'We kunnen je aanvraag niet via deze route voortzetten',
    message:
      'Je hebt aangegeven dat je een aandoening of behandeling aan de alvleesklier hebt gehad. Op basis van deze informatie kan Kearty je aanvraag niet via deze online vragenlijst voortzetten. Neem bij vragen gerust contact met ons op.'
  };
}
}

if (
  currentQuestionId === 'current_gallbladder_symptoms' &&
  answers.current_gallbladder_symptoms === 'yes'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment klachten hebt die mogelijk te maken hebben met je galblaas of galwegen. Daarom kunnen we je aanvraag niet direct via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken wat in jouw situatie de juiste vervolgstap is.'
  };
}

if (
  currentQuestionId === 'eating_disorder_current_status' &&
  answers.eating_disorder_current_status === 'current'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment last hebt van een eetstoornis of ernstige problemen met eten. Daarom kunnen we je aanvraag niet via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken welke ondersteuning in jouw situatie passend is.'
  };
}

return null;
};

      const goToNextQuestion = () => {
  const stopStatus = getStopStatus();

  if (stopStatus) {
    renderStatus(stopStatus);
    return;
  }

  if (
  currentQuestionId === 'current_or_previous_treatment' &&
  answers.treatment_goal === 'need_guidance' &&
  answers.current_or_previous_treatment === 'other'
) {
  const treatmentName =
    answers.current_or_previous_treatment_other?.trim() ||
    'de door jou ingevulde behandeling';

  renderStatus({
    type: 'other_treatment',
    title:
      'Voor deze behandeling kunnen we geen automatische vervolgstap bepalen',
    message:
      `Je hebt aangegeven dat je ${treatmentName} gebruikt. Omdat deze behandeling niet in onze vaste lijst staat, kunnen we geen passende vervolgdosis voorstellen. Je kunt een andere behandeling overwegen of contact met ons opnemen.`
  });

  return;
}

  const visibleQuestions = getVisibleQuestions();

  const currentIndex = visibleQuestions.findIndex(
    (question) => question.id === currentQuestionId
  );

  const currentQuestion = visibleQuestions[currentIndex];
  const nextQuestion = visibleQuestions[currentIndex + 1];

  const currentSection = currentQuestion?.section || 'about';

const nextSection = nextQuestion
  ? nextQuestion.section || 'about'
  : null;

  /*
   * Eerst een overgangsscherm tonen wanneer
   * het volgende onderdeel begint.
   */
  if (nextQuestion && currentSection !== nextSection) {
  if (currentSection === 'about' && nextSection === 'health') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Over jou" is afgerond',
      message:
        'In de volgende stap stellen we vragen over jouw gezondheid.',
      nextQuestionId: nextQuestion.id,
      nextSection: 'health',
      nextButtonLabel: 'Verder naar jouw gezondheid'
    });

    return;
  }

  if (currentSection === 'health' && nextSection === 'treatment') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
  'Op basis van je gezondheidssituatie lijkt het erop dat je in aanmerking kunt komen voor een behandeling. In de volgende stap kijken we welke behandeling het beste bij jouw situatie past',
      nextQuestionId: nextQuestion.id,
      nextSection: 'treatment',
      nextButtonLabel: 'Verder naar behandeladvies'
    });

    return;
  }
}

  if (currentQuestionId === 'final_declarations') {
    renderStatus({
      type: 'checkout_ready',
      title: 'Je kunt verder naar betalen',
      message:
        'Je hebt alle benodigde gegevens en bevestigingen ingevuld. Je kunt nu verder naar betalen. Nieuw bij Kearty? Dan vragen we je na de betaling om eenmalig je identiteit te bevestigen. Daarna neemt de arts je aanvraag in behandeling.'
    });

    return;
  }

  /*
   * Tijdelijke afronding zolang nog niet alle
   * gezondheidsvragen zijn toegevoegd.
   */
  if (!nextQuestion) {
    renderStatus({
      type: 'health_complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
        'Je hebt alle vragen in dit onderdeel beantwoord.'
    });

    return;
  }

  history.push(currentQuestionId);
  currentQuestionId = nextQuestion.id;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (
          statusScreen?.type === 'complete' ||
          statusScreen?.type === 'consent_intro'
        ) {
  if (statusScreen.type === 'complete' && statusScreen.nextSection === 'health') {
    root.dispatchEvent(
      new CustomEvent('kearty:about-section-complete', {
        bubbles: true,
        detail: { answers: serializeAnswers() }
      })
    );
  }

  const nextQuestionId = statusScreen.nextQuestionId;

  if (!nextQuestionId) return;

  history.push(currentQuestionId);
  currentQuestionId = nextQuestionId;
  statusScreen = null;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  return;
}

        if (!validateCurrentQuestion()) return;

        goToNextQuestion();
      });

      backButton.addEventListener('click', () => {
        if (statusScreen) {
          statusScreen = null;
          renderQuestion();
          return;
        }

        const previousQuestionId = history.pop();

        if (!previousQuestionId) return;

        currentQuestionId = previousQuestionId;
        renderQuestion();

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      helpButton.addEventListener('click', () => {
        const chatSelector = root.dataset.chatSelector?.trim();
        const helpUrl = root.dataset.helpUrl?.trim();

        if (chatSelector) {
          const chatLauncher = document.querySelector(chatSelector);

          if (chatLauncher) {
            chatLauncher.click();
            return;
          }
        }

        const chatEvent = new CustomEvent('kearty:open-chat', {
          bubbles: true
        });

        root.dispatchEvent(chatEvent);

        if (helpUrl) {
          window.location.href = helpUrl;
        }
      });

      // The active route and rendered definitions determine the submission.
      // Only questions that are currently visible and were actually rendered are sent.
      const getSubmissionQuestions = () =>
        getVisibleQuestions().filter(
          (question) =>
            question.type !== 'treatment_recommendation' &&
            shownQuestions.has(question.id)
        );

      const serializeAnswers = () => {
        const result = {};

        getSubmissionQuestions().forEach((question) => {
          if (Object.prototype.hasOwnProperty.call(answers, question.id)) {
            result[question.id] = answers[question.id];
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));

          if (hasOtherAnswer) {
            const otherKey = `${question.id}_other`;

            if (Object.prototype.hasOwnProperty.call(answers, otherKey)) {
              result[otherKey] = answers[otherKey];
            }
          }
        });

        return structuredClone(result);
      };

      const getOtherFieldQuestionText = (question) => {
        if (question.type === 'radio') {
          return 'Welke behandeling heb je gebruikt?';
        }

        return 'Anders, namelijk';
      };

      const serializeQuestions = () => {
        const definitions = [];

        getSubmissionQuestions().forEach((question) => {
          const definition = shownQuestions.get(question.id);

          if (definition) {
            definitions.push(definition);
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));
          const otherKey = `${question.id}_other`;

          if (
            hasOtherAnswer &&
            Object.prototype.hasOwnProperty.call(answers, otherKey)
          ) {
            definitions.push({
              id: otherKey,
              type: 'textarea',
              question: getOtherFieldQuestionText(question),
              help: null,
              answers: null
            });
          }
        });

        return structuredClone(definitions);
      };

      // Composite medication_history fields must be described exactly as shown.
      // These definitions are nested under the parent question in detail.questions.
      const serializeMedicationSubquestions = (cards) =>
        cards.flatMap((card) => {
          const treatment = card.dataset.medicationKey || '';
          const medicationName = card.dataset.medicationName || treatment;
          const text = (element) =>
            element?.textContent.trim().replace(/\s+/g, ' ') || '';
          const definitions = [];

          definitions.push({
            id: `${treatment}.medication`,
            question: 'Welke medicatie heb je gebruikt?',
            type: 'select',
            answers: treatment
              ? { [treatment]: medicationName }
              : null
          });

          const dosageField = card.querySelector(
            '[data-kq-medication-dosage]'
          );

          if (dosageField) {
            const dosageDefinition = {
              id: `${treatment}.last_dosage`,
              question: 'Welke dosering gebruikte je het laatst?',
              type: dosageField.tagName === 'SELECT' ? 'select' : 'text'
            };

            if (dosageField.tagName === 'SELECT') {
              dosageDefinition.answers = Object.fromEntries(
                Array.from(dosageField.options)
                  .filter((option) => option.value !== '')
                  .map((option) => [option.value, text(option)])
              );
            }

            definitions.push(dosageDefinition);
          }

          definitions.push({
            id: `${treatment}.start_date`,
            question: 'Wanneer ben je met deze behandeling gestart?',
            type: 'month_year'
          });

          const statusField = card.querySelector(
            '[data-kq-medication-status]'
          );

          const statusDefinition = {
            id: `${treatment}.usage_status`,
            question: 'Gebruik je deze behandeling op dit moment nog?',
            type: 'select',
            answers: statusField
              ? Object.fromEntries(
                  Array.from(statusField.options)
                    .filter((option) => option.value !== '')
                    .map((option) => [option.value, text(option)])
                )
              : {
                  still_using: 'Ja, ik gebruik deze behandeling nog',
                  stopped: 'Nee, ik ben hiermee gestopt'
                }
          };

          definitions.push(statusDefinition);

          if (statusField?.value === 'stopped') {
            definitions.push({
              id: `${treatment}.end_date`,
              question: 'Wanneer ben je met deze behandeling gestopt?',
              type: 'month_year',
              condition: "usage_status === 'stopped'"
            });
          }

          return definitions;
        });

      root.addEventListener('kearty:submission-error', () => {
        submissionPending = false;
        submissionFailedDuringDispatch = true;
        root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
          button.disabled = false;
          button.innerHTML = 'Behandeling aanvragen <span aria-hidden="true">→</span>';
        });
      });

      root.addEventListener('click', (event) => {
  const switchFromOtherButton = event.target.closest(
    '[data-kq-switch-from-other]'
  );

  if (
    switchFromOtherButton &&
    root.contains(switchFromOtherButton)
  ) {
    answers.treatment_goal = 'switch_treatment';

    statusScreen = null;
    history.push(currentQuestionId);
    currentQuestionId = 'preferred_treatment_form';

    renderQuestion();

    root.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    return;
  }

  const calendlyButton = event.target.closest(
    '[data-kq-calendly]'
  );

  if (
    calendlyButton &&
    root.contains(calendlyButton)
  ) {
    event.preventDefault();

    if (calendlyButton.disabled) return;

    const calendlyError = questionRegion.querySelector(
      '[data-kq-calendly-error]'
    );
    const originalButtonHtml = calendlyButton.innerHTML;

    if (calendlyError) {
      calendlyError.hidden = true;
      calendlyError.textContent = '';
    }

    calendlyButton.disabled = true;
    calendlyButton.textContent = 'Agenda wordt geladen…';

    openCalendlyPopup()
      .catch(() => {
        if (calendlyError) {
          calendlyError.textContent =
            'De agenda kon niet worden geladen. Probeer het opnieuw of neem contact met ons op.';
          calendlyError.hidden = false;
        }
      })
      .finally(() => {
        if (calendlyButton.isConnected) {
          calendlyButton.disabled = false;
          calendlyButton.innerHTML = originalButtonHtml;
        }
      });

    return;
  }

  const finalCheckoutButton = event.target.closest(
    '[data-kq-final-checkout]'
  );

  if (
    finalCheckoutButton &&
    root.contains(finalCheckoutButton)
  ) {
    if (finalCheckoutButton.disabled || submissionPending) return;
    event.preventDefault();

    const treatment = finalCheckoutButton.dataset.treatment || '';

    const variantId = finalCheckoutButton.dataset.variantId || '';

    const errorElement = questionRegion.querySelector(
      '[data-kq-apply-error]'
    );

    if (!treatment || !/^\d+$/.test(variantId) || /^0+$/.test(variantId)) {
      if (errorElement) {
        errorElement.textContent =
          'De gekozen behandeling kon niet worden teruggevonden. Ga terug naar het behandeladvies en kies de behandeling opnieuw.';
        errorElement.hidden = false;
      }

      return;
    }

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }
    submissionFailedDuringDispatch = false;
    submissionPending = true;

    const applicationEvent = new CustomEvent(
      'kearty:treatment-apply',
      {
        bubbles: true,
        cancelable: true,
        detail: {
          treatment,
          variantId,
          answers: serializeAnswers(),
          questions: serializeQuestions(),
          questionnaireKey: 'weight-loss-flow-1',
          questionnaireVersion: '2026-10-20'
        }
      }
    );

    const eventWasNotCancelled =
      root.dispatchEvent(applicationEvent);

    if (!eventWasNotCancelled) {
      // A synchronous handler error may already have restored the buttons.
      if (!submissionFailedDuringDispatch) {
        root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
          button.disabled = true;
          button.innerHTML = 'Aanvraag wordt verwerkt…';
        });
      }
      return;
    }

    submissionPending = false;
    // Without a submission handler, keep the answers here and show an error.
    if (errorElement) {
      errorElement.textContent =
        'De aanvraagkoppeling is nog niet geactiveerd. Probeer het later opnieuw of neem contact met ons op.';
      errorElement.hidden = false;
    }

    return;
  }

  const applyButton = event.target.closest(
    '[data-kq-treatment-select]'
  );

  if (
    !applyButton ||
    !root.contains(applyButton) ||
    applyButton.disabled
  ) {
    return;
  }

  const treatment =
    applyButton.dataset.treatment || '';

  const variantId =
    applyButton.dataset.variantId || '';

  const treatmentConfig =
    treatmentRecommendations[treatment];

  const treatmentName = treatmentConfig
    ? [
        treatmentConfig.displayName,
        treatmentConfig.dosage
      ]
        .filter(Boolean)
        .join(' ')
    : 'de gekozen behandeling';

  selectedTreatment = treatment;
  selectedVariantId = variantId;

  renderStatus({
    type: 'consent_intro',
    title: 'Rond je aanvraag af',
    message:
      `Je hebt gekozen voor ${treatmentName}. Voordat je verdergaat naar betalen hebben we alleen nog een paar gegevens en bevestigingen van je nodig.`,
    nextQuestionId: getFirstFinalQuestionId(),
    nextSection: 'treatment',
    nextButtonLabel: 'Verder met afronden'
  });

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});

      renderQuestion();
    });

    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot = event.target.querySelector(
        '[data-kearty-questionnaire-flow-1]'
      );

      if (sectionRoot) {
        sectionRoot.removeAttribute('data-kq-flow-1-initialized');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kearty-questionnaire-flow-1-startvoordeel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const questionnaireRoots = document.querySelectorAll(
      '[data-kearty-questionnaire-flow-1]:not([data-kq-flow-1-initialized])'
    );

    questionnaireRoots.forEach((root) => {
      root.setAttribute('data-kq-flow-1-initialized', 'true');

      const questionRegion = root.querySelector(
        '[data-kq-question-region]'
      );
      const form = root.querySelector('[data-kq-form]');
      const backButton = root.querySelector('[data-kq-back]');
      const nextButton = root.querySelector('[data-kq-next]');
      const helpButton = root.querySelector('[data-kq-help]');

      const homeUrl = root.dataset.homeUrl || '/';
      const contactUrl =
        root.dataset.contactUrl || '/pages/contact';
      const termsUrl =
        root.dataset.termsUrl || '/pages/algemene-voorwaarden';
      const privacyUrl =
        root.dataset.privacyUrl || '/pages/privacy-statement';

      const countryCode =
        (root.dataset.countryCode || '').toUpperCase();

      const isNetherlands = countryCode === 'NL';

      const calendlyUrl =
        'https://calendly.com/clanooij-kearty/persoonlijk-gesprek';

      const ensureCalendlyAssets = () => {
        if (
          window.Calendly &&
          typeof window.Calendly.initPopupWidget === 'function'
        ) {
          return Promise.resolve();
        }

        if (!document.querySelector('link[data-kearty-calendly-css]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href =
            'https://assets.calendly.com/assets/external/widget.css';
          stylesheet.setAttribute('data-kearty-calendly-css', 'true');
          document.head.appendChild(stylesheet);
        }

        return new Promise((resolve, reject) => {
          const existingScript = document.querySelector(
            'script[data-kearty-calendly-script]'
          );

          const onReady = () => {
            if (
              window.Calendly &&
              typeof window.Calendly.initPopupWidget === 'function'
            ) {
              resolve();
            } else {
              reject(new Error('Calendly is niet beschikbaar.'));
            }
          };

          if (existingScript) {
            existingScript.addEventListener('load', onReady, { once: true });
            existingScript.addEventListener('error', reject, { once: true });
            return;
          }

          const script = document.createElement('script');
          script.src =
            'https://assets.calendly.com/assets/external/widget.js';
          script.async = true;
          script.setAttribute('data-kearty-calendly-script', 'true');
          script.addEventListener('load', onReady, { once: true });
          script.addEventListener('error', reject, { once: true });
          document.head.appendChild(script);
        });
      };

      const openCalendlyPopup = async () => {
        await ensureCalendlyAssets();

        window.Calendly.initPopupWidget({
          url: calendlyUrl
        });
      };

      const escapeHtml = (value) =>
        String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');

      const addLowestPriceToLabel = (label, price) => {
        return price
          ? `${label} – vanaf ${price}`
          : label;
      };

      const answers = {};
      const history = [];
      const shownQuestions = new Map();
      let submissionPending = false;
      let submissionFailedDuringDispatch = false;

      let selectedTreatment = '';
      let selectedVariantId = '';

      const continuationTreatmentMap = {
        wegovy: {
          '0_25_mg': 'wegovy_0_5',
          '0_5_mg': 'wegovy_1',
          '1_0_mg': 'wegovy_1_7',
          '1_7_mg': 'wegovy_2_4',
          '2_4_mg': 'wegovy_2_4'
        },
        mounjaro: {
          '2_5_mg': 'mounjaro_5',
          '5_mg': 'mounjaro_7_5',
          '7_5_mg': 'mounjaro_10',
          '10_mg': 'mounjaro_12_5',
          '12_5_mg': 'mounjaro_15',
          '15_mg': 'mounjaro_15'
        },
        ozempic: {
          '0_25_mg': 'ozempic_0_5',
          '0_5_mg': 'ozempic_1',
          '1_0_mg': 'ozempic_2',
          '2_0_mg': 'ozempic_2'
        },
        rybelsus: {
          '1_5_mg': 'rybelsus_4',
          '4_mg': 'rybelsus_9',
          '9_mg': 'rybelsus_9'
        },
        saxenda: {
          default: 'saxenda'
        },
        mysimba: {
          default: 'mysimba'
        }
      };

      const getContinuationTreatmentKey = () => {
        const currentTreatment =
          answers.current_or_previous_treatment;

        if (!currentTreatment) {
          return '';
        }

        const treatmentMap =
          continuationTreatmentMap[currentTreatment];

        if (!treatmentMap) {
          return '';
        }

        if (treatmentMap.default) {
          return treatmentMap.default;
        }

        const dosageAnswerKey =
          `${currentTreatment}_current_dosage`;

        const currentDosage =
          answers[dosageAnswerKey];

        if (!currentDosage) {
          return '';
        }

        return treatmentMap[currentDosage] || '';
      };

      let currentQuestionId = 'dateOfBirth';
      let statusScreen = null;

      const questions = [
        {
          id: 'dateOfBirth',
          type: 'date',
          title: 'Wat is je geboortedatum?',
          help: 'Je geboortedatum gebruiken we om je leeftijd te bepalen en om deze op het e-recept te vermelden als de arts je aanvraag goedkeurt.'
        },
        {
          id: 'sex_at_birth',
          type: 'radio',
          title: 'Welk geslacht werd bij je geboorte geregistreerd?',
          options: [
            { value: 'male', label: 'Mannelijk' },
            { value: 'female', label: 'Vrouwelijk' },
            { value: 'intersex_or_other', label: 'Intersekse of anders' }
          ]
        },
        {
          id: 'pregnancy_status',
          type: 'radio',
          title: 'Probeer je op dit moment zwanger te worden, ben je zwanger of geef je borstvoeding?',
          condition: () => answers.sex_at_birth === 'female',
          options: [
            { value: 'pregnant', label: 'Ik ben zwanger' },
            { value: 'breastfeeding', label: 'Ik geef borstvoeding' },
            {
              value: 'trying_to_conceive',
              label: 'Ik probeer zwanger te worden'
            },
            {
              value: 'none',
              label: 'Nee, geen van bovenstaande'
            }
          ]
        },
        {
          id: 'body_measurements',
          type: 'measurements',
          title: 'Wat zijn je lengte en je gewicht?',
          help:
            'Met je lengte en huidige gewicht berekenen we automatisch je BMI.'
        },
        {
          id: 'previous_weight_loss_attempts',
          type: 'checkbox',
          title: 'Wat heb je eerder gedaan om af te vallen?',
          help: 'Je kunt meerdere antwoorden kiezen.',
          exclusiveValues: ['not_tried'],
          options: [
            {
              value: 'diet',
              label: 'Zelf mijn voeding of eetpatroon aangepast'
            },
            {
              value: 'exercise',
              label: 'Meer bewogen of gesport'
            },
            {
              value: 'dietitian',
              label:
                'Begeleiding gehad van een diëtist of voedingsdeskundige'
            },
            {
              value: 'gli',
              label: 'Een gecombineerde leefstijlinterventie (GLI) gevolgd'
            },
            {
              value: 'other_program',
              label: 'Een ander afvalprogramma of begeleidingstraject gevolgd'
            },
            {
              value: 'weight_loss_medication',
              label: 'Medicatie gebruikt om af te vallen'
            },
            {
              value: 'bariatric_surgery',
              label:
                'Een maagverkleining of andere operatie voor gewichtsverlies gehad'
            },
            {
              value: 'not_tried',
              label: 'Ik heb nog niet eerder geprobeerd af te vallen'
            },
            {
              value: 'other',
              label: 'Anders, namelijk'
            }
                    ]
        },
        {
          id: 'previous_weight_loss_medications',
          type: 'checkbox',
          title: 'Welke medicatie heb je eerder gebruikt om af te vallen?',
          help: 'Je kunt meerdere behandelingen selecteren.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_attempts) &&
            answers.previous_weight_loss_attempts.includes(
              'weight_loss_medication'
            ),
          options: [
            { value: 'wegovy', label: 'Wegovy®' },
            { value: 'mounjaro', label: 'Mounjaro®' },
            { value: 'ozempic', label: 'Ozempic®' },
            { value: 'saxenda', label: 'Saxenda®' },
            { value: 'mysimba', label: 'Mysimba®' },
            { value: 'rybelsus', label: 'Rybelsus®' },
            { value: 'other', label: 'Andere medicatie' }
          ]
        },
        {
          id: 'previous_weight_loss_medication_details',
          type: 'medication_history',
          title: 'Vertel ons iets meer over de medicatie die je hebt gebruikt',
          help:
            'Vul per behandeling de periode in waarin je deze hebt gebruikt. Waar relevant vragen we ook naar de laatst gebruikte dosering.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_medications) &&
            answers.previous_weight_loss_medications.length > 0
        },
        {
          id: 'weight_related_conditions',
          section: 'health',
          type: 'checkbox',
          title: 'Heb je één of meer van de volgende gewichtsgerelateerde aandoeningen of klachten?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'high_blood_pressure',
              label: 'Hoge bloeddruk'
            },
            {
              value: 'high_cholesterol',
              label: 'Verhoogd cholesterol of verhoogde bloedvetten'
            },
            {
              value: 'prediabetes',
              label: 'Prediabetes'
            },
            {
              value: 'type_2_diabetes',
              label: 'Diabetes type 2'
            },
            {
              value: 'type_1_or_other_diabetes',
              label: 'Diabetes type 1 of een andere vorm van diabetes'
            },
            {
              value: 'sleep_apnea',
              label: 'Slaapapneu (OSAS)'
            },
            {
              value: 'cardiovascular_disease',
              label: 'Een hart- of vaatziekte'
            },
            {
              value: 'fatty_liver',
              label: 'Leververvetting'
            },
            {
              value: 'pcos',
              label: 'PCOS'
            },
                        {
              value: 'osteoarthritis',
              label: 'Artrose aan de knie of heup'
            },
            {
              value: 'none',
              label: 'Geen van bovenstaande'
            },
            {
              value: 'other',
              label: 'Andere gewichtsgerelateerde aandoening, namelijk'
            }
          ]
        },
        {
          id: 'pancreas_conditions',
          section: 'health',
          type: 'checkbox',
          title:
            'Heb je één of meer van de volgende aandoeningen of behandelingen aan de alvleesklier gehad?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'pancreatitis',
              label: 'Een ontsteking van de alvleesklier (pancreatitis)'
            },
            {
              value: 'other_pancreas_condition',
              label: 'Een andere aandoening of afwijking aan de alvleesklier'
            },
            {
  value: 'pancreas_removed',
  label:
    'Mijn alvleesklier is gedeeltelijk of volledig verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'gallbladder_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende galblaasproblemen gehad?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'gallstones',
      label: 'Galstenen'
    },
    {
      value: 'gallbladder_inflammation',
      label: 'Een ontsteking van de galblaas'
    },
    {
  value: 'gallbladder_removed',
  label: 'Mijn galblaas is verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'current_gallbladder_symptoms',
  section: 'health',
  type: 'radio',
  title:
    'Heb je op dit moment klachten die mogelijk te maken hebben met je galblaas of galwegen?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.gallbladder_conditions
    )
      ? answers.gallbladder_conditions
      : [];

    return [
      'gallstones',
      'gallbladder_inflammation',
      'gallbladder_removed'
    ].some((value) => selectedConditions.includes(value));
  },
    options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'other_health_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende aandoeningen?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'severe_gastrointestinal_condition',
      label: 'Een ernstige maag- of darmaandoening'
    },
    {
      value: 'kidney_condition',
      label: 'Een nierziekte of verminderde nierfunctie'
    },
    {
      value: 'liver_condition',
      label: 'Een leverziekte'
    },
    {
      value: 'thyroid_condition',
      label:
        'Een schildklieraandoening, schildklierknobbels of schildklierkanker'
    },
    {
      value: 'epilepsy',
      label: 'Epilepsie of andere aanvallen'
    },
    {
      value: 'cancer',
      label: 'Kanker'
    },
    {
      value: 'other',
      label: 'Een andere ernstige of chronische aandoening'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'health_conditions_treatment_status',
  section: 'health',
  type: 'radio',
  title:
    'Word je hiervoor momenteel behandeld of is de aandoening onder controle?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.other_health_conditions
    )
      ? answers.other_health_conditions
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication',
  section: 'health',
  type: 'radio',
  title:
    'Gebruik je op dit moment medicijnen, anders dan medicatie om af te vallen?',
  help:
    'Denk ook aan medicijnen die je alleen af en toe of zo nodig gebruikt.',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication_details',
  section: 'health',
  type: 'textarea',
  title: 'Welke medicijnen gebruik je op dit moment?',
  help:
    'Vermeld per medicijn de naam, dosering en hoe vaak je het gebruikt.',
  label: 'Medicijn(en)',
  placeholder:
    'Bijvoorbeeld: Metformine 500 mg, twee keer per dag',
  condition: () => answers.current_medication === 'yes'
},
{
  id: 'medication_allergies',
  section: 'health',
  type: 'radio',
  title:
    'Ben je allergisch of overgevoelig voor medicijnen of andere stoffen?',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'medication_allergy_details',
  section: 'health',
  type: 'textarea',
  title: 'Waar ben je allergisch of overgevoelig voor?',
  help:
    'Vermeld het medicijn of de stof en beschrijf welke reactie je krijgt.',
  label: 'Allergie of overgevoeligheid',
  placeholder:
    'Bijvoorbeeld: penicilline – huiduitslag en zwelling',
  errorMessage:
    'Vul in waarvoor je allergisch of overgevoelig bent en welke reactie je krijgt.',
  condition: () => answers.medication_allergies === 'yes'
},
{
  id: 'eating_disorder_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden last gehad van een eetstoornis of ernstige problemen met eten?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'anorexia',
      label: 'Anorexia nervosa'
    },
    {
      value: 'bulimia',
      label: 'Boulimia nervosa'
    },
    {
      value: 'binge_eating',
      label: 'Eetbuien of een eetbuistoornis'
    },
    {
      value: 'other',
      label: 'Een andere eetstoornis of ernstige problemen met eten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'eating_disorder_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze eetproblemen of deze eetstoornis op dit moment nog?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.eating_disorder_history
    )
      ? answers.eating_disorder_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current',
      label: 'Ja, dit speelt op dit moment'
    },
    {
      value: 'past',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'mental_health_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden te maken gehad met psychische klachten of een psychische aandoening?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'depression',
      label: 'Depressie'
    },
    {
      value: 'anxiety_or_panic',
      label: 'Angstklachten of een paniekstoornis'
    },
    {
      value: 'bipolar_disorder',
      label: 'Een bipolaire stoornis'
    },
    {
      value: 'psychosis',
      label: 'Een psychose of schizofrenie'
    },
    {
      value: 'other',
      label: 'Een andere psychische aandoening of ernstige psychische klachten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'mental_health_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze psychische klachten op dit moment nog of word je hiervoor behandeld?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.mental_health_history
    )
      ? answers.mental_health_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current_or_treatment',
      label:
        'Ja, ik heb op dit moment klachten en/of word hiervoor behandeld'
    },
    {
      value: 'past_only',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'additional_health_information',
  section: 'health',
  type: 'textarea',
  title:
    'Is er nog iets over je gezondheid dat belangrijk kan zijn voor de beoordeling van je aanvraag?',
  help:
    'Denk aan klachten, onderzoeken, behandelingen of andere medische informatie die nog niet aan bod is gekomen.',
  label: 'Aanvullende informatie',
  placeholder: 'Vul hier eventueel een toelichting in',
  required: false
},
{
  id: 'treatment_goal',
  section: 'treatment',
  type: 'radio',
  title: 'Waar ben je op dit moment vooral naar op zoek?',
  options: [
    {
      value: 'start_treatment',
      label: 'Ik wil starten met een behandeling'
    },
    {
      value: 'need_guidance',
      label:
        'Ik wil weten wat een passende vervolgstap is binnen mijn huidige behandeling'
    },
    {
      value: 'switch_treatment',
      label: 'Ik wil een andere behandeling overwegen'
    }
  ]
},
{
  id: 'current_or_previous_treatment',
  section: 'treatment',
  type: 'radio',
  title:
    'Welke behandeling voor gewichtsverlies gebruik je op dit moment?',
  condition: () =>
    [
      'switch_treatment',
      'need_guidance'
    ].includes(answers.treatment_goal),
  options: [
    {
      value: 'wegovy',
      label: 'Wegovy®'
    },
    {
      value: 'mounjaro',
      label: 'Mounjaro®'
    },
    {
      value: 'ozempic',
      label: 'Ozempic®'
    },
    {
      value: 'saxenda',
      label: 'Saxenda®'
    },
    {
      value: 'mysimba',
      label: 'Mysimba®'
    },
    {
      value: 'rybelsus',
      label: 'Rybelsus®'
    },
    {
      value: 'other',
      label: 'Anders, namelijk'
    }
  ]
},
{
  id: 'wegovy_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Wegovy® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'wegovy',
  options: [
    {
      value: '0_25_mg',
      label: '0,25 mg'
    },
    {
      value: '0_5_mg',
      label: '0,5 mg'
    },
    {
      value: '1_0_mg',
      label: '1,0 mg'
    },
    {
      value: '1_7_mg',
      label: '1,7 mg'
    },
    {
      value: '2_4_mg',
      label: '2,4 mg'
    }
  ]
},
{
  id: 'mounjaro_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Mounjaro® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'mounjaro',
  options: [
    {
      value: '2_5_mg',
      label: '2,5 mg'
    },
    {
      value: '5_mg',
      label: '5 mg'
    },
    {
      value: '7_5_mg',
      label: '7,5 mg'
    },
    {
      value: '10_mg',
      label: '10 mg'
    },
    {
      value: '12_5_mg',
      label: '12,5 mg'
    },
    {
      value: '15_mg',
      label: '15 mg'
    }
  ]
},
{
  id: 'ozempic_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Ozempic® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'ozempic',
  options: [
    {
      value: '0_25_mg',
      label: '0,25 mg'
    },
    {
      value: '0_5_mg',
      label: '0,5 mg'
    },
    {
      value: '1_0_mg',
      label: '1,0 mg'
    },
    {
      value: '2_0_mg',
      label: '2,0 mg'
    }
  ]
},
{
  id: 'rybelsus_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Rybelsus® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'rybelsus',
  options: [
    {
      value: '1_5_mg',
      label: '1,5 mg'
    },
    {
      value: '4_mg',
      label: '4 mg'
    },
    {
      value: '9_mg',
      label: '9 mg'
    }
  ]
},
{
  id: 'continuation_treatment_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: () => getContinuationTreatmentKey(),
  condition: () =>
    answers.treatment_goal === 'need_guidance' &&
    Boolean(getContinuationTreatmentKey())
},
{
  id: 'preferred_treatment_form',
  section: 'treatment',
  type: 'radio',
  title:
    'Heb je op dit moment een voorkeur voor een prikpen of tabletten?',
  condition: () =>
    answers.treatment_goal === 'start_treatment' ||
    answers.treatment_goal === 'switch_treatment',
  options: [
    {
      value: 'injection_pen',
      label: 'Ik heb een voorkeur voor een prikpen'
    },
    {
      value: 'tablets',
      label: 'Ik heb een voorkeur voor tabletten'
    }
  ]
},
{
  id: 'tablet_treatment_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Geef aan waar je voorkeur naar uit gaat:',
  help:
    'Op dit moment kunnen we twee behandelopties aanbieden: Mysimba® en Rybelsus®. Deze behandelingen bevatten verschillende werkzame stoffen en verschillen in toepassing. Mysimba® is specifiek bedoeld voor gewichtsbeheersing. Rybelsus® is bedoeld voor volwassenen met type 2 diabetes en wordt in sommige situaties off label gebruikt voor gewichtsverlies.',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        )
      )
    ),
  options: [
    {
      value: 'mysimba',
      label: addLowestPriceToLabel(
        'Mysimba® lijkt het beste bij mijn situatie te passen',
        root.dataset.mysimbaLowestPrice
      )
    },
    {
      value: 'rybelsus',
      label: addLowestPriceToLabel(
        'Rybelsus® (off label) lijkt het beste bij mijn situatie te passen',
        root.dataset.rybelsusLowestPrice
      )
    }
  ]
},
{
  id: 'mysimba_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'mysimba',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      (
        answers.treatment_goal === 'start_treatment' &&
        answers.tablet_treatment_preference === 'mysimba'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        answers.current_or_previous_treatment === 'rybelsus'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        ) &&
        answers.tablet_treatment_preference === 'mysimba'
      )
    )
},
{
  id: 'rybelsus_1_5_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'rybelsus_1_5',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      (
        answers.treatment_goal === 'start_treatment' &&
        answers.tablet_treatment_preference === 'rybelsus'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        answers.current_or_previous_treatment === 'mysimba'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        ) &&
        answers.tablet_treatment_preference === 'rybelsus'
      )
    )
},
{
  id: 'injection_frequency_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Wat heeft op dit moment jouw voorkeur?',
  help:
    'De ene behandeling gebruik je dagelijks, de andere wekelijks. Met je antwoord kunnen we beter inschatten welke optie het beste bij jouw situatie past.',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen',
  options: [
    {
      value: 'daily',
      label: 'Dagelijks gebruiken past beter bij mij'
    },
    {
      value: 'weekly',
      label: 'Wekelijks gebruiken past beter bij mij'
    }
  ]
},
{
  id: 'saxenda_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'saxenda',
  condition: () =>
    answers.treatment_goal === 'start_treatment' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'daily'
},
{
  id: 'switch_saxenda_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'saxenda',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'daily'
},
{
  id: 'weekly_injection_price_preference',
  section: 'treatment',
  type: 'radio',
  title:
    'Speelt de maandelijkse prijs van een behandeling voor jou een belangrijke rol?',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly',
  options: [
    {
      value: 'faster_result_higher_cost',
      label:
        'Ik wil graag sneller resultaat en sta open voor hogere maandelijkse kosten'
    },
    {
      value: 'lower_cost_slower_pace',
      label:
        'Ik vind lagere maandelijkse kosten belangrijk en kies liever voor een rustiger tempo'
    }
  ]
},
{
  id: 'weekly_lower_cost_treatment_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Geef aan waar je voorkeur naar uit gaat:',
  help:
    'Op dit moment kunnen we twee behandelopties aanbieden, namelijk Wegovy® en Ozempic®. Beide bevatten dezelfde werkzame stof, maar verschillen in toepassing. Wegovy® is specifiek bedoeld voor gewichtsverlies. Ozempic® is in principe bedoeld voor volwassenen met type 2 diabetes en wordt in sommige situaties off-label gebruikt voor gewichtsverlies. De prijzen van beide behandelingen zijn nagenoeg gelijk.',
  condition: () =>
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ),
  options: [
    {
      value: 'wegovy',
      label: addLowestPriceToLabel(
        'Wegovy® lijkt het beste bij mijn situatie te passen',
        root.dataset.wegovyLowestPrice
      )
    },
    {
      value: 'ozempic',
      label: addLowestPriceToLabel(
        'Ozempic® lijkt het beste bij mijn situatie te passen',
        root.dataset.ozempicLowestPrice
      )
    }
  ]
},
{
  id: 'mounjaro_2_5_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'mounjaro_2_5',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'faster_result_higher_cost'
},
{
  id: 'wegovy_0_25_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_25',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    answers.weekly_lower_cost_treatment_preference ===
      'wegovy'
},
{
  id: 'ozempic_0_25_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_25',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    answers.weekly_lower_cost_treatment_preference ===
      'ozempic'
},
{
  id: 'switch_wegovy_0_25_to_ozempic_0_25',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_25',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '0_25_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_0_5_to_ozempic_0_5',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_5',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '0_5_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_1_to_ozempic_1',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_1',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '1_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_high_dose_to_ozempic_2',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_2',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    ['1_7_mg', '2_4_mg'].includes(
      answers.wegovy_current_dosage
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_0_25_to_wegovy_0_25',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_25',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '0_25_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_0_5_to_wegovy_0_5',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_5',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '0_5_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_1_to_wegovy_1',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_1',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '1_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_2_to_wegovy_1_7',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_1_7',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '2_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'lsp_consent',
  section: 'treatment',
  condition: () =>
    Boolean(selectedTreatment) &&
    isNetherlands,
  type: 'radio',
  title:
    'Geef je toestemming voor het delen van je medische gegevens via het Landelijk Schakelpunt?',
  help:
    'Het LSP (Landelijk Schakelpunt) is een beveiligd netwerk waarmee je arts en apotheek relevante medische gegevens kunnen uitwisselen. Met jouw toestemming kunnen zij je belangrijkste medische gegevens en medicatieoverzicht raadplegen. Dit helpt om te controleren of de behandeling veilig bij jouw situatie past. Let op: geef je geen toestemming, dan kan de apotheek je behandeling mogelijk niet uitleveren of kan er vertraging ontstaan.',
  defaultValue: 'yes',
    options: [
    {
      value: 'yes',
      label: 'Ja, ik geef toestemming'
    },
    {
      value: 'no',
      label: 'Nee, ik geef geen toestemming'
    }
  ]
},
{
  id: 'bsn',
  section: 'treatment',
  condition: () =>
    Boolean(selectedTreatment) &&
    isNetherlands,
  type: 'bsn',
  title: 'Wat is je burgerservicenummer (BSN)?',
  help:
    'Je BSN bestaat uit 9 cijfers. Je vindt het onder andere op je paspoort, identiteitskaart of rijbewijs.'
},
{
  id: 'final_declarations',
  section: 'treatment',
  condition: () => Boolean(selectedTreatment),
  type: 'checkbox',
  title: 'Bevestig de volgende verklaringen',
  help:
    'Vink alle verklaringen aan om verder te gaan.',
  requireAll: true,
  options: [
    {
      value: 'truthful_and_complete',
      label:
        'Ik verklaar dat ik alle vragen naar waarheid en zo volledig mogelijk heb beantwoord.'
    },
    {
      value: 'doctor_review',
      label:
        'Ik begrijp dat een arts mijn aanvraag beoordeelt en dat deze beoordeling niet automatisch betekent dat een behandeling wordt voorgeschreven.'
    },
        {
      value: 'personal_use',
      label:
        'Ik verklaar dat deze aanvraag uitsluitend voor mijzelf is en dat een eventueel voorgeschreven behandeling alleen door mij wordt gebruikt.'
    },
    {
      value: 'terms_and_privacy',
      label:
        'Ik ga akkoord met de Kearty algemene voorwaarden en het privacy statement.',
      labelHtml:
        `Ik ga akkoord met de <a class="kq__answer-link" href="${escapeHtml(termsUrl)}" target="_blank" rel="noopener noreferrer">Kearty algemene voorwaarden</a> en het <a class="kq__answer-link" href="${escapeHtml(privacyUrl)}" target="_blank" rel="noopener noreferrer">privacy statement</a>.`
    }
  ]
},
];

      const previousMedicationLabels = {
        wegovy: 'Wegovy®',
        mounjaro: 'Mounjaro®',
        ozempic: 'Ozempic®',
        saxenda: 'Saxenda®',
        mysimba: 'Mysimba®',
        rybelsus: 'Rybelsus®'
      };

      const previousMedicationDosages = {
        wegovy: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '1_7_mg', label: '1,7 mg' },
          { value: '2_4_mg', label: '2,4 mg' }
        ],
        mounjaro: [
          { value: '2_5_mg', label: '2,5 mg' },
          { value: '5_mg', label: '5 mg' },
          { value: '7_5_mg', label: '7,5 mg' },
          { value: '10_mg', label: '10 mg' },
          { value: '12_5_mg', label: '12,5 mg' },
          { value: '15_mg', label: '15 mg' }
        ],
        ozempic: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '2_0_mg', label: '2 mg' }
        ],
        rybelsus: [
          { value: '1_5_mg', label: '1,5 mg' },
          { value: '4_mg', label: '4 mg' },
          { value: '9_mg', label: '9 mg' }
        ]
      };

      const medicationMonthOptions = [
        { value: '1', label: 'Januari' },
        { value: '2', label: 'Februari' },
        { value: '3', label: 'Maart' },
        { value: '4', label: 'April' },
        { value: '5', label: 'Mei' },
        { value: '6', label: 'Juni' },
        { value: '7', label: 'Juli' },
        { value: '8', label: 'Augustus' },
        { value: '9', label: 'September' },
        { value: '10', label: 'Oktober' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
      ];

      const getVisibleQuestions = () =>
        questions.filter(
          (question) =>
            typeof question.condition !== 'function' || question.condition()
        );

      const getQuestion = (questionId) =>
        questions.find((question) => question.id === questionId);

      const getFirstFinalQuestionId = () =>
        isNetherlands
          ? 'lsp_consent'
          : 'final_declarations';

      const setActiveSection = (sectionKey) => {
        const sectionOrder = ['about', 'health', 'treatment'];
        const activeIndex = sectionOrder.indexOf(sectionKey);

        root.querySelectorAll('[data-kq-progress-step]').forEach((step) => {
          const stepIndex = sectionOrder.indexOf(
            step.getAttribute('data-kq-progress-step')
          );

          step.classList.toggle('is-active', stepIndex === activeIndex);
          step.classList.toggle('is-complete', stepIndex < activeIndex);

          if (stepIndex === activeIndex) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });

        const progressFill = root.querySelector('[data-kq-progress-fill]');

        if (progressFill) {
          progressFill.style.width =
            activeIndex === 0 ? '0%' : activeIndex === 1 ? '50%' : '100%';
        }
      };

      const renderError = (message) => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = message;
        errorElement.hidden = false;
      };

      const clearError = () => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = '';
        errorElement.hidden = true;

        questionRegion
          .querySelectorAll('.has-error')
          .forEach((field) => field.classList.remove('has-error'));
      };

      const updateSelectedRows = () => {
        questionRegion
          .querySelectorAll('.kq__answer-row')
          .forEach((row) => {
            const input = row.querySelector('input');
            row.classList.toggle('is-selected', Boolean(input?.checked));
          });
      };

      const calculateAge = (day, month, year) => {
        const today = new Date();
        let age = today.getFullYear() - year;

        const birthdayPassed =
          today.getMonth() + 1 > month ||
          (today.getMonth() + 1 === month && today.getDate() >= day);

        if (!birthdayPassed) age -= 1;

        return age;
      };

      const isValidDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);

        return (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        );
      };

      const isPastDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return date < today;
      };

      const padDatePart = (value) =>
        String(value).padStart(2, '0');

      const formatDateOfBirth = (day, month, year) =>
        `${padDatePart(day)}-${padDatePart(month)}-${year}`;

      const parseDateOfBirth = (value) => {
        const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(
          String(value || '')
        );

        if (!match) return null;

        return {
          day: Number.parseInt(match[1], 10),
          month: Number.parseInt(match[2], 10),
          year: Number.parseInt(match[3], 10)
        };
      };

      const isValidBsn = (value) => {
        const bsn = String(value || '').replace(/\D/g, '');

        if (!/^\d{9}$/.test(bsn)) {
          return false;
        }

        if (bsn === '000000000') {
          return false;
        }

        const digits = bsn.split('').map(Number);

        const sum =
          digits[0] * 9 +
          digits[1] * 8 +
          digits[2] * 7 +
          digits[3] * 6 +
          digits[4] * 5 +
          digits[5] * 4 +
          digits[6] * 3 +
          digits[7] * 2 -
          digits[8];

        return sum % 11 === 0;
      };

      const renderDateQuestion = (question) => {
        const saved = parseDateOfBirth(answers[question.id]) || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__field-group">
            <div class="kq__date-grid">
              <label>
                <span class="kq__field-label">Dag</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-day"
                  maxlength="2"
                  placeholder="DD"
                  value="${escapeHtml(saved.day || '')}"
                  data-kq-date-day
                >
              </label>

              <label>
                <span class="kq__field-label">Maand</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-month"
                  maxlength="2"
                  placeholder="MM"
                  value="${escapeHtml(saved.month || '')}"
                  data-kq-date-month
                >
              </label>

              <label class="kq__date-year">
                <span class="kq__field-label">Jaar</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-year"
                  maxlength="4"
                  placeholder="JJJJ"
                  value="${escapeHtml(saved.year || '')}"
                  data-kq-date-year
                >
              </label>
            </div>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderRadioQuestion = (question) => {
        const selectedValue =
  answers[question.id] ?? question.defaultValue ?? '';

  const options = question.options
    .map(
      (option) => `
        <label class="kq__answer-row ${
          selectedValue === option.value
            ? 'is-selected'
            : ''
        }">
          <input
            type="radio"
            name="kq-${question.id}"
            value="${escapeHtml(option.value)}"
            ${selectedValue === option.value ? 'checked' : ''}
          >

          <span class="kq__answer-label">
            ${escapeHtml(option.label)}
          </span>
        </label>
      `
    )
    .join('');

  const hasOtherOption = question.options.some(
    (option) => option.value === 'other'
  );

  const otherValue =
    answers[`${question.id}_other`] || '';

  const otherVisible =
    selectedValue === 'other';

  const otherFieldHtml = hasOtherOption
    ? `
      <div
        class="kq__other-field ${
          otherVisible ? 'is-visible' : ''
        }"
        data-kq-other-field
      >
        <label>
          <span class="kq__field-label">
            Welke behandeling heb je gebruikt?
          </span>

          <input
            class="kq__field"
            type="text"
            value="${escapeHtml(otherValue)}"
            placeholder="Vul de naam van de behandeling in"
            data-kq-other-input
          >
        </label>
      </div>
    `
    : '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `
          <p class="kq__question-help">
            ${escapeHtml(question.help)}
          </p>
        `
        : ''
    }

    <div class="kq__answer-list">
      ${options}
    </div>

    ${otherFieldHtml}

    <p
      class="kq__error"
      data-kq-error
      hidden
    ></p>
  `;
};

      const renderCheckboxQuestion = (question) => {
        const selectedValues = Array.isArray(answers[question.id])
          ? answers[question.id]
          : [];

        const options = question.options
          .map(
            (option) => `
              <label class="kq__answer-row ${
                selectedValues.includes(option.value) ? 'is-selected' : ''
              }">
                <input
                  type="checkbox"
                  name="kq-${question.id}"
                  value="${escapeHtml(option.value)}"
                  ${
                    selectedValues.includes(option.value)
                      ? 'checked'
                      : ''
                  }
                >
                <span class="kq__answer-label">
                  ${
                    option.labelHtml
                      ? option.labelHtml
                      : escapeHtml(option.label)
                  }
                </span>
              </label>
            `
          )
          .join('');

        const otherValue = answers[`${question.id}_other`] || '';
        const otherVisible = selectedValues.includes('other');

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

          ${
            question.help
              ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
              : ''
          }

          <div class="kq__answer-list">
            ${options}
          </div>

          <div class="kq__other-field ${
            otherVisible ? 'is-visible' : ''
          }" data-kq-other-field>
            <label>
              <span class="kq__field-label">Anders, namelijk</span>
              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(otherValue)}"
                data-kq-other-input
              >
            </label>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };
const renderMedicationHistoryQuestion = (question) => {
  const selectedMedications = Array.isArray(
    answers.previous_weight_loss_medications
  )
    ? answers.previous_weight_loss_medications
    : [];

  const savedHistory = Array.isArray(answers[question.id])
    ? answers[question.id]
    : [];

  const monthOptionsHtml = (selectedValue = '') =>
    `
      <option value="">Kies maand</option>
      ${medicationMonthOptions
        .map(
          (month) => `
            <option
              value="${escapeHtml(month.value)}"
              ${String(selectedValue) === month.value ? 'selected' : ''}
            >
              ${escapeHtml(month.label)}
            </option>
          `
        )
        .join('')}
    `;

  const cards = selectedMedications
    .map((medicationKey) => {
      const saved =
        savedHistory.find(
          (item) => item.treatment === medicationKey
        ) || {};

      const medicationName =
        medicationKey === 'other'
          ? answers.previous_weight_loss_medications_other?.trim() ||
            'Andere medicatie'
          : previousMedicationLabels[medicationKey] || medicationKey;

      const dosageOptions =
        previousMedicationDosages[medicationKey] || null;

      const dosageNotApplicable =
        ['saxenda', 'mysimba'].includes(medicationKey);

      const dosageField = dosageNotApplicable
        ? ''
        : dosageOptions
          ? `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <select
                class="kq__field"
                data-kq-medication-dosage
              >
                <option value="">Kies dosering</option>
                ${dosageOptions
                  .map(
                    (option) => `
                      <option
                        value="${escapeHtml(option.value)}"
                        ${saved.last_dosage === option.value ? 'selected' : ''}
                      >
                        ${escapeHtml(option.label)}
                      </option>
                    `
                  )
                  .join('')}
              </select>
            </label>
          `
          : `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(saved.last_dosage || '')}"
                placeholder="Vul de dosering in"
                data-kq-medication-dosage
              >
            </label>
          `;

      const usageStatus = saved.still_using
        ? 'still_using'
        : saved.usage_status || '';

      return `
        <div
          class="kq__medication-card"
          data-kq-medication-card
          data-medication-key="${escapeHtml(medicationKey)}"
          data-medication-name="${escapeHtml(medicationName)}"
        >
          <h2 class="kq__medication-card-title">
            ${escapeHtml(medicationName)}
          </h2>

          <div class="kq__medication-fields">
            ${dosageField}

            <div>
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestart?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-start-month
                  >
                    ${monthOptionsHtml(saved.started_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.started_year || '')}"
                    data-kq-medication-start-year
                  >
                </label>
              </div>

              <p class="kq__medication-help">
                Een schatting van de maand is voldoende.
              </p>
            </div>

            <label class="kq__medication-status">
              <span class="kq__field-label">
                Gebruik je deze behandeling op dit moment nog?
              </span>

              <select
                class="kq__field"
                data-kq-medication-status
              >
                <option value="">Maak een keuze</option>
                <option
                  value="still_using"
                  ${usageStatus === 'still_using' ? 'selected' : ''}
                >
                  Ja, ik gebruik deze behandeling nog
                </option>
                <option
                  value="stopped"
                  ${usageStatus === 'stopped' ? 'selected' : ''}
                >
                  Nee, ik ben hiermee gestopt
                </option>
              </select>
            </label>

            <div
              class="kq__medication-end-date"
              data-kq-medication-end-date
              ${usageStatus === 'stopped' ? '' : 'hidden'}
            >
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestopt?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-end-month
                  >
                    ${monthOptionsHtml(saved.ended_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.ended_year || '')}"
                    data-kq-medication-end-year
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join('');

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__medication-history">
      ${cards}
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const saveMedicationHistoryDraft = (question) => {
  if (question.type !== 'medication_history') return;

  const historyItems = Array.from(
    questionRegion.querySelectorAll('[data-kq-medication-card]')
  ).map((card) => {
    const usageStatus =
      card.querySelector('[data-kq-medication-status]')?.value || '';

    const dosageField = card.querySelector(
      '[data-kq-medication-dosage]'
    );

    const item = {
      treatment: card.dataset.medicationKey || '',
      started_month:
        card.querySelector('[data-kq-medication-start-month]')?.value || '',
      started_year:
        card.querySelector('[data-kq-medication-start-year]')?.value.trim() || '',
      usage_status: usageStatus,
      still_using: usageStatus === 'still_using',
      ended_month:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-month]')?.value || ''
          : '',
      ended_year:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-year]')?.value.trim() || ''
          : ''
    };

    if (dosageField) {
      item.last_dosage = dosageField.value.trim();
    }

    return item;
  });

  answers[question.id] = historyItems;
};

const renderBsnQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group kq__bsn-field">
      <label>
        <span class="kq__field-label">
          Burgerservicenummer
        </span>

        <input
          class="kq__field"
          type="text"
          inputmode="numeric"
          maxlength="9"
          autocomplete="off"
          placeholder="123456789"
          value="${escapeHtml(savedValue)}"
          data-kq-bsn
        >
      </label>
    </div>

    <div class="kq__bsn-info">
      <span
        class="kq__bsn-info-icon"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          fill="none"
        >
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M12 10.5v6"></path>
          <circle
            cx="12"
            cy="7.5"
            r=".8"
            fill="currentColor"
            stroke="none"
          ></circle>
        </svg>
      </span>

      <div>
        <p class="kq__bsn-info-title">
          Waarom vragen we je BSN?
        </p>

        <p class="kq__bsn-info-text">
          Voor de uitvoering van medische zorg zijn de arts en apotheek wettelijk verplicht je BSN te gebruiken. Met je BSN kunnen zij controleren dat je aanvraag, medische gegevens en eventuele recept bij de juiste persoon horen.
          <br><br>
          Voor jouw veiligheid en om zorgvuldig met je gegevens om te gaan, slaat Kearty je BSN niet zelf op. Het nummer wordt alleen veilig doorgegeven aan de betrokken zorgverleners binnen jouw behandeling.
        </p>
      </div>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const renderTextareaQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group">
      <label>
        ${
          question.label
            ? `<span class="kq__field-label">${escapeHtml(question.label)}</span>`
            : ''
        }

        <textarea
          class="kq__field kq__textarea"
          rows="6"
          placeholder="${escapeHtml(question.placeholder || '')}"
          data-kq-textarea
        >${escapeHtml(savedValue)}</textarea>
      </label>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};
const treatmentProfiles = {
  saxenda: {
    summaryTitle: 'Saxenda® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Liraglutide'
      },
      {
        label: 'Toediening',
        value: 'Dagelijks als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gemiddeld gewichtsverlies',
        value:
          'In studies verloren mensen gemiddeld ongeveer 7,5% van hun lichaamsgewicht in 56 weken, in combinatie met voeding en beweging'
      },
      {
        label: 'Gebruik',
        value: 'In combinatie met voeding en beweging'
      },
      {
        label: 'Werking',
        value:
          'Werkt als GLP-1-receptoragonist en helpt de eetlust te verminderen en het verzadigingsgevoel te vergroten'
      },
      {
        label: 'Veelvoorkomende bijwerkingen',
        value: 'Misselijkheid, braken, diarree en verstopping'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Saxenda®'
  },

  mounjaro: {
    summaryTitle: 'Mounjaro® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Tirzepatide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gebruik',
        value:
          'In combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Mounjaro®'
  },

  wegovy: {
    summaryTitle: 'Wegovy® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Semaglutide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gebruik',
        value:
          'In combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Wegovy®'
  },

  ozempic: {
    summaryTitle: 'Ozempic® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Semaglutide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Geregistreerde toepassing',
        value:
          'Voor de behandeling van volwassenen met onvoldoende gereguleerde type 2-diabetes'
      },
      {
        label: 'Gebruik bij gewichtsverlies',
        value:
          'Bij gebruik voor gewichtsverlies wordt Ozempic® off-label voorgeschreven'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Ozempic®'
  },
  mysimba: {
  summaryTitle: 'Mysimba® in het kort',
  facts: [
    {
      label: 'Werkzame stoffen',
      value: 'Naltrexon en bupropion'
    },
    {
      label: 'Toediening',
      value: 'Tabletten met verlengde afgifte voor oraal gebruik'
    },
    {
      label: 'Toepassing',
      value:
        'Voor gewichtsbeheersing in combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
    },
    {
      label: 'Verkrijgbaarheid',
      value: 'Alleen op recept'
    }
  ],
  source:
    'Bron: European Medicines Agency, productinformatie Mysimba®'
},

rybelsus: {
  summaryTitle: 'Rybelsus® in het kort',
  facts: [
    {
      label: 'Werkzame stof',
      value: 'Semaglutide'
    },
    {
      label: 'Toediening',
      value: 'Eén keer per dag als tablet'
    },
    {
      label: 'Geregistreerde toepassing',
      value:
        'Voor de behandeling van volwassenen met onvoldoende gereguleerde type 2-diabetes'
    },
    {
      label: 'Gebruik bij gewichtsverlies',
      value:
        'Gebruik voor gewichtsverlies valt buiten de geregistreerde toepassing'
    },
    {
      label: 'Verkrijgbaarheid',
      value: 'Alleen op recept'
    }
  ],
  source:
    'Bron: European Medicines Agency, productinformatie Rybelsus®'
}
};

const treatmentRecommendations = {
  saxenda: {
    profile: 'saxenda',
    shopifyKey: 'saxenda',
    displayName: 'Saxenda®',
    dosage: '',
    subtitle: 'Dagelijkse injectie',
    quantity: '5 prikpennen'
  },

  mounjaro_2_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro25',
    displayName: 'Mounjaro®',
    dosage: '2,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro5',
    displayName: 'Mounjaro®',
    dosage: '5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_7_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro75',
    displayName: 'Mounjaro®',
    dosage: '7,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_10: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro10',
    displayName: 'Mounjaro®',
    dosage: '10 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_12_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro125',
    displayName: 'Mounjaro®',
    dosage: '12,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_15: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro15',
    displayName: 'Mounjaro®',
    dosage: '15 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  wegovy_0_25: {
    profile: 'wegovy',
    shopifyKey: 'wegovy025',
    displayName: 'Wegovy®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  wegovy_0_5: {
  profile: 'wegovy',
  shopifyKey: 'wegovy05',
  displayName: 'Wegovy®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1: {
  profile: 'wegovy',
  shopifyKey: 'wegovy1',
  displayName: 'Wegovy®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1_7: {
  profile: 'wegovy',
  shopifyKey: 'wegovy17',
  displayName: 'Wegovy®',
  dosage: '1,7 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_2_4: {
  profile: 'wegovy',
  shopifyKey: 'wegovy24',
  displayName: 'Wegovy®',
  dosage: '2,4 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

  ozempic_0_25: {
    profile: 'ozempic',
    shopifyKey: 'ozempic025',
    displayName: 'Ozempic®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  ozempic_0_5: {
  profile: 'ozempic',
  shopifyKey: 'ozempic05',
  displayName: 'Ozempic®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_1: {
  profile: 'ozempic',
  shopifyKey: 'ozempic1',
  displayName: 'Ozempic®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_2: {
  profile: 'ozempic',
  shopifyKey: 'ozempic2',
  displayName: 'Ozempic®',
  dosage: '2 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},
  mysimba: {
  profile: 'mysimba',
  shopifyKey: 'mysimba',
  displayName: 'Mysimba®',
  dosage: '',
  subtitle: 'Behandeling met tabletten',
  quantity: '112 tabletten'
},

rybelsus_1_5: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus15',
  displayName: 'Rybelsus®',
  dosage: '1,5 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_4: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus4',
  displayName: 'Rybelsus®',
  dosage: '4 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_9: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus9',
  displayName: 'Rybelsus®',
  dosage: '9 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
}
};

const getTreatmentDatasetValue = (shopifyKey, field) => {
  const datasetKey =
    shopifyKey +
    field.charAt(0).toUpperCase() +
    field.slice(1);

  return root.dataset[datasetKey] || '';
};

const renderTreatmentRecommendation = (question) => {
  const treatmentKey =
    typeof question.treatment === 'function'
      ? question.treatment()
      : question.treatment;

  const treatmentConfig =
    treatmentRecommendations[treatmentKey];

  if (!treatmentConfig) {
    return `
      <p class="kq__error">
        Deze behandelaanbeveling kon niet worden geladen.
      </p>
    `;
  }

  const treatmentProfile =
    treatmentProfiles[treatmentConfig.profile];

  if (!treatmentProfile) {
    return `
      <p class="kq__error">
        De informatie over deze behandeling kon niet worden geladen.
      </p>
    `;
  }

  const shopifyKey = treatmentConfig.shopifyKey;

  const shopifyProductTitle =
    getTreatmentDatasetValue(shopifyKey, 'title');

  const productPrice =
    getTreatmentDatasetValue(shopifyKey, 'price');

  const productImage =
    getTreatmentDatasetValue(shopifyKey, 'image');

  const productInfoUrl =
    getTreatmentDatasetValue(shopifyKey, 'infoUrl');

  const variantId =
    getTreatmentDatasetValue(shopifyKey, 'variantId');

  const isAvailable =
    getTreatmentDatasetValue(shopifyKey, 'available') === 'true';

  const recommendationName = [
    treatmentConfig.displayName,
    treatmentConfig.dosage
  ]
    .filter(Boolean)
    .join(' ');

  const isContinuationRecommendation =
    answers.treatment_goal === 'need_guidance';

  const recommendationTitle =
    isContinuationRecommendation
      ? 'Jouw passende vervolgstap'
      : 'Jouw behandeladvies';

  const recommendationIntro =
    isContinuationRecommendation
      ? 'Op basis van je antwoorden lijkt onderstaande dosering een passende vervolgstap binnen je huidige behandeling. De uiteindelijke medische beoordeling en verantwoordelijkheid liggen altijd bij de arts.'
      : 'Op basis van je antwoorden lijkt onderstaande behandeling het beste aan te sluiten bij jouw situatie. De uiteindelijke medische beoordeling en verantwoordelijkheid liggen altijd bij de arts.';

  const recommendationNoticeText =
    isContinuationRecommendation
      ? 'De voorgestelde vervolgstap binnen je huidige behandeling is:'
      : 'Het advies is om je behandeling voor gewichtsverlies te starten met de volgende behandeling:';

  const recommendationBadge =
    isContinuationRecommendation
      ? 'Voorgestelde vervolgstap'
      : 'Geadviseerde behandeling';

  const productTitle =
    treatmentConfig.dosage
      ? recommendationName
      : shopifyProductTitle || treatmentConfig.displayName;

  const canApply =
    Boolean(variantId) && isAvailable;

  const applyButtonLabel = canApply
    ? 'Behandeling aanvragen'
    : 'Tijdelijk niet beschikbaar';

  const applyButtonDisabled = canApply
    ? ''
    : 'disabled';

  const imageHtml = productImage
    ? `
      <img
        src="${escapeHtml(productImage)}"
        alt="${escapeHtml(productTitle)}"
        loading="lazy"
      >
    `
    : '';

  const factsHtml = treatmentProfile.facts
    .map(
      (fact) => `
        <div class="kq__treatment-fact">
          <dt>${escapeHtml(fact.label)}</dt>
          <dd>${escapeHtml(fact.value)}</dd>
        </div>
      `
    )
    .join('');

  return `
    <div class="kq__recommendation">
      <h1 class="kq__question-title">
        ${escapeHtml(recommendationTitle)}
      </h1>

      <p class="kq__recommendation-intro">
        ${escapeHtml(recommendationIntro)}
      </p>

      <div class="kq__recommendation-notice">
        <span
          class="kq__recommendation-check"
          aria-hidden="true"
        >
          ✓
        </span>

        <p>
          ${escapeHtml(recommendationNoticeText)}
          <strong>${escapeHtml(recommendationName)}</strong>
        </p>
      </div>

      <div class="kq__product-card">
        <div class="kq__product-image">
          ${imageHtml}
        </div>

        <div class="kq__product-content">
          <span class="kq__product-badge">
            ${escapeHtml(recommendationBadge)}
          </span>

          <h2 class="kq__product-title">
            ${escapeHtml(productTitle)}
          </h2>

          <p class="kq__product-subtitle">
            ${escapeHtml(treatmentConfig.subtitle)}
          </p>

          ${
            productPrice
              ? `
                <p class="kq__product-price">
                  ${escapeHtml(productPrice)}
                </p>
              `
              : ''
          }

         ${
  treatmentConfig.quantity
    ? `
      <p class="kq__product-quantity">
        ${escapeHtml(treatmentConfig.quantity)}
      </p>
    `
    : ''
}

          <button
            type="button"
            class="kq__product-cta"
            data-kq-treatment-select
            data-treatment="${escapeHtml(treatmentKey)}"
            data-variant-id="${escapeHtml(variantId)}"
            ${applyButtonDisabled}
          >
            ${escapeHtml(applyButtonLabel)}
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <div class="kq__treatment-summary">
        <h2 class="kq__treatment-summary-title">
          ${escapeHtml(treatmentProfile.summaryTitle)}
        </h2>

        <dl class="kq__treatment-facts">
          ${factsHtml}
        </dl>

        <p class="kq__treatment-source">
          ${escapeHtml(treatmentProfile.source)}
        </p>
      </div>

      <div class="kq__recommendation-actions">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-treatment-select
          data-treatment="${escapeHtml(treatmentKey)}"
          data-variant-id="${escapeHtml(variantId)}"
          ${applyButtonDisabled}
        >
          ${escapeHtml(applyButtonLabel)}
          <span aria-hidden="true">→</span>
        </button>

        ${
          productInfoUrl
            ? `
              <a
                href="${escapeHtml(productInfoUrl)}"
                class="kq__status-button kq__status-button--secondary"
              >
                Meer informatie
                <span aria-hidden="true">→</span>
              </a>
            `
            : ''
        }
      </div>

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>
    </div>
  `;
};
      const renderMeasurementsQuestion = (question) => {
      const saved = answers[question.id] || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__measurement-list">
            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Hoe lang ben je?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="numeric"
                min="120"
                max="230"
                step="1"
                value="${escapeHtml(saved.height || '')}"
                data-kq-height
              >
              <span class="kq__measurement-unit">cm</span>
            </label>

            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Wat is je huidige gewicht?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="decimal"
                min="35"
                max="350"
                step="0.1"
                value="${escapeHtml(saved.weight || '')}"
                data-kq-weight
              >
              <span class="kq__measurement-unit">kg</span>
            </label>
          </div>

          <div class="kq__bmi-result" data-kq-bmi-result>
            <p class="kq__bmi-value" data-kq-bmi-value></p>
            <p class="kq__bmi-description" data-kq-bmi-description></p>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderQuestion = () => {
  statusScreen = null;

  const question = getQuestion(currentQuestionId);

  if (!question) return;

  setActiveSection(question.section || 'about');

  if (question.type === 'date') {
    questionRegion.innerHTML = renderDateQuestion(question);
  }

  if (question.type === 'radio') {
    questionRegion.innerHTML = renderRadioQuestion(question);
  }

  if (question.type === 'checkbox') {
    questionRegion.innerHTML = renderCheckboxQuestion(question);
  }

  if (question.type === 'medication_history') {
    questionRegion.innerHTML =
      renderMedicationHistoryQuestion(question);
  }

  if (question.type === 'bsn') {
    questionRegion.innerHTML = renderBsnQuestion(question);
  }

  if (question.type === 'textarea') {
    questionRegion.innerHTML = renderTextareaQuestion(question);
  }

  if (question.type === 'treatment_recommendation') {
  questionRegion.innerHTML =
    renderTreatmentRecommendation(question);
  }

  if (question.type === 'measurements') {
    questionRegion.innerHTML = renderMeasurementsQuestion(question);
  }

  if (question.type !== 'treatment_recommendation') {
    shownQuestions.set(question.id, {
      id: question.id,
      type: question.type === 'bsn' ? 'textarea' : question.type,
      question: question.title,
      help: question.help ?? null,
      answers: question.options
        ? Object.fromEntries(
            question.options.map((option) => [option.value, option.label])
          )
        : null,
      ...(question.type === 'medication_history' ? { subquestions: [] } : {})
    });
  }

  backButton.hidden = history.length === 0;

if (question.type === 'treatment_recommendation') {
  nextButton.hidden = true;
} else {
  nextButton.hidden = false;
  nextButton.innerHTML =
    'Verder <span aria-hidden="true">→</span>';

  bindQuestionEvents(question);
}

  if (question.type === 'measurements') {
    updateBmiPreview();
  }
};

    const renderStatus = ({
  title,
  message,
  type = 'stop',
  nextQuestionId = null,
  nextSection = null,
  nextButtonLabel = null
}) => {
  statusScreen = {
    title,
    message,
    type,
    nextQuestionId,
    nextSection,
    nextButtonLabel
  };

  const isAboutComplete =
    type === 'complete' &&
    nextSection === 'health';

  const isHealthComplete =
    type === 'complete' &&
    nextSection === 'treatment';

  const isOtherTreatment =
    type === 'other_treatment';

  const isConsentIntro =
    type === 'consent_intro';

  const isCheckoutReady =
    type === 'checkout_ready';

  const stopActions =
    type === 'stop'
      ? `
        <div class="kq__status-actions">
          <a
            class="kq__status-button kq__status-button--secondary"
            href="${escapeHtml(homeUrl)}"
          >
            Naar de homepage
          </a>

          <a
            class="kq__status-button kq__status-button--primary"
            href="${escapeHtml(contactUrl)}"
          >
            Neem contact op
            <span aria-hidden="true">→</span>
          </a>
        </div>
      `
      : '';

  const aboutCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent al goed op weg!
          </p>

          <p class="kq__status-motivation-text">
            Samen zetten we de volgende stap naar de behandeling die bij jou past.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <path
                d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"
              ></path>
              <rect
                x="9"
                y="10.5"
                width="6"
                height="5"
                rx="1"
              ></rect>
              <path d="M10.5 10.5V9a1.5 1.5 0 0 1 3 0v1.5"></path>
            </svg>
          </span>

          <p>100% vertrouwelijk en veilig</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>

          <p>Slechts enkele minuten</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path
                d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"
              ></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>

          <p>Beoordeeld door een arts</p>
        </div>
      </div>
    </div>
  `;

  const healthCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete kq__status-card--health-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent bijna bij je behandeladvies
          </p>

          <p class="kq__status-motivation-text">
            Met je laatste antwoorden kunnen we beter inschatten welke behandeling of vervolgstap bij jouw situatie kan passen.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <path d="M4 7h10"></path>
              <path d="M18 7h2"></path>
              <circle cx="16" cy="7" r="2"></circle>
              <path d="M4 12h3"></path>
              <path d="M11 12h9"></path>
              <circle cx="9" cy="12" r="2"></circle>
              <path d="M4 17h8"></path>
              <path d="M16 17h4"></path>
              <circle cx="14" cy="17" r="2"></circle>
            </svg>
          </span>

          <p>Afgestemd op jouw situatie</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>

          <p>Nog enkele korte vragen</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path
                d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"
              ></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>

          <p>Altijd beoordeeld door een BIG geregistreerde arts</p>
        </div>
      </div>
    </div>
  `;
  
  const consentIntroText = isNetherlands
    ? 'Voordat je verdergaat naar betalen, vragen we nog om toestemming voor gegevensuitwisseling via het LSP, je BSN en een laatste bevestiging van je antwoorden. Nieuw bij Kearty? Dan rond je na de betaling eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.'
    : 'Voordat je verdergaat naar betalen, vragen we nog om een laatste bevestiging van je antwoorden. Nieuw bij Kearty? Dan rond je na de betaling eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.';

  const consentIntroContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"></path>
            <path d="m9 12 2 2 4-4"></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Bijna klaar
          </p>

          <p class="kq__status-motivation-text">
            ${escapeHtml(consentIntroText)}
          </p>
        </div>
      </div>
    </div>
  `;
  
  const selectedTreatmentConfig =
    treatmentRecommendations[selectedTreatment] || null;

  const selectedTreatmentName = selectedTreatmentConfig
    ? [
        selectedTreatmentConfig.displayName,
        selectedTreatmentConfig.dosage
      ]
        .filter(Boolean)
        .join(' ')
    : '';

  const startBenefitTreatments = new Set([
    'wegovy_0_25',
    'ozempic_0_25',
    'mounjaro_2_5'
  ]);

  const showStartBenefit =
    startBenefitTreatments.has(selectedTreatment);

  const startBenefitContent = showStartBenefit
    ? `
      <div class="kq__start-benefit" data-kq-start-benefit>
        <span class="kq__start-benefit-icon" aria-hidden="true">€</span>

        <div>
          <p class="kq__start-benefit-title">
            €100 startvoordeel voor nieuwe klanten
          </p>

          <p class="kq__start-benefit-text">
            Ben je nieuw bij Kearty? Dan ontvang je €100 startvoordeel op je eerste behandeling.
          </p>
        </div>

        <div class="kq__start-benefit-note">
          <span class="kq__start-benefit-check" aria-hidden="true">✓</span>
          <span>
            Het startvoordeel wordt tijdens de checkout zichtbaar zodra je je gegevens invult.
          </span>
        </div>
      </div>
    `
    : '';

  const checkoutReadyContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${
        selectedTreatmentName
          ? `
            <div class="kq__recommendation-notice" style="margin-top: 28px; text-align: left;">
              <span
                class="kq__recommendation-check"
                aria-hidden="true"
              >
                ✓
              </span>

              <p>
                Je vraagt aan: <strong>${escapeHtml(selectedTreatmentName)}</strong>
              </p>
            </div>
          `
          : ''
      }

      <div class="kq__status-actions kq__checkout-actions">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-final-checkout
          data-kq-treatment-apply
          data-treatment="${escapeHtml(selectedTreatment)}"
          data-variant-id="${escapeHtml(selectedVariantId)}"
        >
          Behandeling aanvragen
          <span aria-hidden="true">→</span>
        </button>

        <button
          type="button"
          class="kq__status-button kq__status-button--secondary kq__calendly-button"
          data-kq-calendly
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <rect x="4" y="5.5" width="16" height="14" rx="2"></rect>
            <path d="M8 3.5v4"></path>
            <path d="M16 3.5v4"></path>
            <path d="M4 9.5h16"></path>
          </svg>
          Adviesgesprek inplannen
        </button>
      </div>

      <p class="kq__calendly-copy">
        <strong>Liever eerst persoonlijk contact?</strong> Plan dan een gratis telefonisch gesprek van 10 minuten met Kearty. We leggen je graag uit hoe Kearty werkt, nemen je mee in het aanvraagproces en helpen je verder met je vragen.
      </p>

      <p
        class="kq__error kq__calendly-error"
        data-kq-calendly-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>

      ${startBenefitContent}

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>
    </div>
  `;
  
  const otherTreatmentContent = `
  <div class="kq__status-card">
    <h1 class="kq__status-title">
      ${escapeHtml(title)}
    </h1>

    <p class="kq__status-message">
      ${escapeHtml(message)}
    </p>

    <div class="kq__status-actions">
      <button
        type="button"
        class="kq__status-button kq__status-button--primary"
        data-kq-switch-from-other
      >
        Ik wil een andere behandeling overwegen
        <span aria-hidden="true">→</span>
      </button>

      <a
        class="kq__status-button kq__status-button--secondary"
        href="${escapeHtml(contactUrl)}"
      >
        Neem contact op
      </a>
    </div>
  </div>
`;

  const defaultStatusContent = `
    <div class="kq__status-card">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${stopActions}
    </div>
  `;

  questionRegion.innerHTML =
  isAboutComplete
    ? aboutCompleteContent
    : isHealthComplete
      ? healthCompleteContent
      : isConsentIntro
        ? consentIntroContent
        : isCheckoutReady
          ? checkoutReadyContent
          : isOtherTreatment
            ? otherTreatmentContent
            : defaultStatusContent;

  if (isOtherTreatment) {
  setActiveSection('treatment');
}

  if (
    type === 'complete' ||
    type === 'consent_intro'
  ) {
    setActiveSection(nextSection || 'health');

    nextButton.hidden = false;
    nextButton.innerHTML = `
      ${escapeHtml(nextButtonLabel || 'Verder')}
      <span aria-hidden="true">→</span>
    `;
  } else {
    nextButton.hidden = true;
  }
};

      const updateBmiPreview = () => {
        const heightInput = questionRegion.querySelector('[data-kq-height]');
        const weightInput = questionRegion.querySelector('[data-kq-weight]');
        const result = questionRegion.querySelector('[data-kq-bmi-result]');
        const valueElement = questionRegion.querySelector(
          '[data-kq-bmi-value]'
        );
        const descriptionElement = questionRegion.querySelector(
          '[data-kq-bmi-description]'
        );

        if (
          !heightInput ||
          !weightInput ||
          !result ||
          !valueElement ||
          !descriptionElement
        ) {
          return;
        }

        const height = Number.parseFloat(heightInput.value);
        const weight = Number.parseFloat(weightInput.value);

        if (!height || !weight || height <= 0 || weight <= 0) {
          result.classList.remove('is-visible');
          return;
        }

        const bmi = weight / Math.pow(height / 100, 2);
        const roundedBmi = bmi.toFixed(1);

      valueElement.textContent = `Jouw BMI is ${roundedBmi}`;

result.classList.remove('is-stop');

let bmiCategory = '';

if (bmi < 19) {
  bmiCategory = 'ondergewicht';
} else if (bmi < 25) {
  bmiCategory = 'gezond gewicht';
} else if (bmi < 30) {
  bmiCategory = 'overgewicht';
} else if (bmi < 35) {
  bmiCategory = 'obesitas';
} else if (bmi < 40) {
  bmiCategory = 'ernstige obesitas';
} else {
  bmiCategory = 'zeer ernstige obesitas';
}

descriptionElement.textContent =
  `Je BMI valt in de categorie ${bmiCategory}.`;

if (bmi < 25) {
  result.classList.add('is-stop');
}

result.classList.add('is-visible');
      };

      const bindQuestionEvents = (question) => {
        clearError();

        if (question.type === 'medication_history') {
          questionRegion
            .querySelectorAll(
              '[data-kq-medication-dosage], [data-kq-medication-start-month], [data-kq-medication-start-year], [data-kq-medication-status], [data-kq-medication-end-month], [data-kq-medication-end-year]'
            )
            .forEach((field) => {
              const eventName =
                field.tagName === 'SELECT' ? 'change' : 'input';

              field.addEventListener(eventName, () => {
                if (
                  field.matches(
                    '[data-kq-medication-start-year], [data-kq-medication-end-year]'
                  )
                ) {
                  field.value = field.value
                    .replace(/\D/g, '')
                    .slice(0, 4);
                }

                if (field.matches('[data-kq-medication-status]')) {
                  const card = field.closest(
                    '[data-kq-medication-card]'
                  );
                  const endDate = card?.querySelector(
                    '[data-kq-medication-end-date]'
                  );

                  if (endDate) {
                    endDate.hidden = field.value !== 'stopped';
                  }

                  if (field.value !== 'stopped' && card) {
                    const endMonth = card.querySelector(
                      '[data-kq-medication-end-month]'
                    );
                    const endYear = card.querySelector(
                      '[data-kq-medication-end-year]'
                    );

                    if (endMonth) endMonth.value = '';
                    if (endYear) endYear.value = '';
                  }
                }

                field.classList.remove('has-error');
                saveMedicationHistoryDraft(question);
                clearError();
              });
            });
        }

        questionRegion
  .querySelectorAll('input[type="radio"]')
  .forEach((input) => {
    input.addEventListener('change', () => {
      answers[question.id] = input.value;

      const otherField = questionRegion.querySelector(
        '[data-kq-other-field]'
      );

      const otherInput = questionRegion.querySelector(
        '[data-kq-other-input]'
      );

      otherField?.classList.toggle(
        'is-visible',
        input.value === 'other'
      );

      if (input.value === 'other') {
        otherInput?.focus();
      }

      updateSelectedRows();
      clearError();
    });
  });

        questionRegion
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            input.addEventListener('change', () => {
              const selectedInputs = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              );

              if (
                input.checked &&
                question.exclusiveValues?.includes(input.value)
              ) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    otherInput.checked = otherInput === input;
                  });
              } else if (input.checked) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    if (
                      question.exclusiveValues?.includes(otherInput.value)
                    ) {
                      otherInput.checked = false;
                    }
                  });
              }

              answers[question.id] = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              ).map((checkedInput) => checkedInput.value);

              const otherField = questionRegion.querySelector(
                '[data-kq-other-field]'
              );

              otherField?.classList.toggle(
                'is-visible',
                answers[question.id].includes('other')
              );

              updateSelectedRows();
              clearError();
            });
          });

        const bsnInput = questionRegion.querySelector(
          '[data-kq-bsn]'
        );

        bsnInput?.addEventListener('input', () => {
          bsnInput.value = bsnInput.value
            .replace(/\D/g, '')
            .slice(0, 9);

          clearError();
        });

        const dateInputs = Array.from(
  questionRegion.querySelectorAll(
    '[data-kq-date-day], [data-kq-date-month], [data-kq-date-year]'
  )
);

dateInputs.forEach((input, index) => {
  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '');

    const maxLength = Number.parseInt(
      input.getAttribute('maxlength'),
      10
    );

    if (
      input.value.length === maxLength &&
      dateInputs[index + 1]
    ) {
      dateInputs[index + 1].focus();
    }

    clearError();
  });

  input.addEventListener('keydown', (event) => {
    if (
      event.key === 'Backspace' &&
      input.value === '' &&
      dateInputs[index - 1]
    ) {
      dateInputs[index - 1].focus();
    }
  });
});

        questionRegion
          .querySelectorAll('[data-kq-height], [data-kq-weight]')
          .forEach((input) => {
            input.addEventListener('input', () => {
              updateBmiPreview();
              clearError();
            });
          });

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          textarea?.addEventListener('input', () => {
            answers[question.id] = textarea.value;
            textarea.classList.remove('has-error');
            clearError();
          });
        }

        questionRegion
          .querySelector('[data-kq-other-input]')
          ?.addEventListener('input', (event) => {
            answers[`${question.id}_other`] = event.target.value;
            clearError();
          });
      };

      const validateCurrentQuestion = () => {
        clearError();

        const question = getQuestion(currentQuestionId);

        if (!question) return false;

        if (question.type === 'date') {
  const dayInput = questionRegion.querySelector('[data-kq-date-day]');
  const monthInput = questionRegion.querySelector(
    '[data-kq-date-month]'
  );
  const yearInput = questionRegion.querySelector(
    '[data-kq-date-year]'
  );

  const day = Number.parseInt(dayInput.value, 10);
  const month = Number.parseInt(monthInput.value, 10);
  const year = Number.parseInt(yearInput.value, 10);

  if (!day || !month || !year) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul je volledige geboortedatum in.');
    return false;
  }

  if (!isValidDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geldige geboortedatum in.');
    return false;
  }

  if (!isPastDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geboortedatum in het verleden in.');
    return false;
  }

  const age = calculateAge(day, month, year);

  answers[question.id] = formatDateOfBirth(day, month, year);

  if (age < 18) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
    });

    return false;
  }

  if (age > 76) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
    });

    return false;
  }

  return true;
}

        if (question.type === 'bsn') {
          const bsnInput = questionRegion.querySelector(
            '[data-kq-bsn]'
          );

          const bsn = bsnInput?.value
            .replace(/\D/g, '')
            .trim() || '';

          if (bsn.length !== 9) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Vul je BSN van 9 cijfers in.'
            );

            return false;
          }

          if (!isValidBsn(bsn)) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Dit lijkt geen geldig BSN. Controleer de 9 cijfers en probeer het opnieuw.'
            );

            return false;
          }

          answers[question.id] = bsn;

          return true;
        }

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          const value = textarea?.value.trim() || '';

          // Synchronize the latest DOM value before validation/navigation.
          answers[question.id] = value;

          if (!value && question.required !== false) {
            textarea?.classList.add('has-error');

            renderError(
              question.errorMessage ||
                'Vul de gevraagde informatie in om verder te gaan.'
            );

            return false;
          }

          return true;
        }

        if (question.type === 'radio') {
  const checkedInput = questionRegion.querySelector(
    'input[type="radio"]:checked'
  );

  if (!checkedInput) {
    renderError('Kies één antwoord om verder te gaan.');
    return false;
  }

  answers[question.id] = checkedInput.value;

  if (checkedInput.value === 'other') {
    const otherInput = questionRegion.querySelector(
      '[data-kq-other-input]'
    );

    const otherValue =
      otherInput?.value.trim() || '';

    if (!otherValue) {
      otherInput?.classList.add('has-error');

      renderError(
        'Vul bij “Anders, namelijk” de naam van de behandeling in.'
      );

      return false;
    }

    answers[`${question.id}_other`] = otherValue;
  }

  return true;
}

        if (question.type === 'checkbox') {
          const checkedInputs = Array.from(
            questionRegion.querySelectorAll(
              'input[type="checkbox"]:checked'
            )
          );

          if (checkedInputs.length === 0) {
  renderError(
    question.requireAll
      ? 'Vink alle verklaringen aan om verder te gaan.'
      : 'Kies minimaal één antwoord om verder te gaan.'
  );

  return false;
}

if (
  question.requireAll &&
  checkedInputs.length !== question.options.length
) {
  renderError('Vink alle verklaringen aan om verder te gaan.');
  return false;
}

answers[question.id] = checkedInputs.map(
  (input) => input.value
);

if (question.id === 'previous_weight_loss_attempts') {
  if (!answers[question.id].includes('weight_loss_medication')) {
    delete answers.previous_weight_loss_medications;
    delete answers.previous_weight_loss_medications_other;
    delete answers.previous_weight_loss_medication_details;
  }
}

if (question.id === 'previous_weight_loss_medications') {
  const selectedTreatments = answers[question.id];

  if (!selectedTreatments.includes('other')) {
    delete answers.previous_weight_loss_medications_other;
  }

  if (
    Array.isArray(answers.previous_weight_loss_medication_details)
  ) {
    answers.previous_weight_loss_medication_details =
      answers.previous_weight_loss_medication_details.filter(
        (item) => selectedTreatments.includes(item.treatment)
      );
  }
}

          if (
            answers[question.id].includes('other') &&
            !questionRegion
              .querySelector('[data-kq-other-input]')
              ?.value.trim()
          ) {
            renderError('Vul bij “Anders, namelijk” een korte toelichting in.');
            return false;
          }

          return true;
        }

        if (question.type === 'medication_history') {
          const cards = Array.from(
            questionRegion.querySelectorAll(
              '[data-kq-medication-card]'
            )
          );

          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;
          const validatedHistory = [];

          const markError = (field) => {
            field?.classList.add('has-error');
          };

          const isValidMonthYear = (month, year) => {
            return (
              month >= 1 &&
              month <= 12 &&
              year >= 1900 &&
              year <= currentYear
            );
          };

          const isFutureMonth = (month, year) => {
            return (
              year > currentYear ||
              (year === currentYear && month > currentMonth)
            );
          };

          for (const card of cards) {
            const treatment = card.dataset.medicationKey || '';
            const medicationName =
              card.dataset.medicationName || treatment;

            const dosageField = card.querySelector(
              '[data-kq-medication-dosage]'
            );
            const startMonthField = card.querySelector(
              '[data-kq-medication-start-month]'
            );
            const startYearField = card.querySelector(
              '[data-kq-medication-start-year]'
            );
            const statusField = card.querySelector(
              '[data-kq-medication-status]'
            );
            const endMonthField = card.querySelector(
              '[data-kq-medication-end-month]'
            );
            const endYearField = card.querySelector(
              '[data-kq-medication-end-year]'
            );

            const lastDosage = dosageField?.value.trim() || '';
            const startedMonth = Number.parseInt(
              startMonthField?.value || '',
              10
            );
            const startedYear = Number.parseInt(
              startYearField?.value || '',
              10
            );
            const usageStatus = statusField?.value || '';
            const stillUsing = usageStatus === 'still_using';

            if (dosageField && !lastDosage) {
              markError(dosageField);
              renderError(
                `Vul voor ${medicationName} de laatst gebruikte dosering in.`
              );
              return false;
            }

            if (
              !isValidMonthYear(startedMonth, startedYear) ||
              isFutureMonth(startedMonth, startedYear)
            ) {
              markError(startMonthField);
              markError(startYearField);
              renderError(
                `Vul voor ${medicationName} een geldige startmaand en een geldig startjaar in.`
              );
              return false;
            }

            if (!usageStatus) {
              markError(statusField);
              renderError(
                `Geef voor ${medicationName} aan of je deze behandeling nog gebruikt.`
              );
              return false;
            }

            let endedMonth = null;
            let endedYear = null;

            if (!stillUsing) {
              endedMonth = Number.parseInt(
                endMonthField?.value || '',
                10
              );
              endedYear = Number.parseInt(
                endYearField?.value || '',
                10
              );

              if (
                !isValidMonthYear(endedMonth, endedYear) ||
                isFutureMonth(endedMonth, endedYear)
              ) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `Vul voor ${medicationName} een geldige stopmaand en een geldig stopjaar in.`
                );
                return false;
              }

              const startValue = startedYear * 12 + startedMonth;
              const endValue = endedYear * 12 + endedMonth;

              if (endValue < startValue) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `De stopdatum van ${medicationName} kan niet vóór de startdatum liggen.`
                );
                return false;
              }
            }

            const historyItem = {
              treatment,
              started_month: startedMonth,
              started_year: startedYear,
              usage_status: usageStatus,
              still_using: stillUsing,
              ended_month: stillUsing ? null : endedMonth,
              ended_year: stillUsing ? null : endedYear
            };

            if (dosageField) {
              historyItem.last_dosage = lastDosage;
            }

            validatedHistory.push(historyItem);
          }

          shownQuestions.get(question.id).subquestions =
            serializeMedicationSubquestions(cards);
          answers[question.id] = validatedHistory;
          return true;
        }

        if (question.type === 'measurements') {
          const heightInput = questionRegion.querySelector('[data-kq-height]');
          const weightInput = questionRegion.querySelector('[data-kq-weight]');

          const height = Number.parseFloat(heightInput.value);
          const weight = Number.parseFloat(weightInput.value);

          if (!height || height < 120 || height > 230) {
            heightInput.classList.add('has-error');
            renderError('Vul een geldige lengte tussen 120 en 230 cm in.');
            return false;
          }

          if (!weight || weight < 35 || weight > 350) {
            weightInput.classList.add('has-error');
            renderError('Vul een geldig gewicht tussen 35 en 350 kg in.');
            return false;
          }

          const bmi = weight / Math.pow(height / 100, 2);

          answers[question.id] = {
            height,
            weight,
            bmi: Number.parseFloat(bmi.toFixed(1))
          };

          return true;
        }

        return true;
      };

      const getStopStatus = () => {
        if (currentQuestionId === 'dateOfBirth') {
          const birthDate = parseDateOfBirth(answers.dateOfBirth);

          if (!birthDate) return null;

          const age = calculateAge(
            birthDate.day,
            birthDate.month,
            birthDate.year
          );

          if (age < 18) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
            };
          }

          if (age > 76) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
            };
          }
        }

        if (currentQuestionId === 'pregnancy_status') {
          const excludedStatuses = [
            'pregnant',
            'breastfeeding',
            'trying_to_conceive'
          ];

          if (excludedStatuses.includes(answers.pregnancy_status)) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'Je hebt aangegeven dat je zwanger bent, borstvoeding geeft of probeert zwanger te worden. Daarom kun je via het huidige Kearty-traject geen gewichtsverliesbehandeling met medicatie aanvragen. Bespreek met je huisarts of behandelend arts welke ondersteuning in jouw situatie passend is.'
            };
          }
        }

        if (currentQuestionId === 'body_measurements') {
  const bmi = answers.body_measurements?.bmi;

  if (bmi < 19) {
    return {
      title: 'Op dit moment geen passende behandeling met medicatie',
      message:
        'Je BMI is lager dan 19. Op basis van deze uitkomst is een behandeling gericht op gewichtsverlies niet passend. Daarom kan Kearty je via deze route geen behandeling aanbieden. Bespreek met je huisarts welke ondersteuning in jouw situatie passend is.'
    };
  }

  if (bmi < 25) {
  return {
    title: 'Op dit moment geen passende behandeling met medicatie',
    message:
      'Je BMI valt binnen de categorie gezond gewicht. Op basis van deze uitkomst lijkt een behandeling met gewichtsverliesmedicatie op dit moment niet passend. Daarom kan Kearty je via deze route geen passende behandeling aanbieden.'
  };
}
}

if (currentQuestionId === 'pancreas_conditions') {
  const selectedConditions = Array.isArray(answers.pancreas_conditions)
    ? answers.pancreas_conditions
    : [];

  const stopValues = [
    'pancreatitis',
    'other_pancreas_condition',
    'pancreas_removed'
  ];

  const shouldStop = selectedConditions.some((value) =>
    stopValues.includes(value)
  );

  if (shouldStop) {
  return {
    type: 'stop',
    title: 'We kunnen je aanvraag niet via deze route voortzetten',
    message:
      'Je hebt aangegeven dat je een aandoening of behandeling aan de alvleesklier hebt gehad. Op basis van deze informatie kan Kearty je aanvraag niet via deze online vragenlijst voortzetten. Neem bij vragen gerust contact met ons op.'
  };
}
}

if (
  currentQuestionId === 'current_gallbladder_symptoms' &&
  answers.current_gallbladder_symptoms === 'yes'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment klachten hebt die mogelijk te maken hebben met je galblaas of galwegen. Daarom kunnen we je aanvraag niet direct via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken wat in jouw situatie de juiste vervolgstap is.'
  };
}

if (
  currentQuestionId === 'eating_disorder_current_status' &&
  answers.eating_disorder_current_status === 'current'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment last hebt van een eetstoornis of ernstige problemen met eten. Daarom kunnen we je aanvraag niet via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken welke ondersteuning in jouw situatie passend is.'
  };
}

return null;
};

      const goToNextQuestion = () => {
  const stopStatus = getStopStatus();

  if (stopStatus) {
    renderStatus(stopStatus);
    return;
  }

  if (
  currentQuestionId === 'current_or_previous_treatment' &&
  answers.treatment_goal === 'need_guidance' &&
  answers.current_or_previous_treatment === 'other'
) {
  const treatmentName =
    answers.current_or_previous_treatment_other?.trim() ||
    'de door jou ingevulde behandeling';

  renderStatus({
    type: 'other_treatment',
    title:
      'Voor deze behandeling kunnen we geen automatische vervolgstap bepalen',
    message:
      `Je hebt aangegeven dat je ${treatmentName} gebruikt. Omdat deze behandeling niet in onze vaste lijst staat, kunnen we geen passende vervolgdosis voorstellen. Je kunt een andere behandeling overwegen of contact met ons opnemen.`
  });

  return;
}

  const visibleQuestions = getVisibleQuestions();

  const currentIndex = visibleQuestions.findIndex(
    (question) => question.id === currentQuestionId
  );

  const currentQuestion = visibleQuestions[currentIndex];
  const nextQuestion = visibleQuestions[currentIndex + 1];

  const currentSection = currentQuestion?.section || 'about';

const nextSection = nextQuestion
  ? nextQuestion.section || 'about'
  : null;

  /*
   * Eerst een overgangsscherm tonen wanneer
   * het volgende onderdeel begint.
   */
  if (nextQuestion && currentSection !== nextSection) {
  if (currentSection === 'about' && nextSection === 'health') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Over jou" is afgerond',
      message:
        'In de volgende stap stellen we vragen over jouw gezondheid.',
      nextQuestionId: nextQuestion.id,
      nextSection: 'health',
      nextButtonLabel: 'Verder naar jouw gezondheid'
    });

    return;
  }

  if (currentSection === 'health' && nextSection === 'treatment') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
  'Op basis van je gezondheidssituatie lijkt het erop dat je in aanmerking kunt komen voor een behandeling. In de volgende stap kijken we welke behandeling het beste bij jouw situatie past',
      nextQuestionId: nextQuestion.id,
      nextSection: 'treatment',
      nextButtonLabel: 'Verder naar behandeladvies'
    });

    return;
  }
}

  if (currentQuestionId === 'final_declarations') {
    renderStatus({
      type: 'checkout_ready',
      title: 'Je kunt verder naar betalen',
      message:
        'Je hebt alle benodigde gegevens en bevestigingen ingevuld. Je kunt nu verder naar betalen. Nieuw bij Kearty? Dan vragen we je na de betaling om eenmalig je identiteit te bevestigen. Daarna neemt de arts je aanvraag in behandeling.'
    });

    return;
  }

  /*
   * Tijdelijke afronding zolang nog niet alle
   * gezondheidsvragen zijn toegevoegd.
   */
  if (!nextQuestion) {
    renderStatus({
      type: 'health_complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
        'Je hebt alle vragen in dit onderdeel beantwoord.'
    });

    return;
  }

  history.push(currentQuestionId);
  currentQuestionId = nextQuestion.id;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (
          statusScreen?.type === 'complete' ||
          statusScreen?.type === 'consent_intro'
        ) {
  if (statusScreen.type === 'complete' && statusScreen.nextSection === 'health') {
    root.dispatchEvent(
      new CustomEvent('kearty:about-section-complete', {
        bubbles: true,
        detail: { answers: serializeAnswers() }
      })
    );
  }

  const nextQuestionId = statusScreen.nextQuestionId;

  if (!nextQuestionId) return;

  history.push(currentQuestionId);
  currentQuestionId = nextQuestionId;
  statusScreen = null;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  return;
}

        if (!validateCurrentQuestion()) return;

        goToNextQuestion();
      });

      backButton.addEventListener('click', () => {
        if (statusScreen) {
          statusScreen = null;
          renderQuestion();
          return;
        }

        const previousQuestionId = history.pop();

        if (!previousQuestionId) return;

        currentQuestionId = previousQuestionId;
        renderQuestion();

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      helpButton.addEventListener('click', () => {
        const chatSelector = root.dataset.chatSelector?.trim();
        const helpUrl = root.dataset.helpUrl?.trim();

        if (chatSelector) {
          const chatLauncher = document.querySelector(chatSelector);

          if (chatLauncher) {
            chatLauncher.click();
            return;
          }
        }

        const chatEvent = new CustomEvent('kearty:open-chat', {
          bubbles: true
        });

        root.dispatchEvent(chatEvent);

        if (helpUrl) {
          window.location.href = helpUrl;
        }
      });

      // The active route and rendered definitions determine the submission.
      // Only questions that are currently visible and were actually rendered are sent.
      const getSubmissionQuestions = () =>
        getVisibleQuestions().filter(
          (question) =>
            question.type !== 'treatment_recommendation' &&
            shownQuestions.has(question.id)
        );

      const serializeAnswers = () => {
        const result = {};

        getSubmissionQuestions().forEach((question) => {
          if (Object.prototype.hasOwnProperty.call(answers, question.id)) {
            result[question.id] = answers[question.id];
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));

          if (hasOtherAnswer) {
            const otherKey = `${question.id}_other`;

            if (Object.prototype.hasOwnProperty.call(answers, otherKey)) {
              result[otherKey] = answers[otherKey];
            }
          }
        });

        return structuredClone(result);
      };

      const getOtherFieldQuestionText = (question) => {
        if (question.type === 'radio') {
          return 'Welke behandeling heb je gebruikt?';
        }

        return 'Anders, namelijk';
      };

      const serializeQuestions = () => {
        const definitions = [];

        getSubmissionQuestions().forEach((question) => {
          const definition = shownQuestions.get(question.id);

          if (definition) {
            definitions.push(definition);
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));
          const otherKey = `${question.id}_other`;

          if (
            hasOtherAnswer &&
            Object.prototype.hasOwnProperty.call(answers, otherKey)
          ) {
            definitions.push({
              id: otherKey,
              type: 'textarea',
              question: getOtherFieldQuestionText(question),
              help: null,
              answers: null
            });
          }
        });

        return structuredClone(definitions);
      };

      // Composite medication_history fields must be described exactly as shown.
      // These definitions are nested under the parent question in detail.questions.
      const serializeMedicationSubquestions = (cards) =>
        cards.flatMap((card) => {
          const treatment = card.dataset.medicationKey || '';
          const medicationName = card.dataset.medicationName || treatment;
          const text = (element) =>
            element?.textContent.trim().replace(/\s+/g, ' ') || '';
          const definitions = [];

          definitions.push({
            id: `${treatment}.medication`,
            question: 'Welke medicatie heb je gebruikt?',
            type: 'select',
            answers: treatment
              ? { [treatment]: medicationName }
              : null
          });

          const dosageField = card.querySelector(
            '[data-kq-medication-dosage]'
          );

          if (dosageField) {
            const dosageDefinition = {
              id: `${treatment}.last_dosage`,
              question: 'Welke dosering gebruikte je het laatst?',
              type: dosageField.tagName === 'SELECT' ? 'select' : 'text'
            };

            if (dosageField.tagName === 'SELECT') {
              dosageDefinition.answers = Object.fromEntries(
                Array.from(dosageField.options)
                  .filter((option) => option.value !== '')
                  .map((option) => [option.value, text(option)])
              );
            }

            definitions.push(dosageDefinition);
          }

          definitions.push({
            id: `${treatment}.start_date`,
            question: 'Wanneer ben je met deze behandeling gestart?',
            type: 'month_year'
          });

          const statusField = card.querySelector(
            '[data-kq-medication-status]'
          );

          const statusDefinition = {
            id: `${treatment}.usage_status`,
            question: 'Gebruik je deze behandeling op dit moment nog?',
            type: 'select',
            answers: statusField
              ? Object.fromEntries(
                  Array.from(statusField.options)
                    .filter((option) => option.value !== '')
                    .map((option) => [option.value, text(option)])
                )
              : {
                  still_using: 'Ja, ik gebruik deze behandeling nog',
                  stopped: 'Nee, ik ben hiermee gestopt'
                }
          };

          definitions.push(statusDefinition);

          if (statusField?.value === 'stopped') {
            definitions.push({
              id: `${treatment}.end_date`,
              question: 'Wanneer ben je met deze behandeling gestopt?',
              type: 'month_year',
              condition: "usage_status === 'stopped'"
            });
          }

          return definitions;
        });

      root.addEventListener('kearty:submission-error', () => {
        submissionPending = false;
        submissionFailedDuringDispatch = true;
        root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
          button.disabled = false;
          button.innerHTML = 'Behandeling aanvragen <span aria-hidden="true">→</span>';
        });
      });

      root.addEventListener('click', (event) => {
  const switchFromOtherButton = event.target.closest(
    '[data-kq-switch-from-other]'
  );

  if (
    switchFromOtherButton &&
    root.contains(switchFromOtherButton)
  ) {
    answers.treatment_goal = 'switch_treatment';

    statusScreen = null;
    history.push(currentQuestionId);
    currentQuestionId = 'preferred_treatment_form';

    renderQuestion();

    root.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    return;
  }

  const calendlyButton = event.target.closest(
    '[data-kq-calendly]'
  );

  if (
    calendlyButton &&
    root.contains(calendlyButton)
  ) {
    event.preventDefault();

    if (calendlyButton.disabled) return;

    const calendlyError = questionRegion.querySelector(
      '[data-kq-calendly-error]'
    );
    const originalButtonHtml = calendlyButton.innerHTML;

    if (calendlyError) {
      calendlyError.hidden = true;
      calendlyError.textContent = '';
    }

    calendlyButton.disabled = true;
    calendlyButton.textContent = 'Agenda wordt geladen…';

    openCalendlyPopup()
      .catch(() => {
        if (calendlyError) {
          calendlyError.textContent =
            'De agenda kon niet worden geladen. Probeer het opnieuw of neem contact met ons op.';
          calendlyError.hidden = false;
        }
      })
      .finally(() => {
        if (calendlyButton.isConnected) {
          calendlyButton.disabled = false;
          calendlyButton.innerHTML = originalButtonHtml;
        }
      });

    return;
  }

  const finalCheckoutButton = event.target.closest(
    '[data-kq-final-checkout]'
  );

  if (
    finalCheckoutButton &&
    root.contains(finalCheckoutButton)
  ) {
    if (finalCheckoutButton.disabled || submissionPending) return;
    event.preventDefault();

    const treatment = finalCheckoutButton.dataset.treatment || '';

    const variantId = finalCheckoutButton.dataset.variantId || '';

    const errorElement = questionRegion.querySelector(
      '[data-kq-apply-error]'
    );

    if (!treatment || !/^\d+$/.test(variantId) || /^0+$/.test(variantId)) {
      if (errorElement) {
        errorElement.textContent =
          'De gekozen behandeling kon niet worden teruggevonden. Ga terug naar het behandeladvies en kies de behandeling opnieuw.';
        errorElement.hidden = false;
      }

      return;
    }

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }
    submissionFailedDuringDispatch = false;
    submissionPending = true;

    const applicationEvent = new CustomEvent(
      'kearty:treatment-apply',
      {
        bubbles: true,
        cancelable: true,
        detail: {
          treatment,
          variantId,
          answers: serializeAnswers(),
          questions: serializeQuestions(),
          questionnaireKey: 'weight-loss-flow-1',
          questionnaireVersion: '2026-10-20'
        }
      }
    );

    const eventWasNotCancelled =
      root.dispatchEvent(applicationEvent);

    if (!eventWasNotCancelled) {
      // A synchronous handler error may already have restored the buttons.
      if (!submissionFailedDuringDispatch) {
        root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
          button.disabled = true;
          button.innerHTML = 'Aanvraag wordt verwerkt…';
        });
      }
      return;
    }

    submissionPending = false;
    // Without a submission handler, keep the answers here and show an error.
    if (errorElement) {
      errorElement.textContent =
        'De aanvraagkoppeling is nog niet geactiveerd. Probeer het later opnieuw of neem contact met ons op.';
      errorElement.hidden = false;
    }

    return;
  }

  const applyButton = event.target.closest(
    '[data-kq-treatment-select]'
  );

  if (
    !applyButton ||
    !root.contains(applyButton) ||
    applyButton.disabled
  ) {
    return;
  }

  const treatment =
    applyButton.dataset.treatment || '';

  const variantId =
    applyButton.dataset.variantId || '';

  const treatmentConfig =
    treatmentRecommendations[treatment];

  const treatmentName = treatmentConfig
    ? [
        treatmentConfig.displayName,
        treatmentConfig.dosage
      ]
        .filter(Boolean)
        .join(' ')
    : 'de gekozen behandeling';

  selectedTreatment = treatment;
  selectedVariantId = variantId;

  renderStatus({
    type: 'consent_intro',
    title: 'Rond je aanvraag af',
    message:
      `Je hebt gekozen voor ${treatmentName}. Voordat je verdergaat naar betalen hebben we alleen nog een paar gegevens en bevestigingen van je nodig.`,
    nextQuestionId: getFirstFinalQuestionId(),
    nextSection: 'treatment',
    nextButtonLabel: 'Verder met afronden'
  });

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});

      renderQuestion();
    });

    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot = event.target.querySelector(
        '[data-kearty-questionnaire-flow-1]'
      );

      if (sectionRoot) {
        sectionRoot.removeAttribute('data-kq-flow-1-initialized');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kearty-questionnaire-flow-1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const questionnaireRoots = document.querySelectorAll(
      '[data-kearty-questionnaire-flow-1]:not([data-kq-flow-1-initialized])'
    );

    questionnaireRoots.forEach((root) => {
      root.setAttribute('data-kq-flow-1-initialized', 'true');

      const questionRegion = root.querySelector(
        '[data-kq-question-region]'
      );
      const form = root.querySelector('[data-kq-form]');
      const backButton = root.querySelector('[data-kq-back]');
      const nextButton = root.querySelector('[data-kq-next]');
      const helpButton = root.querySelector('[data-kq-help]');

      const homeUrl = root.dataset.homeUrl || '/';
      const contactUrl =
        root.dataset.contactUrl || '/pages/contact';
      const termsUrl =
        root.dataset.termsUrl || '/pages/algemene-voorwaarden';
      const privacyUrl =
        root.dataset.privacyUrl || '/pages/privacy-statement';

      const countryCode =
        (root.dataset.countryCode || '').toUpperCase();

      const isNetherlands = countryCode === 'NL';

      const calendlyUrl =
        'https://calendly.com/clanooij-kearty/persoonlijk-gesprek';

      const ensureCalendlyAssets = () => {
        if (
          window.Calendly &&
          typeof window.Calendly.initPopupWidget === 'function'
        ) {
          return Promise.resolve();
        }

        if (!document.querySelector('link[data-kearty-calendly-css]')) {
          const stylesheet = document.createElement('link');
          stylesheet.rel = 'stylesheet';
          stylesheet.href =
            'https://assets.calendly.com/assets/external/widget.css';
          stylesheet.setAttribute('data-kearty-calendly-css', 'true');
          document.head.appendChild(stylesheet);
        }

        return new Promise((resolve, reject) => {
          const existingScript = document.querySelector(
            'script[data-kearty-calendly-script]'
          );

          const onReady = () => {
            if (
              window.Calendly &&
              typeof window.Calendly.initPopupWidget === 'function'
            ) {
              resolve();
            } else {
              reject(new Error('Calendly is niet beschikbaar.'));
            }
          };

          if (existingScript) {
            existingScript.addEventListener('load', onReady, { once: true });
            existingScript.addEventListener('error', reject, { once: true });
            return;
          }

          const script = document.createElement('script');
          script.src =
            'https://assets.calendly.com/assets/external/widget.js';
          script.async = true;
          script.setAttribute('data-kearty-calendly-script', 'true');
          script.addEventListener('load', onReady, { once: true });
          script.addEventListener('error', reject, { once: true });
          document.head.appendChild(script);
        });
      };

      const openCalendlyPopup = async () => {
        await ensureCalendlyAssets();

        window.Calendly.initPopupWidget({
          url: calendlyUrl
        });
      };

      const escapeHtml = (value) =>
        String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');

      const addLowestPriceToLabel = (label, price) => {
        return price
          ? `${label} – vanaf ${price}`
          : label;
      };

      const answers = {};
      const history = [];
      const shownQuestions = new Map();
      let submissionPending = false;
      let submissionFailedDuringDispatch = false;

      let selectedTreatment = '';
      let selectedVariantId = '';

      const continuationTreatmentMap = {
        wegovy: {
          '0_25_mg': 'wegovy_0_5',
          '0_5_mg': 'wegovy_1',
          '1_0_mg': 'wegovy_1_7',
          '1_7_mg': 'wegovy_2_4',
          '2_4_mg': 'wegovy_2_4'
        },
        mounjaro: {
          '2_5_mg': 'mounjaro_5',
          '5_mg': 'mounjaro_7_5',
          '7_5_mg': 'mounjaro_10',
          '10_mg': 'mounjaro_12_5',
          '12_5_mg': 'mounjaro_15',
          '15_mg': 'mounjaro_15'
        },
        ozempic: {
          '0_25_mg': 'ozempic_0_5',
          '0_5_mg': 'ozempic_1',
          '1_0_mg': 'ozempic_2',
          '2_0_mg': 'ozempic_2'
        },
        rybelsus: {
          '1_5_mg': 'rybelsus_4',
          '4_mg': 'rybelsus_9',
          '9_mg': 'rybelsus_9'
        },
        saxenda: {
          default: 'saxenda'
        },
        mysimba: {
          default: 'mysimba'
        }
      };

      const getContinuationTreatmentKey = () => {
        const currentTreatment =
          answers.current_or_previous_treatment;

        if (!currentTreatment) {
          return '';
        }

        const treatmentMap =
          continuationTreatmentMap[currentTreatment];

        if (!treatmentMap) {
          return '';
        }

        if (treatmentMap.default) {
          return treatmentMap.default;
        }

        const dosageAnswerKey =
          `${currentTreatment}_current_dosage`;

        const currentDosage =
          answers[dosageAnswerKey];

        if (!currentDosage) {
          return '';
        }

        return treatmentMap[currentDosage] || '';
      };

      let currentQuestionId = 'dateOfBirth';
      let statusScreen = null;

      const questions = [
        {
          id: 'dateOfBirth',
          type: 'date',
          title: 'Wat is je geboortedatum?',
          help: 'Je geboortedatum gebruiken we om je leeftijd te bepalen en om deze op het e-recept te vermelden als de arts je aanvraag goedkeurt.'
        },
        {
          id: 'sex_at_birth',
          type: 'radio',
          title: 'Welk geslacht werd bij je geboorte geregistreerd?',
          options: [
            { value: 'male', label: 'Mannelijk' },
            { value: 'female', label: 'Vrouwelijk' },
            { value: 'intersex_or_other', label: 'Intersekse of anders' }
          ]
        },
        {
          id: 'pregnancy_status',
          type: 'radio',
          title: 'Probeer je op dit moment zwanger te worden, ben je zwanger of geef je borstvoeding?',
          condition: () => answers.sex_at_birth === 'female',
          options: [
            { value: 'pregnant', label: 'Ik ben zwanger' },
            { value: 'breastfeeding', label: 'Ik geef borstvoeding' },
            {
              value: 'trying_to_conceive',
              label: 'Ik probeer zwanger te worden'
            },
            {
              value: 'none',
              label: 'Nee, geen van bovenstaande'
            }
          ]
        },
        {
          id: 'body_measurements',
          type: 'measurements',
          title: 'Wat zijn je lengte en je gewicht?',
          help:
            'Met je lengte en huidige gewicht berekenen we automatisch je BMI.'
        },
        {
          id: 'previous_weight_loss_attempts',
          type: 'checkbox',
          title: 'Wat heb je eerder gedaan om af te vallen?',
          help: 'Je kunt meerdere antwoorden kiezen.',
          exclusiveValues: ['not_tried'],
          options: [
            {
              value: 'diet',
              label: 'Zelf mijn voeding of eetpatroon aangepast'
            },
            {
              value: 'exercise',
              label: 'Meer bewogen of gesport'
            },
            {
              value: 'dietitian',
              label:
                'Begeleiding gehad van een diëtist of voedingsdeskundige'
            },
            {
              value: 'gli',
              label: 'Een gecombineerde leefstijlinterventie (GLI) gevolgd'
            },
            {
              value: 'other_program',
              label: 'Een ander afvalprogramma of begeleidingstraject gevolgd'
            },
            {
              value: 'weight_loss_medication',
              label: 'Medicatie gebruikt om af te vallen'
            },
            {
              value: 'bariatric_surgery',
              label:
                'Een maagverkleining of andere operatie voor gewichtsverlies gehad'
            },
            {
              value: 'not_tried',
              label: 'Ik heb nog niet eerder geprobeerd af te vallen'
            },
            {
              value: 'other',
              label: 'Anders, namelijk'
            }
                    ]
        },
        {
          id: 'previous_weight_loss_medications',
          type: 'checkbox',
          title: 'Welke medicatie heb je eerder gebruikt om af te vallen?',
          help: 'Je kunt meerdere behandelingen selecteren.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_attempts) &&
            answers.previous_weight_loss_attempts.includes(
              'weight_loss_medication'
            ),
          options: [
            { value: 'wegovy', label: 'Wegovy®' },
            { value: 'mounjaro', label: 'Mounjaro®' },
            { value: 'ozempic', label: 'Ozempic®' },
            { value: 'saxenda', label: 'Saxenda®' },
            { value: 'mysimba', label: 'Mysimba®' },
            { value: 'rybelsus', label: 'Rybelsus®' },
            { value: 'other', label: 'Andere medicatie' }
          ]
        },
        {
          id: 'previous_weight_loss_medication_details',
          type: 'medication_history',
          title: 'Vertel ons iets meer over de medicatie die je hebt gebruikt',
          help:
            'Vul per behandeling de periode in waarin je deze hebt gebruikt. Waar relevant vragen we ook naar de laatst gebruikte dosering.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_medications) &&
            answers.previous_weight_loss_medications.length > 0
        },
        {
          id: 'weight_related_conditions',
          section: 'health',
          type: 'checkbox',
          title: 'Heb je één of meer van de volgende gewichtsgerelateerde aandoeningen of klachten?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'high_blood_pressure',
              label: 'Hoge bloeddruk'
            },
            {
              value: 'high_cholesterol',
              label: 'Verhoogd cholesterol of verhoogde bloedvetten'
            },
            {
              value: 'prediabetes',
              label: 'Prediabetes'
            },
            {
              value: 'type_2_diabetes',
              label: 'Diabetes type 2'
            },
            {
              value: 'type_1_or_other_diabetes',
              label: 'Diabetes type 1 of een andere vorm van diabetes'
            },
            {
              value: 'sleep_apnea',
              label: 'Slaapapneu (OSAS)'
            },
            {
              value: 'cardiovascular_disease',
              label: 'Een hart- of vaatziekte'
            },
            {
              value: 'fatty_liver',
              label: 'Leververvetting'
            },
            {
              value: 'pcos',
              label: 'PCOS'
            },
                        {
              value: 'osteoarthritis',
              label: 'Artrose aan de knie of heup'
            },
            {
              value: 'none',
              label: 'Geen van bovenstaande'
            },
            {
              value: 'other',
              label: 'Andere gewichtsgerelateerde aandoening, namelijk'
            }
          ]
        },
        {
          id: 'pancreas_conditions',
          section: 'health',
          type: 'checkbox',
          title:
            'Heb je één of meer van de volgende aandoeningen of behandelingen aan de alvleesklier gehad?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'pancreatitis',
              label: 'Een ontsteking van de alvleesklier (pancreatitis)'
            },
            {
              value: 'other_pancreas_condition',
              label: 'Een andere aandoening of afwijking aan de alvleesklier'
            },
            {
  value: 'pancreas_removed',
  label:
    'Mijn alvleesklier is gedeeltelijk of volledig verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'gallbladder_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende galblaasproblemen gehad?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'gallstones',
      label: 'Galstenen'
    },
    {
      value: 'gallbladder_inflammation',
      label: 'Een ontsteking van de galblaas'
    },
    {
  value: 'gallbladder_removed',
  label: 'Mijn galblaas is verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'current_gallbladder_symptoms',
  section: 'health',
  type: 'radio',
  title:
    'Heb je op dit moment klachten die mogelijk te maken hebben met je galblaas of galwegen?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.gallbladder_conditions
    )
      ? answers.gallbladder_conditions
      : [];

    return [
      'gallstones',
      'gallbladder_inflammation',
      'gallbladder_removed'
    ].some((value) => selectedConditions.includes(value));
  },
    options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'other_health_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende aandoeningen?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'severe_gastrointestinal_condition',
      label: 'Een ernstige maag- of darmaandoening'
    },
    {
      value: 'kidney_condition',
      label: 'Een nierziekte of verminderde nierfunctie'
    },
    {
      value: 'liver_condition',
      label: 'Een leverziekte'
    },
    {
      value: 'thyroid_condition',
      label:
        'Een schildklieraandoening, schildklierknobbels of schildklierkanker'
    },
    {
      value: 'epilepsy',
      label: 'Epilepsie of andere aanvallen'
    },
    {
      value: 'cancer',
      label: 'Kanker'
    },
    {
      value: 'other',
      label: 'Een andere ernstige of chronische aandoening'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'health_conditions_treatment_status',
  section: 'health',
  type: 'radio',
  title:
    'Word je hiervoor momenteel behandeld of is de aandoening onder controle?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.other_health_conditions
    )
      ? answers.other_health_conditions
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication',
  section: 'health',
  type: 'radio',
  title:
    'Gebruik je op dit moment medicijnen, anders dan medicatie om af te vallen?',
  help:
    'Denk ook aan medicijnen die je alleen af en toe of zo nodig gebruikt.',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication_details',
  section: 'health',
  type: 'textarea',
  title: 'Welke medicijnen gebruik je op dit moment?',
  help:
    'Vermeld per medicijn de naam, dosering en hoe vaak je het gebruikt.',
  label: 'Medicijn(en)',
  placeholder:
    'Bijvoorbeeld: Metformine 500 mg, twee keer per dag',
  condition: () => answers.current_medication === 'yes'
},
{
  id: 'medication_allergies',
  section: 'health',
  type: 'radio',
  title:
    'Ben je allergisch of overgevoelig voor medicijnen of andere stoffen?',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'medication_allergy_details',
  section: 'health',
  type: 'textarea',
  title: 'Waar ben je allergisch of overgevoelig voor?',
  help:
    'Vermeld het medicijn of de stof en beschrijf welke reactie je krijgt.',
  label: 'Allergie of overgevoeligheid',
  placeholder:
    'Bijvoorbeeld: penicilline – huiduitslag en zwelling',
  errorMessage:
    'Vul in waarvoor je allergisch of overgevoelig bent en welke reactie je krijgt.',
  condition: () => answers.medication_allergies === 'yes'
},
{
  id: 'eating_disorder_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden last gehad van een eetstoornis of ernstige problemen met eten?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'anorexia',
      label: 'Anorexia nervosa'
    },
    {
      value: 'bulimia',
      label: 'Boulimia nervosa'
    },
    {
      value: 'binge_eating',
      label: 'Eetbuien of een eetbuistoornis'
    },
    {
      value: 'other',
      label: 'Een andere eetstoornis of ernstige problemen met eten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'eating_disorder_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze eetproblemen of deze eetstoornis op dit moment nog?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.eating_disorder_history
    )
      ? answers.eating_disorder_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current',
      label: 'Ja, dit speelt op dit moment'
    },
    {
      value: 'past',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'mental_health_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden te maken gehad met psychische klachten of een psychische aandoening?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'depression',
      label: 'Depressie'
    },
    {
      value: 'anxiety_or_panic',
      label: 'Angstklachten of een paniekstoornis'
    },
    {
      value: 'bipolar_disorder',
      label: 'Een bipolaire stoornis'
    },
    {
      value: 'psychosis',
      label: 'Een psychose of schizofrenie'
    },
    {
      value: 'other',
      label: 'Een andere psychische aandoening of ernstige psychische klachten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'mental_health_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze psychische klachten op dit moment nog of word je hiervoor behandeld?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.mental_health_history
    )
      ? answers.mental_health_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current_or_treatment',
      label:
        'Ja, ik heb op dit moment klachten en/of word hiervoor behandeld'
    },
    {
      value: 'past_only',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'additional_health_information',
  section: 'health',
  type: 'textarea',
  title:
    'Is er nog iets over je gezondheid dat belangrijk kan zijn voor de beoordeling van je aanvraag?',
  help:
    'Denk aan klachten, onderzoeken, behandelingen of andere medische informatie die nog niet aan bod is gekomen.',
  label: 'Aanvullende informatie',
  placeholder: 'Vul hier eventueel een toelichting in',
  required: false
},
{
  id: 'treatment_goal',
  section: 'treatment',
  type: 'radio',
  title: 'Waar ben je op dit moment vooral naar op zoek?',
  options: [
    {
      value: 'start_treatment',
      label: 'Ik wil starten met een behandeling'
    },
    {
      value: 'need_guidance',
      label:
        'Ik wil weten wat een passende vervolgstap is binnen mijn huidige behandeling'
    },
    {
      value: 'switch_treatment',
      label: 'Ik wil een andere behandeling overwegen'
    }
  ]
},
{
  id: 'current_or_previous_treatment',
  section: 'treatment',
  type: 'radio',
  title:
    'Welke behandeling voor gewichtsverlies gebruik je op dit moment?',
  condition: () =>
    [
      'switch_treatment',
      'need_guidance'
    ].includes(answers.treatment_goal),
  options: [
    {
      value: 'wegovy',
      label: 'Wegovy®'
    },
    {
      value: 'mounjaro',
      label: 'Mounjaro®'
    },
    {
      value: 'ozempic',
      label: 'Ozempic®'
    },
    {
      value: 'saxenda',
      label: 'Saxenda®'
    },
    {
      value: 'mysimba',
      label: 'Mysimba®'
    },
    {
      value: 'rybelsus',
      label: 'Rybelsus®'
    },
    {
      value: 'other',
      label: 'Anders, namelijk'
    }
  ]
},
{
  id: 'wegovy_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Wegovy® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'wegovy',
  options: [
    {
      value: '0_25_mg',
      label: '0,25 mg'
    },
    {
      value: '0_5_mg',
      label: '0,5 mg'
    },
    {
      value: '1_0_mg',
      label: '1,0 mg'
    },
    {
      value: '1_7_mg',
      label: '1,7 mg'
    },
    {
      value: '2_4_mg',
      label: '2,4 mg'
    }
  ]
},
{
  id: 'mounjaro_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Mounjaro® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'mounjaro',
  options: [
    {
      value: '2_5_mg',
      label: '2,5 mg'
    },
    {
      value: '5_mg',
      label: '5 mg'
    },
    {
      value: '7_5_mg',
      label: '7,5 mg'
    },
    {
      value: '10_mg',
      label: '10 mg'
    },
    {
      value: '12_5_mg',
      label: '12,5 mg'
    },
    {
      value: '15_mg',
      label: '15 mg'
    }
  ]
},
{
  id: 'ozempic_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Ozempic® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'ozempic',
  options: [
    {
      value: '0_25_mg',
      label: '0,25 mg'
    },
    {
      value: '0_5_mg',
      label: '0,5 mg'
    },
    {
      value: '1_0_mg',
      label: '1,0 mg'
    },
    {
      value: '2_0_mg',
      label: '2,0 mg'
    }
  ]
},
{
  id: 'rybelsus_current_dosage',
  section: 'treatment',
  type: 'radio',
  title: 'Welke Rybelsus® dosering gebruik je nu?',
  condition: () =>
  [
    'switch_treatment',
    'need_guidance'
  ].includes(answers.treatment_goal) &&
  answers.current_or_previous_treatment === 'rybelsus',
  options: [
    {
      value: '1_5_mg',
      label: '1,5 mg'
    },
    {
      value: '4_mg',
      label: '4 mg'
    },
    {
      value: '9_mg',
      label: '9 mg'
    }
  ]
},
{
  id: 'continuation_treatment_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: () => getContinuationTreatmentKey(),
  condition: () =>
    answers.treatment_goal === 'need_guidance' &&
    Boolean(getContinuationTreatmentKey())
},
{
  id: 'preferred_treatment_form',
  section: 'treatment',
  type: 'radio',
  title:
    'Heb je op dit moment een voorkeur voor een prikpen of tabletten?',
  condition: () =>
    answers.treatment_goal === 'start_treatment' ||
    answers.treatment_goal === 'switch_treatment',
  options: [
    {
      value: 'injection_pen',
      label: 'Ik heb een voorkeur voor een prikpen'
    },
    {
      value: 'tablets',
      label: 'Ik heb een voorkeur voor tabletten'
    }
  ]
},
{
  id: 'tablet_treatment_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Geef aan waar je voorkeur naar uit gaat:',
  help:
    'Op dit moment kunnen we twee behandelopties aanbieden: Mysimba® en Rybelsus®. Deze behandelingen bevatten verschillende werkzame stoffen en verschillen in toepassing. Mysimba® is specifiek bedoeld voor gewichtsbeheersing. Rybelsus® is bedoeld voor volwassenen met type 2 diabetes en wordt in sommige situaties off label gebruikt voor gewichtsverlies.',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        )
      )
    ),
  options: [
    {
      value: 'mysimba',
      label: addLowestPriceToLabel(
        'Mysimba® lijkt het beste bij mijn situatie te passen',
        root.dataset.mysimbaLowestPrice
      )
    },
    {
      value: 'rybelsus',
      label: addLowestPriceToLabel(
        'Rybelsus® (off label) lijkt het beste bij mijn situatie te passen',
        root.dataset.rybelsusLowestPrice
      )
    }
  ]
},
{
  id: 'mysimba_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'mysimba',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      (
        answers.treatment_goal === 'start_treatment' &&
        answers.tablet_treatment_preference === 'mysimba'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        answers.current_or_previous_treatment === 'rybelsus'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        ) &&
        answers.tablet_treatment_preference === 'mysimba'
      )
    )
},
{
  id: 'rybelsus_1_5_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'rybelsus_1_5',
  condition: () =>
    answers.preferred_treatment_form === 'tablets' &&
    (
      (
        answers.treatment_goal === 'start_treatment' &&
        answers.tablet_treatment_preference === 'rybelsus'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        answers.current_or_previous_treatment === 'mysimba'
      ) ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['mysimba', 'rybelsus'].includes(
          answers.current_or_previous_treatment
        ) &&
        answers.tablet_treatment_preference === 'rybelsus'
      )
    )
},
{
  id: 'injection_frequency_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Wat heeft op dit moment jouw voorkeur?',
  help:
    'De ene behandeling gebruik je dagelijks, de andere wekelijks. Met je antwoord kunnen we beter inschatten welke optie het beste bij jouw situatie past.',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen',
  options: [
    {
      value: 'daily',
      label: 'Dagelijks gebruiken past beter bij mij'
    },
    {
      value: 'weekly',
      label: 'Wekelijks gebruiken past beter bij mij'
    }
  ]
},
{
  id: 'saxenda_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'saxenda',
  condition: () =>
    answers.treatment_goal === 'start_treatment' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'daily'
},
{
  id: 'switch_saxenda_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'saxenda',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'daily'
},
{
  id: 'weekly_injection_price_preference',
  section: 'treatment',
  type: 'radio',
  title:
    'Speelt de maandelijkse prijs van een behandeling voor jou een belangrijke rol?',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly',
  options: [
    {
      value: 'faster_result_higher_cost',
      label:
        'Ik wil graag sneller resultaat en sta open voor hogere maandelijkse kosten'
    },
    {
      value: 'lower_cost_slower_pace',
      label:
        'Ik vind lagere maandelijkse kosten belangrijk en kies liever voor een rustiger tempo'
    }
  ]
},
{
  id: 'weekly_lower_cost_treatment_preference',
  section: 'treatment',
  type: 'radio',
  title: 'Geef aan waar je voorkeur naar uit gaat:',
  help:
    'Op dit moment kunnen we twee behandelopties aanbieden, namelijk Wegovy® en Ozempic®. Beide bevatten dezelfde werkzame stof, maar verschillen in toepassing. Wegovy® is specifiek bedoeld voor gewichtsverlies. Ozempic® is in principe bedoeld voor volwassenen met type 2 diabetes en wordt in sommige situaties off-label gebruikt voor gewichtsverlies. De prijzen van beide behandelingen zijn nagenoeg gelijk.',
  condition: () =>
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ),
  options: [
    {
      value: 'wegovy',
      label: addLowestPriceToLabel(
        'Wegovy® lijkt het beste bij mijn situatie te passen',
        root.dataset.wegovyLowestPrice
      )
    },
    {
      value: 'ozempic',
      label: addLowestPriceToLabel(
        'Ozempic® lijkt het beste bij mijn situatie te passen',
        root.dataset.ozempicLowestPrice
      )
    }
  ]
},
{
  id: 'mounjaro_2_5_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'mounjaro_2_5',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      answers.treatment_goal === 'switch_treatment'
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'faster_result_higher_cost'
},
{
  id: 'wegovy_0_25_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_25',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    answers.weekly_lower_cost_treatment_preference ===
      'wegovy'
},
{
  id: 'ozempic_0_25_recommendation',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_25',
  condition: () =>
    (
      answers.treatment_goal === 'start_treatment' ||
      (
        answers.treatment_goal === 'switch_treatment' &&
        !['wegovy', 'ozempic'].includes(
          answers.current_or_previous_treatment
        )
      )
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace' &&
    answers.weekly_lower_cost_treatment_preference ===
      'ozempic'
},
{
  id: 'switch_wegovy_0_25_to_ozempic_0_25',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_25',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '0_25_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_0_5_to_ozempic_0_5',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_0_5',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '0_5_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_1_to_ozempic_1',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_1',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    answers.wegovy_current_dosage === '1_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_wegovy_high_dose_to_ozempic_2',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'ozempic_2',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'wegovy' &&
    ['1_7_mg', '2_4_mg'].includes(
      answers.wegovy_current_dosage
    ) &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_0_25_to_wegovy_0_25',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_25',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '0_25_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_0_5_to_wegovy_0_5',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_0_5',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '0_5_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_1_to_wegovy_1',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_1',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '1_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'switch_ozempic_2_to_wegovy_1_7',
  section: 'treatment',
  type: 'treatment_recommendation',
  treatment: 'wegovy_1_7',
  condition: () =>
    answers.treatment_goal === 'switch_treatment' &&
    answers.current_or_previous_treatment === 'ozempic' &&
    answers.ozempic_current_dosage === '2_0_mg' &&
    answers.preferred_treatment_form === 'injection_pen' &&
    answers.injection_frequency_preference === 'weekly' &&
    answers.weekly_injection_price_preference ===
      'lower_cost_slower_pace'
},
{
  id: 'lsp_consent',
  section: 'treatment',
  condition: () =>
    Boolean(selectedTreatment) &&
    isNetherlands,
  type: 'radio',
  title:
    'Geef je toestemming voor het delen van je medische gegevens via het Landelijk Schakelpunt?',
  help:
    'Het LSP (Landelijk Schakelpunt) is een beveiligd netwerk waarmee je arts en apotheek relevante medische gegevens kunnen uitwisselen. Met jouw toestemming kunnen zij je belangrijkste medische gegevens en medicatieoverzicht raadplegen. Dit helpt om te controleren of de behandeling veilig bij jouw situatie past. Let op: geef je geen toestemming, dan kan de apotheek je behandeling mogelijk niet uitleveren of kan er vertraging ontstaan.',
  defaultValue: 'yes',
    options: [
    {
      value: 'yes',
      label: 'Ja, ik geef toestemming'
    },
    {
      value: 'no',
      label: 'Nee, ik geef geen toestemming'
    }
  ]
},
{
  id: 'bsn',
  section: 'treatment',
  condition: () =>
    Boolean(selectedTreatment) &&
    isNetherlands,
  type: 'bsn',
  title: 'Wat is je burgerservicenummer (BSN)?',
  help:
    'Je BSN bestaat uit 9 cijfers. Je vindt het onder andere op je paspoort, identiteitskaart of rijbewijs.'
},
{
  id: 'final_declarations',
  section: 'treatment',
  condition: () => Boolean(selectedTreatment),
  type: 'checkbox',
  title: 'Bevestig de volgende verklaringen',
  help:
    'Vink alle verklaringen aan om verder te gaan.',
  requireAll: true,
  options: [
    {
      value: 'truthful_and_complete',
      label:
        'Ik verklaar dat ik alle vragen naar waarheid en zo volledig mogelijk heb beantwoord.'
    },
    {
      value: 'doctor_review',
      label:
        'Ik begrijp dat een arts mijn aanvraag beoordeelt en dat deze beoordeling niet automatisch betekent dat een behandeling wordt voorgeschreven.'
    },
        {
      value: 'personal_use',
      label:
        'Ik verklaar dat deze aanvraag uitsluitend voor mijzelf is en dat een eventueel voorgeschreven behandeling alleen door mij wordt gebruikt.'
    },
    {
      value: 'terms_and_privacy',
      label:
        'Ik ga akkoord met de Kearty algemene voorwaarden en het privacy statement.',
      labelHtml:
        `Ik ga akkoord met de <a class="kq__answer-link" href="${escapeHtml(termsUrl)}" target="_blank" rel="noopener noreferrer">Kearty algemene voorwaarden</a> en het <a class="kq__answer-link" href="${escapeHtml(privacyUrl)}" target="_blank" rel="noopener noreferrer">privacy statement</a>.`
    }
  ]
},
];

      const previousMedicationLabels = {
        wegovy: 'Wegovy®',
        mounjaro: 'Mounjaro®',
        ozempic: 'Ozempic®',
        saxenda: 'Saxenda®',
        mysimba: 'Mysimba®',
        rybelsus: 'Rybelsus®'
      };

      const previousMedicationDosages = {
        wegovy: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '1_7_mg', label: '1,7 mg' },
          { value: '2_4_mg', label: '2,4 mg' }
        ],
        mounjaro: [
          { value: '2_5_mg', label: '2,5 mg' },
          { value: '5_mg', label: '5 mg' },
          { value: '7_5_mg', label: '7,5 mg' },
          { value: '10_mg', label: '10 mg' },
          { value: '12_5_mg', label: '12,5 mg' },
          { value: '15_mg', label: '15 mg' }
        ],
        ozempic: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '2_0_mg', label: '2 mg' }
        ],
        rybelsus: [
          { value: '1_5_mg', label: '1,5 mg' },
          { value: '4_mg', label: '4 mg' },
          { value: '9_mg', label: '9 mg' }
        ]
      };

      const medicationMonthOptions = [
        { value: '1', label: 'Januari' },
        { value: '2', label: 'Februari' },
        { value: '3', label: 'Maart' },
        { value: '4', label: 'April' },
        { value: '5', label: 'Mei' },
        { value: '6', label: 'Juni' },
        { value: '7', label: 'Juli' },
        { value: '8', label: 'Augustus' },
        { value: '9', label: 'September' },
        { value: '10', label: 'Oktober' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
      ];

      const getVisibleQuestions = () =>
        questions.filter(
          (question) =>
            typeof question.condition !== 'function' || question.condition()
        );

      const getQuestion = (questionId) =>
        questions.find((question) => question.id === questionId);

      const getFirstFinalQuestionId = () =>
        isNetherlands
          ? 'lsp_consent'
          : 'final_declarations';

      const setActiveSection = (sectionKey) => {
        const sectionOrder = ['about', 'health', 'treatment'];
        const activeIndex = sectionOrder.indexOf(sectionKey);

        root.querySelectorAll('[data-kq-progress-step]').forEach((step) => {
          const stepIndex = sectionOrder.indexOf(
            step.getAttribute('data-kq-progress-step')
          );

          step.classList.toggle('is-active', stepIndex === activeIndex);
          step.classList.toggle('is-complete', stepIndex < activeIndex);

          if (stepIndex === activeIndex) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });

        const progressFill = root.querySelector('[data-kq-progress-fill]');

        if (progressFill) {
          progressFill.style.width =
            activeIndex === 0 ? '0%' : activeIndex === 1 ? '50%' : '100%';
        }
      };

      const renderError = (message) => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = message;
        errorElement.hidden = false;
      };

      const clearError = () => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = '';
        errorElement.hidden = true;

        questionRegion
          .querySelectorAll('.has-error')
          .forEach((field) => field.classList.remove('has-error'));
      };

      const updateSelectedRows = () => {
        questionRegion
          .querySelectorAll('.kq__answer-row')
          .forEach((row) => {
            const input = row.querySelector('input');
            row.classList.toggle('is-selected', Boolean(input?.checked));
          });
      };

      const calculateAge = (day, month, year) => {
        const today = new Date();
        let age = today.getFullYear() - year;

        const birthdayPassed =
          today.getMonth() + 1 > month ||
          (today.getMonth() + 1 === month && today.getDate() >= day);

        if (!birthdayPassed) age -= 1;

        return age;
      };

      const isValidDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);

        return (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        );
      };

      const isPastDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return date < today;
      };

      const padDatePart = (value) =>
        String(value).padStart(2, '0');

      const formatDateOfBirth = (day, month, year) =>
        `${padDatePart(day)}-${padDatePart(month)}-${year}`;

      const parseDateOfBirth = (value) => {
        const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(
          String(value || '')
        );

        if (!match) return null;

        return {
          day: Number.parseInt(match[1], 10),
          month: Number.parseInt(match[2], 10),
          year: Number.parseInt(match[3], 10)
        };
      };

      const isValidBsn = (value) => {
        const bsn = String(value || '').replace(/\D/g, '');

        if (!/^\d{9}$/.test(bsn)) {
          return false;
        }

        if (bsn === '000000000') {
          return false;
        }

        const digits = bsn.split('').map(Number);

        const sum =
          digits[0] * 9 +
          digits[1] * 8 +
          digits[2] * 7 +
          digits[3] * 6 +
          digits[4] * 5 +
          digits[5] * 4 +
          digits[6] * 3 +
          digits[7] * 2 -
          digits[8];

        return sum % 11 === 0;
      };

      const renderDateQuestion = (question) => {
        const saved = parseDateOfBirth(answers[question.id]) || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__field-group">
            <div class="kq__date-grid">
              <label>
                <span class="kq__field-label">Dag</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-day"
                  maxlength="2"
                  placeholder="DD"
                  value="${escapeHtml(saved.day || '')}"
                  data-kq-date-day
                >
              </label>

              <label>
                <span class="kq__field-label">Maand</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-month"
                  maxlength="2"
                  placeholder="MM"
                  value="${escapeHtml(saved.month || '')}"
                  data-kq-date-month
                >
              </label>

              <label class="kq__date-year">
                <span class="kq__field-label">Jaar</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-year"
                  maxlength="4"
                  placeholder="JJJJ"
                  value="${escapeHtml(saved.year || '')}"
                  data-kq-date-year
                >
              </label>
            </div>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderRadioQuestion = (question) => {
        const selectedValue =
  answers[question.id] ?? question.defaultValue ?? '';

  const options = question.options
    .map(
      (option) => `
        <label class="kq__answer-row ${
          selectedValue === option.value
            ? 'is-selected'
            : ''
        }">
          <input
            type="radio"
            name="kq-${question.id}"
            value="${escapeHtml(option.value)}"
            ${selectedValue === option.value ? 'checked' : ''}
          >

          <span class="kq__answer-label">
            ${escapeHtml(option.label)}
          </span>
        </label>
      `
    )
    .join('');

  const hasOtherOption = question.options.some(
    (option) => option.value === 'other'
  );

  const otherValue =
    answers[`${question.id}_other`] || '';

  const otherVisible =
    selectedValue === 'other';

  const otherFieldHtml = hasOtherOption
    ? `
      <div
        class="kq__other-field ${
          otherVisible ? 'is-visible' : ''
        }"
        data-kq-other-field
      >
        <label>
          <span class="kq__field-label">
            Welke behandeling heb je gebruikt?
          </span>

          <input
            class="kq__field"
            type="text"
            value="${escapeHtml(otherValue)}"
            placeholder="Vul de naam van de behandeling in"
            data-kq-other-input
          >
        </label>
      </div>
    `
    : '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `
          <p class="kq__question-help">
            ${escapeHtml(question.help)}
          </p>
        `
        : ''
    }

    <div class="kq__answer-list">
      ${options}
    </div>

    ${otherFieldHtml}

    <p
      class="kq__error"
      data-kq-error
      hidden
    ></p>
  `;
};

      const renderCheckboxQuestion = (question) => {
        const selectedValues = Array.isArray(answers[question.id])
          ? answers[question.id]
          : [];

        const options = question.options
          .map(
            (option) => `
              <label class="kq__answer-row ${
                selectedValues.includes(option.value) ? 'is-selected' : ''
              }">
                <input
                  type="checkbox"
                  name="kq-${question.id}"
                  value="${escapeHtml(option.value)}"
                  ${
                    selectedValues.includes(option.value)
                      ? 'checked'
                      : ''
                  }
                >
                <span class="kq__answer-label">
                  ${
                    option.labelHtml
                      ? option.labelHtml
                      : escapeHtml(option.label)
                  }
                </span>
              </label>
            `
          )
          .join('');

        const otherValue = answers[`${question.id}_other`] || '';
        const otherVisible = selectedValues.includes('other');

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

          ${
            question.help
              ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
              : ''
          }

          <div class="kq__answer-list">
            ${options}
          </div>

          <div class="kq__other-field ${
            otherVisible ? 'is-visible' : ''
          }" data-kq-other-field>
            <label>
              <span class="kq__field-label">Anders, namelijk</span>
              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(otherValue)}"
                data-kq-other-input
              >
            </label>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };
const renderMedicationHistoryQuestion = (question) => {
  const selectedMedications = Array.isArray(
    answers.previous_weight_loss_medications
  )
    ? answers.previous_weight_loss_medications
    : [];

  const savedHistory = Array.isArray(answers[question.id])
    ? answers[question.id]
    : [];

  const monthOptionsHtml = (selectedValue = '') =>
    `
      <option value="">Kies maand</option>
      ${medicationMonthOptions
        .map(
          (month) => `
            <option
              value="${escapeHtml(month.value)}"
              ${String(selectedValue) === month.value ? 'selected' : ''}
            >
              ${escapeHtml(month.label)}
            </option>
          `
        )
        .join('')}
    `;

  const cards = selectedMedications
    .map((medicationKey) => {
      const saved =
        savedHistory.find(
          (item) => item.treatment === medicationKey
        ) || {};

      const medicationName =
        medicationKey === 'other'
          ? answers.previous_weight_loss_medications_other?.trim() ||
            'Andere medicatie'
          : previousMedicationLabels[medicationKey] || medicationKey;

      const dosageOptions =
        previousMedicationDosages[medicationKey] || null;

      const dosageNotApplicable =
        ['saxenda', 'mysimba'].includes(medicationKey);

      const dosageField = dosageNotApplicable
        ? ''
        : dosageOptions
          ? `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <select
                class="kq__field"
                data-kq-medication-dosage
              >
                <option value="">Kies dosering</option>
                ${dosageOptions
                  .map(
                    (option) => `
                      <option
                        value="${escapeHtml(option.value)}"
                        ${saved.last_dosage === option.value ? 'selected' : ''}
                      >
                        ${escapeHtml(option.label)}
                      </option>
                    `
                  )
                  .join('')}
              </select>
            </label>
          `
          : `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(saved.last_dosage || '')}"
                placeholder="Vul de dosering in"
                data-kq-medication-dosage
              >
            </label>
          `;

      const usageStatus = saved.still_using
        ? 'still_using'
        : saved.usage_status || '';

      return `
        <div
          class="kq__medication-card"
          data-kq-medication-card
          data-medication-key="${escapeHtml(medicationKey)}"
          data-medication-name="${escapeHtml(medicationName)}"
        >
          <h2 class="kq__medication-card-title">
            ${escapeHtml(medicationName)}
          </h2>

          <div class="kq__medication-fields">
            ${dosageField}

            <div>
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestart?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-start-month
                  >
                    ${monthOptionsHtml(saved.started_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.started_year || '')}"
                    data-kq-medication-start-year
                  >
                </label>
              </div>

              <p class="kq__medication-help">
                Een schatting van de maand is voldoende.
              </p>
            </div>

            <label class="kq__medication-status">
              <span class="kq__field-label">
                Gebruik je deze behandeling op dit moment nog?
              </span>

              <select
                class="kq__field"
                data-kq-medication-status
              >
                <option value="">Maak een keuze</option>
                <option
                  value="still_using"
                  ${usageStatus === 'still_using' ? 'selected' : ''}
                >
                  Ja, ik gebruik deze behandeling nog
                </option>
                <option
                  value="stopped"
                  ${usageStatus === 'stopped' ? 'selected' : ''}
                >
                  Nee, ik ben hiermee gestopt
                </option>
              </select>
            </label>

            <div
              class="kq__medication-end-date"
              data-kq-medication-end-date
              ${usageStatus === 'stopped' ? '' : 'hidden'}
            >
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestopt?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-end-month
                  >
                    ${monthOptionsHtml(saved.ended_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.ended_year || '')}"
                    data-kq-medication-end-year
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join('');

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__medication-history">
      ${cards}
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const saveMedicationHistoryDraft = (question) => {
  if (question.type !== 'medication_history') return;

  const historyItems = Array.from(
    questionRegion.querySelectorAll('[data-kq-medication-card]')
  ).map((card) => {
    const usageStatus =
      card.querySelector('[data-kq-medication-status]')?.value || '';

    const dosageField = card.querySelector(
      '[data-kq-medication-dosage]'
    );

    const item = {
      treatment: card.dataset.medicationKey || '',
      started_month:
        card.querySelector('[data-kq-medication-start-month]')?.value || '',
      started_year:
        card.querySelector('[data-kq-medication-start-year]')?.value.trim() || '',
      usage_status: usageStatus,
      still_using: usageStatus === 'still_using',
      ended_month:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-month]')?.value || ''
          : '',
      ended_year:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-year]')?.value.trim() || ''
          : ''
    };

    if (dosageField) {
      item.last_dosage = dosageField.value.trim();
    }

    return item;
  });

  answers[question.id] = historyItems;
};

const renderBsnQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group kq__bsn-field">
      <label>
        <span class="kq__field-label">
          Burgerservicenummer
        </span>

        <input
          class="kq__field"
          type="text"
          inputmode="numeric"
          maxlength="9"
          autocomplete="off"
          placeholder="123456789"
          value="${escapeHtml(savedValue)}"
          data-kq-bsn
        >
      </label>
    </div>

    <div class="kq__bsn-info">
      <span
        class="kq__bsn-info-icon"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          fill="none"
        >
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M12 10.5v6"></path>
          <circle
            cx="12"
            cy="7.5"
            r=".8"
            fill="currentColor"
            stroke="none"
          ></circle>
        </svg>
      </span>

      <div>
        <p class="kq__bsn-info-title">
          Waarom vragen we je BSN?
        </p>

        <p class="kq__bsn-info-text">
          Voor de uitvoering van medische zorg zijn de arts en apotheek wettelijk verplicht je BSN te gebruiken. Met je BSN kunnen zij controleren dat je aanvraag, medische gegevens en eventuele recept bij de juiste persoon horen.
          <br><br>
          Voor jouw veiligheid en om zorgvuldig met je gegevens om te gaan, slaat Kearty je BSN niet zelf op. Het nummer wordt alleen veilig doorgegeven aan de betrokken zorgverleners binnen jouw behandeling.
        </p>
      </div>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const renderTextareaQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group">
      <label>
        ${
          question.label
            ? `<span class="kq__field-label">${escapeHtml(question.label)}</span>`
            : ''
        }

        <textarea
          class="kq__field kq__textarea"
          rows="6"
          placeholder="${escapeHtml(question.placeholder || '')}"
          data-kq-textarea
        >${escapeHtml(savedValue)}</textarea>
      </label>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};
const treatmentProfiles = {
  saxenda: {
    summaryTitle: 'Saxenda® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Liraglutide'
      },
      {
        label: 'Toediening',
        value: 'Dagelijks als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gemiddeld gewichtsverlies',
        value:
          'In studies verloren mensen gemiddeld ongeveer 7,5% van hun lichaamsgewicht in 56 weken, in combinatie met voeding en beweging'
      },
      {
        label: 'Gebruik',
        value: 'In combinatie met voeding en beweging'
      },
      {
        label: 'Werking',
        value:
          'Werkt als GLP-1-receptoragonist en helpt de eetlust te verminderen en het verzadigingsgevoel te vergroten'
      },
      {
        label: 'Veelvoorkomende bijwerkingen',
        value: 'Misselijkheid, braken, diarree en verstopping'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Saxenda®'
  },

  mounjaro: {
    summaryTitle: 'Mounjaro® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Tirzepatide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gebruik',
        value:
          'In combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Mounjaro®'
  },

  wegovy: {
    summaryTitle: 'Wegovy® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Semaglutide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Voor wie',
        value:
          'Voor volwassenen met obesitas, of met overgewicht in combinatie met minimaal 1 gewichtsgerelateerde aandoening'
      },
      {
        label: 'BMI-criteria',
        value:
          'BMI van 30 of hoger, of BMI van 27 tot 29,9 met minimaal 1 bijkomende aandoening'
      },
      {
        label: 'Gebruik',
        value:
          'In combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Wegovy®'
  },

  ozempic: {
    summaryTitle: 'Ozempic® in het kort',
    facts: [
      {
        label: 'Werkzame stof',
        value: 'Semaglutide'
      },
      {
        label: 'Toediening',
        value: 'Eén keer per week als injectie met een voorgevulde pen'
      },
      {
        label: 'Geregistreerde toepassing',
        value:
          'Voor de behandeling van volwassenen met onvoldoende gereguleerde type 2-diabetes'
      },
      {
        label: 'Gebruik bij gewichtsverlies',
        value:
          'Bij gebruik voor gewichtsverlies wordt Ozempic® off-label voorgeschreven'
      },
      {
        label: 'Verkrijgbaarheid',
        value: 'Alleen op recept'
      }
    ],
    source:
      'Bron: European Medicines Agency, productinformatie Ozempic®'
  },
  mysimba: {
  summaryTitle: 'Mysimba® in het kort',
  facts: [
    {
      label: 'Werkzame stoffen',
      value: 'Naltrexon en bupropion'
    },
    {
      label: 'Toediening',
      value: 'Tabletten met verlengde afgifte voor oraal gebruik'
    },
    {
      label: 'Toepassing',
      value:
        'Voor gewichtsbeheersing in combinatie met een caloriebeperkt voedingspatroon en meer lichaamsbeweging'
    },
    {
      label: 'Verkrijgbaarheid',
      value: 'Alleen op recept'
    }
  ],
  source:
    'Bron: European Medicines Agency, productinformatie Mysimba®'
},

rybelsus: {
  summaryTitle: 'Rybelsus® in het kort',
  facts: [
    {
      label: 'Werkzame stof',
      value: 'Semaglutide'
    },
    {
      label: 'Toediening',
      value: 'Eén keer per dag als tablet'
    },
    {
      label: 'Geregistreerde toepassing',
      value:
        'Voor de behandeling van volwassenen met onvoldoende gereguleerde type 2-diabetes'
    },
    {
      label: 'Gebruik bij gewichtsverlies',
      value:
        'Gebruik voor gewichtsverlies valt buiten de geregistreerde toepassing'
    },
    {
      label: 'Verkrijgbaarheid',
      value: 'Alleen op recept'
    }
  ],
  source:
    'Bron: European Medicines Agency, productinformatie Rybelsus®'
}
};

const treatmentRecommendations = {
  saxenda: {
    profile: 'saxenda',
    shopifyKey: 'saxenda',
    displayName: 'Saxenda®',
    dosage: '',
    subtitle: 'Dagelijkse injectie',
    quantity: '5 prikpennen'
  },

  mounjaro_2_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro25',
    displayName: 'Mounjaro®',
    dosage: '2,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro5',
    displayName: 'Mounjaro®',
    dosage: '5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_7_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro75',
    displayName: 'Mounjaro®',
    dosage: '7,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_10: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro10',
    displayName: 'Mounjaro®',
    dosage: '10 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_12_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro125',
    displayName: 'Mounjaro®',
    dosage: '12,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_15: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro15',
    displayName: 'Mounjaro®',
    dosage: '15 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  wegovy_0_25: {
    profile: 'wegovy',
    shopifyKey: 'wegovy025',
    displayName: 'Wegovy®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  wegovy_0_5: {
  profile: 'wegovy',
  shopifyKey: 'wegovy05',
  displayName: 'Wegovy®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1: {
  profile: 'wegovy',
  shopifyKey: 'wegovy1',
  displayName: 'Wegovy®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1_7: {
  profile: 'wegovy',
  shopifyKey: 'wegovy17',
  displayName: 'Wegovy®',
  dosage: '1,7 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_2_4: {
  profile: 'wegovy',
  shopifyKey: 'wegovy24',
  displayName: 'Wegovy®',
  dosage: '2,4 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

  ozempic_0_25: {
    profile: 'ozempic',
    shopifyKey: 'ozempic025',
    displayName: 'Ozempic®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  ozempic_0_5: {
  profile: 'ozempic',
  shopifyKey: 'ozempic05',
  displayName: 'Ozempic®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_1: {
  profile: 'ozempic',
  shopifyKey: 'ozempic1',
  displayName: 'Ozempic®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_2: {
  profile: 'ozempic',
  shopifyKey: 'ozempic2',
  displayName: 'Ozempic®',
  dosage: '2 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},
  mysimba: {
  profile: 'mysimba',
  shopifyKey: 'mysimba',
  displayName: 'Mysimba®',
  dosage: '',
  subtitle: 'Behandeling met tabletten',
  quantity: '112 tabletten'
},

rybelsus_1_5: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus15',
  displayName: 'Rybelsus®',
  dosage: '1,5 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_4: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus4',
  displayName: 'Rybelsus®',
  dosage: '4 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_9: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus9',
  displayName: 'Rybelsus®',
  dosage: '9 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
}
};

const getTreatmentDatasetValue = (shopifyKey, field) => {
  const datasetKey =
    shopifyKey +
    field.charAt(0).toUpperCase() +
    field.slice(1);

  return root.dataset[datasetKey] || '';
};

const renderTreatmentRecommendation = (question) => {
  const treatmentKey =
    typeof question.treatment === 'function'
      ? question.treatment()
      : question.treatment;

  const treatmentConfig =
    treatmentRecommendations[treatmentKey];

  if (!treatmentConfig) {
    return `
      <p class="kq__error">
        Deze behandelaanbeveling kon niet worden geladen.
      </p>
    `;
  }

  const treatmentProfile =
    treatmentProfiles[treatmentConfig.profile];

  if (!treatmentProfile) {
    return `
      <p class="kq__error">
        De informatie over deze behandeling kon niet worden geladen.
      </p>
    `;
  }

  const shopifyKey = treatmentConfig.shopifyKey;

  const shopifyProductTitle =
    getTreatmentDatasetValue(shopifyKey, 'title');

  const productPrice =
    getTreatmentDatasetValue(shopifyKey, 'price');

  const productImage =
    getTreatmentDatasetValue(shopifyKey, 'image');

  const productInfoUrl =
    getTreatmentDatasetValue(shopifyKey, 'infoUrl');

  const variantId =
    getTreatmentDatasetValue(shopifyKey, 'variantId');

  const isAvailable =
    getTreatmentDatasetValue(shopifyKey, 'available') === 'true';

  const recommendationName = [
    treatmentConfig.displayName,
    treatmentConfig.dosage
  ]
    .filter(Boolean)
    .join(' ');

  const isContinuationRecommendation =
    answers.treatment_goal === 'need_guidance';

  const recommendationTitle =
    isContinuationRecommendation
      ? 'Jouw passende vervolgstap'
      : 'Jouw behandeladvies';

  const recommendationIntro =
    isContinuationRecommendation
      ? 'Op basis van je antwoorden lijkt onderstaande dosering een passende vervolgstap binnen je huidige behandeling. De uiteindelijke medische beoordeling en verantwoordelijkheid liggen altijd bij de arts.'
      : 'Op basis van je antwoorden lijkt onderstaande behandeling het beste aan te sluiten bij jouw situatie. De uiteindelijke medische beoordeling en verantwoordelijkheid liggen altijd bij de arts.';

  const recommendationNoticeText =
    isContinuationRecommendation
      ? 'De voorgestelde vervolgstap binnen je huidige behandeling is:'
      : 'Het advies is om je behandeling voor gewichtsverlies te starten met de volgende behandeling:';

  const recommendationBadge =
    isContinuationRecommendation
      ? 'Voorgestelde vervolgstap'
      : 'Geadviseerde behandeling';

  const productTitle =
    treatmentConfig.dosage
      ? recommendationName
      : shopifyProductTitle || treatmentConfig.displayName;

  const canApply =
    Boolean(variantId) && isAvailable;

  const applyButtonLabel = canApply
    ? 'Behandeling aanvragen'
    : 'Tijdelijk niet beschikbaar';

  const applyButtonDisabled = canApply
    ? ''
    : 'disabled';

  const imageHtml = productImage
    ? `
      <img
        src="${escapeHtml(productImage)}"
        alt="${escapeHtml(productTitle)}"
        loading="lazy"
      >
    `
    : '';

  const factsHtml = treatmentProfile.facts
    .map(
      (fact) => `
        <div class="kq__treatment-fact">
          <dt>${escapeHtml(fact.label)}</dt>
          <dd>${escapeHtml(fact.value)}</dd>
        </div>
      `
    )
    .join('');

  return `
    <div class="kq__recommendation">
      <h1 class="kq__question-title">
        ${escapeHtml(recommendationTitle)}
      </h1>

      <p class="kq__recommendation-intro">
        ${escapeHtml(recommendationIntro)}
      </p>

      <div class="kq__recommendation-notice">
        <span
          class="kq__recommendation-check"
          aria-hidden="true"
        >
          ✓
        </span>

        <p>
          ${escapeHtml(recommendationNoticeText)}
          <strong>${escapeHtml(recommendationName)}</strong>
        </p>
      </div>

      <div class="kq__product-card">
        <div class="kq__product-image">
          ${imageHtml}
        </div>

        <div class="kq__product-content">
          <span class="kq__product-badge">
            ${escapeHtml(recommendationBadge)}
          </span>

          <h2 class="kq__product-title">
            ${escapeHtml(productTitle)}
          </h2>

          <p class="kq__product-subtitle">
            ${escapeHtml(treatmentConfig.subtitle)}
          </p>

          ${
            productPrice
              ? `
                <p class="kq__product-price">
                  ${escapeHtml(productPrice)}
                </p>
              `
              : ''
          }

         ${
  treatmentConfig.quantity
    ? `
      <p class="kq__product-quantity">
        ${escapeHtml(treatmentConfig.quantity)}
      </p>
    `
    : ''
}

          <button
            type="button"
            class="kq__product-cta"
            data-kq-treatment-select
            data-treatment="${escapeHtml(treatmentKey)}"
            data-variant-id="${escapeHtml(variantId)}"
            ${applyButtonDisabled}
          >
            ${escapeHtml(applyButtonLabel)}
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <div class="kq__treatment-summary">
        <h2 class="kq__treatment-summary-title">
          ${escapeHtml(treatmentProfile.summaryTitle)}
        </h2>

        <dl class="kq__treatment-facts">
          ${factsHtml}
        </dl>

        <p class="kq__treatment-source">
          ${escapeHtml(treatmentProfile.source)}
        </p>
      </div>

      <div class="kq__recommendation-actions">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-treatment-select
          data-treatment="${escapeHtml(treatmentKey)}"
          data-variant-id="${escapeHtml(variantId)}"
          ${applyButtonDisabled}
        >
          ${escapeHtml(applyButtonLabel)}
          <span aria-hidden="true">→</span>
        </button>

        ${
          productInfoUrl
            ? `
              <a
                href="${escapeHtml(productInfoUrl)}"
                class="kq__status-button kq__status-button--secondary"
              >
                Meer informatie
                <span aria-hidden="true">→</span>
              </a>
            `
            : ''
        }
      </div>

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>
    </div>
  `;
};
      const renderMeasurementsQuestion = (question) => {
      const saved = answers[question.id] || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__measurement-list">
            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Hoe lang ben je?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="numeric"
                min="120"
                max="230"
                step="1"
                value="${escapeHtml(saved.height || '')}"
                data-kq-height
              >
              <span class="kq__measurement-unit">cm</span>
            </label>

            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Wat is je huidige gewicht?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="decimal"
                min="35"
                max="350"
                step="0.1"
                value="${escapeHtml(saved.weight || '')}"
                data-kq-weight
              >
              <span class="kq__measurement-unit">kg</span>
            </label>
          </div>

          <div class="kq__bmi-result" data-kq-bmi-result>
            <p class="kq__bmi-value" data-kq-bmi-value></p>
            <p class="kq__bmi-description" data-kq-bmi-description></p>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderQuestion = () => {
  statusScreen = null;

  const question = getQuestion(currentQuestionId);

  if (!question) return;

  setActiveSection(question.section || 'about');

  if (question.type === 'date') {
    questionRegion.innerHTML = renderDateQuestion(question);
  }

  if (question.type === 'radio') {
    questionRegion.innerHTML = renderRadioQuestion(question);
  }

  if (question.type === 'checkbox') {
    questionRegion.innerHTML = renderCheckboxQuestion(question);
  }

  if (question.type === 'medication_history') {
    questionRegion.innerHTML =
      renderMedicationHistoryQuestion(question);
  }

  if (question.type === 'bsn') {
    questionRegion.innerHTML = renderBsnQuestion(question);
  }

  if (question.type === 'textarea') {
    questionRegion.innerHTML = renderTextareaQuestion(question);
  }

  if (question.type === 'treatment_recommendation') {
  questionRegion.innerHTML =
    renderTreatmentRecommendation(question);
  }

  if (question.type === 'measurements') {
    questionRegion.innerHTML = renderMeasurementsQuestion(question);
  }

  if (question.type !== 'treatment_recommendation') {
    shownQuestions.set(question.id, {
      id: question.id,
      type: question.type === 'bsn' ? 'textarea' : question.type,
      question: question.title,
      help: question.help ?? null,
      answers: question.options
        ? Object.fromEntries(
            question.options.map((option) => [option.value, option.label])
          )
        : null,
      ...(question.type === 'medication_history' ? { subquestions: [] } : {})
    });
  }

  backButton.hidden = history.length === 0;

if (question.type === 'treatment_recommendation') {
  nextButton.hidden = true;
} else {
  nextButton.hidden = false;
  nextButton.innerHTML =
    'Verder <span aria-hidden="true">→</span>';

  bindQuestionEvents(question);
}

  if (question.type === 'measurements') {
    updateBmiPreview();
  }
};

    const renderStatus = ({
  title,
  message,
  type = 'stop',
  nextQuestionId = null,
  nextSection = null,
  nextButtonLabel = null
}) => {
  statusScreen = {
    title,
    message,
    type,
    nextQuestionId,
    nextSection,
    nextButtonLabel
  };

  const isAboutComplete =
    type === 'complete' &&
    nextSection === 'health';

  const isHealthComplete =
    type === 'complete' &&
    nextSection === 'treatment';

  const isOtherTreatment =
    type === 'other_treatment';

  const isConsentIntro =
    type === 'consent_intro';

  const isCheckoutReady =
    type === 'checkout_ready';

  const stopActions =
    type === 'stop'
      ? `
        <div class="kq__status-actions">
          <a
            class="kq__status-button kq__status-button--secondary"
            href="${escapeHtml(homeUrl)}"
          >
            Naar de homepage
          </a>

          <a
            class="kq__status-button kq__status-button--primary"
            href="${escapeHtml(contactUrl)}"
          >
            Neem contact op
            <span aria-hidden="true">→</span>
          </a>
        </div>
      `
      : '';

  const aboutCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent al goed op weg!
          </p>

          <p class="kq__status-motivation-text">
            Samen zetten we de volgende stap naar de behandeling die bij jou past.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <path
                d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"
              ></path>
              <rect
                x="9"
                y="10.5"
                width="6"
                height="5"
                rx="1"
              ></rect>
              <path d="M10.5 10.5V9a1.5 1.5 0 0 1 3 0v1.5"></path>
            </svg>
          </span>

          <p>100% vertrouwelijk en veilig</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>

          <p>Slechts enkele minuten</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path
                d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"
              ></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>

          <p>Beoordeeld door een arts</p>
        </div>
      </div>
    </div>
  `;

  const healthCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete kq__status-card--health-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent bijna bij je behandeladvies
          </p>

          <p class="kq__status-motivation-text">
            Met je laatste antwoorden kunnen we beter inschatten welke behandeling of vervolgstap bij jouw situatie kan passen.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <path d="M4 7h10"></path>
              <path d="M18 7h2"></path>
              <circle cx="16" cy="7" r="2"></circle>
              <path d="M4 12h3"></path>
              <path d="M11 12h9"></path>
              <circle cx="9" cy="12" r="2"></circle>
              <path d="M4 17h8"></path>
              <path d="M16 17h4"></path>
              <circle cx="14" cy="17" r="2"></circle>
            </svg>
          </span>

          <p>Afgestemd op jouw situatie</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>

          <p>Nog enkele korte vragen</p>
        </div>

        <div class="kq__status-benefit">
          <span
            class="kq__status-benefit-icon"
            aria-hidden="true"
          >
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path
                d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"
              ></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>

          <p>Altijd beoordeeld door een BIG geregistreerde arts</p>
        </div>
      </div>
    </div>
  `;
  
  const consentIntroText = isNetherlands
    ? 'Voordat je verdergaat naar betalen, vragen we nog om toestemming voor gegevensuitwisseling via het LSP, je BSN en een laatste bevestiging van je antwoorden. Nieuw bij Kearty? Dan rond je na de betaling eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.'
    : 'Voordat je verdergaat naar betalen, vragen we nog om een laatste bevestiging van je antwoorden. Nieuw bij Kearty? Dan rond je na de betaling eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.';

  const consentIntroContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"></path>
            <path d="m9 12 2 2 4-4"></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Bijna klaar
          </p>

          <p class="kq__status-motivation-text">
            ${escapeHtml(consentIntroText)}
          </p>
        </div>
      </div>
    </div>
  `;
  
  const selectedTreatmentConfig =
    treatmentRecommendations[selectedTreatment] || null;

  const selectedTreatmentName = selectedTreatmentConfig
    ? [
        selectedTreatmentConfig.displayName,
        selectedTreatmentConfig.dosage
      ]
        .filter(Boolean)
        .join(' ')
    : '';

  const startBenefitTreatments = new Set([
    'wegovy_0_25',
    'ozempic_0_25',
    'mounjaro_2_5'
  ]);

  const showStartBenefit =
    startBenefitTreatments.has(selectedTreatment);

  const startBenefitContent = showStartBenefit
    ? `
      <div class="kq__start-benefit" data-kq-start-benefit>
        <span class="kq__start-benefit-icon" aria-hidden="true">€</span>

        <div>
          <p class="kq__start-benefit-title">
            €100 startvoordeel voor nieuwe klanten
          </p>

          <p class="kq__start-benefit-text">
            Ben je nieuw bij Kearty? Dan ontvang je €100 startvoordeel op je eerste behandeling.
          </p>
        </div>

        <div class="kq__start-benefit-note">
          <span class="kq__start-benefit-check" aria-hidden="true">✓</span>
          <span>
            Het startvoordeel wordt tijdens de checkout zichtbaar zodra je je gegevens invult.
          </span>
        </div>
      </div>
    `
    : '';

  const checkoutReadyContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${
        selectedTreatmentName
          ? `
            <div class="kq__recommendation-notice" style="margin-top: 28px; text-align: left;">
              <span
                class="kq__recommendation-check"
                aria-hidden="true"
              >
                ✓
              </span>

              <p>
                Je vraagt aan: <strong>${escapeHtml(selectedTreatmentName)}</strong>
              </p>
            </div>
          `
          : ''
      }

      <div class="kq__status-actions kq__checkout-actions">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-final-checkout
          data-kq-treatment-apply
          data-treatment="${escapeHtml(selectedTreatment)}"
          data-variant-id="${escapeHtml(selectedVariantId)}"
        >
          Behandeling aanvragen
          <span aria-hidden="true">→</span>
        </button>

        <button
          type="button"
          class="kq__status-button kq__status-button--secondary kq__calendly-button"
          data-kq-calendly
        >
          <svg aria-hidden="true" viewBox="0 0 24 24">
            <rect x="4" y="5.5" width="16" height="14" rx="2"></rect>
            <path d="M8 3.5v4"></path>
            <path d="M16 3.5v4"></path>
            <path d="M4 9.5h16"></path>
          </svg>
          Adviesgesprek inplannen
        </button>
      </div>

      <p class="kq__calendly-copy">
        <strong>Liever eerst persoonlijk contact?</strong> Plan dan een gratis telefonisch gesprek van 10 minuten met Kearty. We leggen je graag uit hoe Kearty werkt, nemen je mee in het aanvraagproces en helpen je verder met je vragen.
      </p>

      <p
        class="kq__error kq__calendly-error"
        data-kq-calendly-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>

      ${startBenefitContent}

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        role="alert"
        aria-live="polite"
        hidden
      ></p>
    </div>
  `;
  
  const otherTreatmentContent = `
  <div class="kq__status-card">
    <h1 class="kq__status-title">
      ${escapeHtml(title)}
    </h1>

    <p class="kq__status-message">
      ${escapeHtml(message)}
    </p>

    <div class="kq__status-actions">
      <button
        type="button"
        class="kq__status-button kq__status-button--primary"
        data-kq-switch-from-other
      >
        Ik wil een andere behandeling overwegen
        <span aria-hidden="true">→</span>
      </button>

      <a
        class="kq__status-button kq__status-button--secondary"
        href="${escapeHtml(contactUrl)}"
      >
        Neem contact op
      </a>
    </div>
  </div>
`;

  const defaultStatusContent = `
    <div class="kq__status-card">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${stopActions}
    </div>
  `;

  questionRegion.innerHTML =
  isAboutComplete
    ? aboutCompleteContent
    : isHealthComplete
      ? healthCompleteContent
      : isConsentIntro
        ? consentIntroContent
        : isCheckoutReady
          ? checkoutReadyContent
          : isOtherTreatment
            ? otherTreatmentContent
            : defaultStatusContent;

  if (isOtherTreatment) {
  setActiveSection('treatment');
}

  if (
    type === 'complete' ||
    type === 'consent_intro'
  ) {
    setActiveSection(nextSection || 'health');

    nextButton.hidden = false;
    nextButton.innerHTML = `
      ${escapeHtml(nextButtonLabel || 'Verder')}
      <span aria-hidden="true">→</span>
    `;
  } else {
    nextButton.hidden = true;
  }
};

      const updateBmiPreview = () => {
        const heightInput = questionRegion.querySelector('[data-kq-height]');
        const weightInput = questionRegion.querySelector('[data-kq-weight]');
        const result = questionRegion.querySelector('[data-kq-bmi-result]');
        const valueElement = questionRegion.querySelector(
          '[data-kq-bmi-value]'
        );
        const descriptionElement = questionRegion.querySelector(
          '[data-kq-bmi-description]'
        );

        if (
          !heightInput ||
          !weightInput ||
          !result ||
          !valueElement ||
          !descriptionElement
        ) {
          return;
        }

        const height = Number.parseFloat(heightInput.value);
        const weight = Number.parseFloat(weightInput.value);

        if (!height || !weight || height <= 0 || weight <= 0) {
          result.classList.remove('is-visible');
          return;
        }

        const bmi = weight / Math.pow(height / 100, 2);
        const roundedBmi = bmi.toFixed(1);

      valueElement.textContent = `Jouw BMI is ${roundedBmi}`;

result.classList.remove('is-stop');

let bmiCategory = '';

if (bmi < 19) {
  bmiCategory = 'ondergewicht';
} else if (bmi < 25) {
  bmiCategory = 'gezond gewicht';
} else if (bmi < 30) {
  bmiCategory = 'overgewicht';
} else if (bmi < 35) {
  bmiCategory = 'obesitas';
} else if (bmi < 40) {
  bmiCategory = 'ernstige obesitas';
} else {
  bmiCategory = 'zeer ernstige obesitas';
}

descriptionElement.textContent =
  `Je BMI valt in de categorie ${bmiCategory}.`;

if (bmi < 25) {
  result.classList.add('is-stop');
}

result.classList.add('is-visible');
      };

      const bindQuestionEvents = (question) => {
        clearError();

        if (question.type === 'medication_history') {
          questionRegion
            .querySelectorAll(
              '[data-kq-medication-dosage], [data-kq-medication-start-month], [data-kq-medication-start-year], [data-kq-medication-status], [data-kq-medication-end-month], [data-kq-medication-end-year]'
            )
            .forEach((field) => {
              const eventName =
                field.tagName === 'SELECT' ? 'change' : 'input';

              field.addEventListener(eventName, () => {
                if (
                  field.matches(
                    '[data-kq-medication-start-year], [data-kq-medication-end-year]'
                  )
                ) {
                  field.value = field.value
                    .replace(/\D/g, '')
                    .slice(0, 4);
                }

                if (field.matches('[data-kq-medication-status]')) {
                  const card = field.closest(
                    '[data-kq-medication-card]'
                  );
                  const endDate = card?.querySelector(
                    '[data-kq-medication-end-date]'
                  );

                  if (endDate) {
                    endDate.hidden = field.value !== 'stopped';
                  }

                  if (field.value !== 'stopped' && card) {
                    const endMonth = card.querySelector(
                      '[data-kq-medication-end-month]'
                    );
                    const endYear = card.querySelector(
                      '[data-kq-medication-end-year]'
                    );

                    if (endMonth) endMonth.value = '';
                    if (endYear) endYear.value = '';
                  }
                }

                field.classList.remove('has-error');
                saveMedicationHistoryDraft(question);
                clearError();
              });
            });
        }

        questionRegion
  .querySelectorAll('input[type="radio"]')
  .forEach((input) => {
    input.addEventListener('change', () => {
      answers[question.id] = input.value;

      const otherField = questionRegion.querySelector(
        '[data-kq-other-field]'
      );

      const otherInput = questionRegion.querySelector(
        '[data-kq-other-input]'
      );

      otherField?.classList.toggle(
        'is-visible',
        input.value === 'other'
      );

      if (input.value === 'other') {
        otherInput?.focus();
      }

      updateSelectedRows();
      clearError();
    });
  });

        questionRegion
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            input.addEventListener('change', () => {
              const selectedInputs = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              );

              if (
                input.checked &&
                question.exclusiveValues?.includes(input.value)
              ) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    otherInput.checked = otherInput === input;
                  });
              } else if (input.checked) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    if (
                      question.exclusiveValues?.includes(otherInput.value)
                    ) {
                      otherInput.checked = false;
                    }
                  });
              }

              answers[question.id] = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              ).map((checkedInput) => checkedInput.value);

              const otherField = questionRegion.querySelector(
                '[data-kq-other-field]'
              );

              otherField?.classList.toggle(
                'is-visible',
                answers[question.id].includes('other')
              );

              updateSelectedRows();
              clearError();
            });
          });

        const bsnInput = questionRegion.querySelector(
          '[data-kq-bsn]'
        );

        bsnInput?.addEventListener('input', () => {
          bsnInput.value = bsnInput.value
            .replace(/\D/g, '')
            .slice(0, 9);

          clearError();
        });

        const dateInputs = Array.from(
  questionRegion.querySelectorAll(
    '[data-kq-date-day], [data-kq-date-month], [data-kq-date-year]'
  )
);

dateInputs.forEach((input, index) => {
  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '');

    const maxLength = Number.parseInt(
      input.getAttribute('maxlength'),
      10
    );

    if (
      input.value.length === maxLength &&
      dateInputs[index + 1]
    ) {
      dateInputs[index + 1].focus();
    }

    clearError();
  });

  input.addEventListener('keydown', (event) => {
    if (
      event.key === 'Backspace' &&
      input.value === '' &&
      dateInputs[index - 1]
    ) {
      dateInputs[index - 1].focus();
    }
  });
});

        questionRegion
          .querySelectorAll('[data-kq-height], [data-kq-weight]')
          .forEach((input) => {
            input.addEventListener('input', () => {
              updateBmiPreview();
              clearError();
            });
          });

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          textarea?.addEventListener('input', () => {
            answers[question.id] = textarea.value;
            textarea.classList.remove('has-error');
            clearError();
          });
        }

        questionRegion
          .querySelector('[data-kq-other-input]')
          ?.addEventListener('input', (event) => {
            answers[`${question.id}_other`] = event.target.value;
            clearError();
          });
      };

      const validateCurrentQuestion = () => {
        clearError();

        const question = getQuestion(currentQuestionId);

        if (!question) return false;

        if (question.type === 'date') {
  const dayInput = questionRegion.querySelector('[data-kq-date-day]');
  const monthInput = questionRegion.querySelector(
    '[data-kq-date-month]'
  );
  const yearInput = questionRegion.querySelector(
    '[data-kq-date-year]'
  );

  const day = Number.parseInt(dayInput.value, 10);
  const month = Number.parseInt(monthInput.value, 10);
  const year = Number.parseInt(yearInput.value, 10);

  if (!day || !month || !year) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul je volledige geboortedatum in.');
    return false;
  }

  if (!isValidDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geldige geboortedatum in.');
    return false;
  }

  if (!isPastDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geboortedatum in het verleden in.');
    return false;
  }

  const age = calculateAge(day, month, year);

  answers[question.id] = formatDateOfBirth(day, month, year);

  if (age < 18) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
    });

    return false;
  }

  if (age > 76) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
    });

    return false;
  }

  return true;
}

        if (question.type === 'bsn') {
          const bsnInput = questionRegion.querySelector(
            '[data-kq-bsn]'
          );

          const bsn = bsnInput?.value
            .replace(/\D/g, '')
            .trim() || '';

          if (bsn.length !== 9) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Vul je BSN van 9 cijfers in.'
            );

            return false;
          }

          if (!isValidBsn(bsn)) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Dit lijkt geen geldig BSN. Controleer de 9 cijfers en probeer het opnieuw.'
            );

            return false;
          }

          answers[question.id] = bsn;

          return true;
        }

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          const value = textarea?.value.trim() || '';

          // Synchronize the latest DOM value before validation/navigation.
          answers[question.id] = value;

          if (!value && question.required !== false) {
            textarea?.classList.add('has-error');

            renderError(
              question.errorMessage ||
                'Vul de gevraagde informatie in om verder te gaan.'
            );

            return false;
          }

          return true;
        }

        if (question.type === 'radio') {
  const checkedInput = questionRegion.querySelector(
    'input[type="radio"]:checked'
  );

  if (!checkedInput) {
    renderError('Kies één antwoord om verder te gaan.');
    return false;
  }

  answers[question.id] = checkedInput.value;

  if (checkedInput.value === 'other') {
    const otherInput = questionRegion.querySelector(
      '[data-kq-other-input]'
    );

    const otherValue =
      otherInput?.value.trim() || '';

    if (!otherValue) {
      otherInput?.classList.add('has-error');

      renderError(
        'Vul bij “Anders, namelijk” de naam van de behandeling in.'
      );

      return false;
    }

    answers[`${question.id}_other`] = otherValue;
  }

  return true;
}

        if (question.type === 'checkbox') {
          const checkedInputs = Array.from(
            questionRegion.querySelectorAll(
              'input[type="checkbox"]:checked'
            )
          );

          if (checkedInputs.length === 0) {
  renderError(
    question.requireAll
      ? 'Vink alle verklaringen aan om verder te gaan.'
      : 'Kies minimaal één antwoord om verder te gaan.'
  );

  return false;
}

if (
  question.requireAll &&
  checkedInputs.length !== question.options.length
) {
  renderError('Vink alle verklaringen aan om verder te gaan.');
  return false;
}

answers[question.id] = checkedInputs.map(
  (input) => input.value
);

if (question.id === 'previous_weight_loss_attempts') {
  if (!answers[question.id].includes('weight_loss_medication')) {
    delete answers.previous_weight_loss_medications;
    delete answers.previous_weight_loss_medications_other;
    delete answers.previous_weight_loss_medication_details;
  }
}

if (question.id === 'previous_weight_loss_medications') {
  const selectedTreatments = answers[question.id];

  if (!selectedTreatments.includes('other')) {
    delete answers.previous_weight_loss_medications_other;
  }

  if (
    Array.isArray(answers.previous_weight_loss_medication_details)
  ) {
    answers.previous_weight_loss_medication_details =
      answers.previous_weight_loss_medication_details.filter(
        (item) => selectedTreatments.includes(item.treatment)
      );
  }
}

          if (
            answers[question.id].includes('other') &&
            !questionRegion
              .querySelector('[data-kq-other-input]')
              ?.value.trim()
          ) {
            renderError('Vul bij “Anders, namelijk” een korte toelichting in.');
            return false;
          }

          return true;
        }

        if (question.type === 'medication_history') {
          const cards = Array.from(
            questionRegion.querySelectorAll(
              '[data-kq-medication-card]'
            )
          );

          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;
          const validatedHistory = [];

          const markError = (field) => {
            field?.classList.add('has-error');
          };

          const isValidMonthYear = (month, year) => {
            return (
              month >= 1 &&
              month <= 12 &&
              year >= 1900 &&
              year <= currentYear
            );
          };

          const isFutureMonth = (month, year) => {
            return (
              year > currentYear ||
              (year === currentYear && month > currentMonth)
            );
          };

          for (const card of cards) {
            const treatment = card.dataset.medicationKey || '';
            const medicationName =
              card.dataset.medicationName || treatment;

            const dosageField = card.querySelector(
              '[data-kq-medication-dosage]'
            );
            const startMonthField = card.querySelector(
              '[data-kq-medication-start-month]'
            );
            const startYearField = card.querySelector(
              '[data-kq-medication-start-year]'
            );
            const statusField = card.querySelector(
              '[data-kq-medication-status]'
            );
            const endMonthField = card.querySelector(
              '[data-kq-medication-end-month]'
            );
            const endYearField = card.querySelector(
              '[data-kq-medication-end-year]'
            );

            const lastDosage = dosageField?.value.trim() || '';
            const startedMonth = Number.parseInt(
              startMonthField?.value || '',
              10
            );
            const startedYear = Number.parseInt(
              startYearField?.value || '',
              10
            );
            const usageStatus = statusField?.value || '';
            const stillUsing = usageStatus === 'still_using';

            if (dosageField && !lastDosage) {
              markError(dosageField);
              renderError(
                `Vul voor ${medicationName} de laatst gebruikte dosering in.`
              );
              return false;
            }

            if (
              !isValidMonthYear(startedMonth, startedYear) ||
              isFutureMonth(startedMonth, startedYear)
            ) {
              markError(startMonthField);
              markError(startYearField);
              renderError(
                `Vul voor ${medicationName} een geldige startmaand en een geldig startjaar in.`
              );
              return false;
            }

            if (!usageStatus) {
              markError(statusField);
              renderError(
                `Geef voor ${medicationName} aan of je deze behandeling nog gebruikt.`
              );
              return false;
            }

            let endedMonth = null;
            let endedYear = null;

            if (!stillUsing) {
              endedMonth = Number.parseInt(
                endMonthField?.value || '',
                10
              );
              endedYear = Number.parseInt(
                endYearField?.value || '',
                10
              );

              if (
                !isValidMonthYear(endedMonth, endedYear) ||
                isFutureMonth(endedMonth, endedYear)
              ) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `Vul voor ${medicationName} een geldige stopmaand en een geldig stopjaar in.`
                );
                return false;
              }

              const startValue = startedYear * 12 + startedMonth;
              const endValue = endedYear * 12 + endedMonth;

              if (endValue < startValue) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `De stopdatum van ${medicationName} kan niet vóór de startdatum liggen.`
                );
                return false;
              }
            }

            const historyItem = {
              treatment,
              started_month: startedMonth,
              started_year: startedYear,
              usage_status: usageStatus,
              still_using: stillUsing,
              ended_month: stillUsing ? null : endedMonth,
              ended_year: stillUsing ? null : endedYear
            };

            if (dosageField) {
              historyItem.last_dosage = lastDosage;
            }

            validatedHistory.push(historyItem);
          }

          shownQuestions.get(question.id).subquestions =
            serializeMedicationSubquestions(cards);
          answers[question.id] = validatedHistory;
          return true;
        }

        if (question.type === 'measurements') {
          const heightInput = questionRegion.querySelector('[data-kq-height]');
          const weightInput = questionRegion.querySelector('[data-kq-weight]');

          const height = Number.parseFloat(heightInput.value);
          const weight = Number.parseFloat(weightInput.value);

          if (!height || height < 120 || height > 230) {
            heightInput.classList.add('has-error');
            renderError('Vul een geldige lengte tussen 120 en 230 cm in.');
            return false;
          }

          if (!weight || weight < 35 || weight > 350) {
            weightInput.classList.add('has-error');
            renderError('Vul een geldig gewicht tussen 35 en 350 kg in.');
            return false;
          }

          const bmi = weight / Math.pow(height / 100, 2);

          answers[question.id] = {
            height,
            weight,
            bmi: Number.parseFloat(bmi.toFixed(1))
          };

          return true;
        }

        return true;
      };

      const getStopStatus = () => {
        if (currentQuestionId === 'dateOfBirth') {
          const birthDate = parseDateOfBirth(answers.dateOfBirth);

          if (!birthDate) return null;

          const age = calculateAge(
            birthDate.day,
            birthDate.month,
            birthDate.year
          );

          if (age < 18) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
            };
          }

          if (age > 76) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
            };
          }
        }

        if (currentQuestionId === 'pregnancy_status') {
          const excludedStatuses = [
            'pregnant',
            'breastfeeding',
            'trying_to_conceive'
          ];

          if (excludedStatuses.includes(answers.pregnancy_status)) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'Je hebt aangegeven dat je zwanger bent, borstvoeding geeft of probeert zwanger te worden. Daarom kun je via het huidige Kearty-traject geen gewichtsverliesbehandeling met medicatie aanvragen. Bespreek met je huisarts of behandelend arts welke ondersteuning in jouw situatie passend is.'
            };
          }
        }

        if (currentQuestionId === 'body_measurements') {
  const bmi = answers.body_measurements?.bmi;

  if (bmi < 19) {
    return {
      title: 'Op dit moment geen passende behandeling met medicatie',
      message:
        'Je BMI is lager dan 19. Op basis van deze uitkomst is een behandeling gericht op gewichtsverlies niet passend. Daarom kan Kearty je via deze route geen behandeling aanbieden. Bespreek met je huisarts welke ondersteuning in jouw situatie passend is.'
    };
  }

  if (bmi < 25) {
  return {
    title: 'Op dit moment geen passende behandeling met medicatie',
    message:
      'Je BMI valt binnen de categorie gezond gewicht. Op basis van deze uitkomst lijkt een behandeling met gewichtsverliesmedicatie op dit moment niet passend. Daarom kan Kearty je via deze route geen passende behandeling aanbieden.'
  };
}
}

if (currentQuestionId === 'pancreas_conditions') {
  const selectedConditions = Array.isArray(answers.pancreas_conditions)
    ? answers.pancreas_conditions
    : [];

  const stopValues = [
    'pancreatitis',
    'other_pancreas_condition',
    'pancreas_removed'
  ];

  const shouldStop = selectedConditions.some((value) =>
    stopValues.includes(value)
  );

  if (shouldStop) {
  return {
    type: 'stop',
    title: 'We kunnen je aanvraag niet via deze route voortzetten',
    message:
      'Je hebt aangegeven dat je een aandoening of behandeling aan de alvleesklier hebt gehad. Op basis van deze informatie kan Kearty je aanvraag niet via deze online vragenlijst voortzetten. Neem bij vragen gerust contact met ons op.'
  };
}
}

if (
  currentQuestionId === 'current_gallbladder_symptoms' &&
  answers.current_gallbladder_symptoms === 'yes'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment klachten hebt die mogelijk te maken hebben met je galblaas of galwegen. Daarom kunnen we je aanvraag niet direct via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken wat in jouw situatie de juiste vervolgstap is.'
  };
}

if (
  currentQuestionId === 'eating_disorder_current_status' &&
  answers.eating_disorder_current_status === 'current'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment last hebt van een eetstoornis of ernstige problemen met eten. Daarom kunnen we je aanvraag niet via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken welke ondersteuning in jouw situatie passend is.'
  };
}

return null;
};

      const goToNextQuestion = () => {
  const stopStatus = getStopStatus();

  if (stopStatus) {
    renderStatus(stopStatus);
    return;
  }

  if (
  currentQuestionId === 'current_or_previous_treatment' &&
  answers.treatment_goal === 'need_guidance' &&
  answers.current_or_previous_treatment === 'other'
) {
  const treatmentName =
    answers.current_or_previous_treatment_other?.trim() ||
    'de door jou ingevulde behandeling';

  renderStatus({
    type: 'other_treatment',
    title:
      'Voor deze behandeling kunnen we geen automatische vervolgstap bepalen',
    message:
      `Je hebt aangegeven dat je ${treatmentName} gebruikt. Omdat deze behandeling niet in onze vaste lijst staat, kunnen we geen passende vervolgdosis voorstellen. Je kunt een andere behandeling overwegen of contact met ons opnemen.`
  });

  return;
}

  const visibleQuestions = getVisibleQuestions();

  const currentIndex = visibleQuestions.findIndex(
    (question) => question.id === currentQuestionId
  );

  const currentQuestion = visibleQuestions[currentIndex];
  const nextQuestion = visibleQuestions[currentIndex + 1];

  const currentSection = currentQuestion?.section || 'about';

const nextSection = nextQuestion
  ? nextQuestion.section || 'about'
  : null;

  /*
   * Eerst een overgangsscherm tonen wanneer
   * het volgende onderdeel begint.
   */
  if (nextQuestion && currentSection !== nextSection) {
  if (currentSection === 'about' && nextSection === 'health') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Over jou" is afgerond',
      message:
        'In de volgende stap stellen we vragen over jouw gezondheid.',
      nextQuestionId: nextQuestion.id,
      nextSection: 'health',
      nextButtonLabel: 'Verder naar jouw gezondheid'
    });

    return;
  }

  if (currentSection === 'health' && nextSection === 'treatment') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
  'Op basis van je gezondheidssituatie lijkt het erop dat je in aanmerking kunt komen voor een behandeling. In de volgende stap kijken we welke behandeling het beste bij jouw situatie past',
      nextQuestionId: nextQuestion.id,
      nextSection: 'treatment',
      nextButtonLabel: 'Verder naar behandeladvies'
    });

    return;
  }
}

  if (currentQuestionId === 'final_declarations') {
    renderStatus({
      type: 'checkout_ready',
      title: 'Je kunt verder naar betalen',
      message:
        'Je hebt alle benodigde gegevens en bevestigingen ingevuld. Je kunt nu verder naar betalen. Nieuw bij Kearty? Dan vragen we je na de betaling om eenmalig je identiteit te bevestigen. Daarna neemt de arts je aanvraag in behandeling.'
    });

    return;
  }

  /*
   * Tijdelijke afronding zolang nog niet alle
   * gezondheidsvragen zijn toegevoegd.
   */
  if (!nextQuestion) {
    renderStatus({
      type: 'health_complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
        'Je hebt alle vragen in dit onderdeel beantwoord.'
    });

    return;
  }

  history.push(currentQuestionId);
  currentQuestionId = nextQuestion.id;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (
          statusScreen?.type === 'complete' ||
          statusScreen?.type === 'consent_intro'
        ) {
  if (statusScreen.type === 'complete' && statusScreen.nextSection === 'health') {
    root.dispatchEvent(
      new CustomEvent('kearty:about-section-complete', {
        bubbles: true,
        detail: { answers: serializeAnswers() }
      })
    );
  }

  const nextQuestionId = statusScreen.nextQuestionId;

  if (!nextQuestionId) return;

  history.push(currentQuestionId);
  currentQuestionId = nextQuestionId;
  statusScreen = null;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  return;
}

        if (!validateCurrentQuestion()) return;

        goToNextQuestion();
      });

      backButton.addEventListener('click', () => {
        if (statusScreen) {
          statusScreen = null;
          renderQuestion();
          return;
        }

        const previousQuestionId = history.pop();

        if (!previousQuestionId) return;

        currentQuestionId = previousQuestionId;
        renderQuestion();

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      helpButton.addEventListener('click', () => {
        const chatSelector = root.dataset.chatSelector?.trim();
        const helpUrl = root.dataset.helpUrl?.trim();

        if (chatSelector) {
          const chatLauncher = document.querySelector(chatSelector);

          if (chatLauncher) {
            chatLauncher.click();
            return;
          }
        }

        const chatEvent = new CustomEvent('kearty:open-chat', {
          bubbles: true
        });

        root.dispatchEvent(chatEvent);

        if (helpUrl) {
          window.location.href = helpUrl;
        }
      });

      // The active route and rendered definitions determine the submission.
      // Only questions that are currently visible and were actually rendered are sent.
      const getSubmissionQuestions = () =>
        getVisibleQuestions().filter(
          (question) =>
            question.type !== 'treatment_recommendation' &&
            shownQuestions.has(question.id)
        );

      const serializeAnswers = () => {
        const result = {};

        getSubmissionQuestions().forEach((question) => {
          if (Object.prototype.hasOwnProperty.call(answers, question.id)) {
            result[question.id] = answers[question.id];
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));

          if (hasOtherAnswer) {
            const otherKey = `${question.id}_other`;

            if (Object.prototype.hasOwnProperty.call(answers, otherKey)) {
              result[otherKey] = answers[otherKey];
            }
          }
        });

        return structuredClone(result);
      };

      const getOtherFieldQuestionText = (question) => {
        if (question.type === 'radio') {
          return 'Welke behandeling heb je gebruikt?';
        }

        return 'Anders, namelijk';
      };

      const serializeQuestions = () => {
        const definitions = [];

        getSubmissionQuestions().forEach((question) => {
          const definition = shownQuestions.get(question.id);

          if (definition) {
            definitions.push(definition);
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));
          const otherKey = `${question.id}_other`;

          if (
            hasOtherAnswer &&
            Object.prototype.hasOwnProperty.call(answers, otherKey)
          ) {
            definitions.push({
              id: otherKey,
              type: 'textarea',
              question: getOtherFieldQuestionText(question),
              help: null,
              answers: null
            });
          }
        });

        return structuredClone(definitions);
      };

      // Composite medication_history fields must be described exactly as shown.
      // These definitions are nested under the parent question in detail.questions.
      const serializeMedicationSubquestions = (cards) =>
        cards.flatMap((card) => {
          const treatment = card.dataset.medicationKey || '';
          const medicationName = card.dataset.medicationName || treatment;
          const text = (element) =>
            element?.textContent.trim().replace(/\s+/g, ' ') || '';
          const definitions = [];

          definitions.push({
            id: `${treatment}.medication`,
            question: 'Welke medicatie heb je gebruikt?',
            type: 'select',
            answers: treatment
              ? { [treatment]: medicationName }
              : null
          });

          const dosageField = card.querySelector(
            '[data-kq-medication-dosage]'
          );

          if (dosageField) {
            const dosageDefinition = {
              id: `${treatment}.last_dosage`,
              question: 'Welke dosering gebruikte je het laatst?',
              type: dosageField.tagName === 'SELECT' ? 'select' : 'text'
            };

            if (dosageField.tagName === 'SELECT') {
              dosageDefinition.answers = Object.fromEntries(
                Array.from(dosageField.options)
                  .filter((option) => option.value !== '')
                  .map((option) => [option.value, text(option)])
              );
            }

            definitions.push(dosageDefinition);
          }

          definitions.push({
            id: `${treatment}.start_date`,
            question: 'Wanneer ben je met deze behandeling gestart?',
            type: 'month_year'
          });

          const statusField = card.querySelector(
            '[data-kq-medication-status]'
          );

          const statusDefinition = {
            id: `${treatment}.usage_status`,
            question: 'Gebruik je deze behandeling op dit moment nog?',
            type: 'select',
            answers: statusField
              ? Object.fromEntries(
                  Array.from(statusField.options)
                    .filter((option) => option.value !== '')
                    .map((option) => [option.value, text(option)])
                )
              : {
                  still_using: 'Ja, ik gebruik deze behandeling nog',
                  stopped: 'Nee, ik ben hiermee gestopt'
                }
          };

          definitions.push(statusDefinition);

          if (statusField?.value === 'stopped') {
            definitions.push({
              id: `${treatment}.end_date`,
              question: 'Wanneer ben je met deze behandeling gestopt?',
              type: 'month_year',
              condition: "usage_status === 'stopped'"
            });
          }

          return definitions;
        });

      root.addEventListener('kearty:submission-error', () => {
        submissionPending = false;
        submissionFailedDuringDispatch = true;
        root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
          button.disabled = false;
          button.innerHTML = 'Behandeling aanvragen <span aria-hidden="true">→</span>';
        });
      });

      root.addEventListener('click', (event) => {
  const switchFromOtherButton = event.target.closest(
    '[data-kq-switch-from-other]'
  );

  if (
    switchFromOtherButton &&
    root.contains(switchFromOtherButton)
  ) {
    answers.treatment_goal = 'switch_treatment';

    statusScreen = null;
    history.push(currentQuestionId);
    currentQuestionId = 'preferred_treatment_form';

    renderQuestion();

    root.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    return;
  }

  const calendlyButton = event.target.closest(
    '[data-kq-calendly]'
  );

  if (
    calendlyButton &&
    root.contains(calendlyButton)
  ) {
    event.preventDefault();

    if (calendlyButton.disabled) return;

    const calendlyError = questionRegion.querySelector(
      '[data-kq-calendly-error]'
    );
    const originalButtonHtml = calendlyButton.innerHTML;

    if (calendlyError) {
      calendlyError.hidden = true;
      calendlyError.textContent = '';
    }

    calendlyButton.disabled = true;
    calendlyButton.textContent = 'Agenda wordt geladen…';

    openCalendlyPopup()
      .catch(() => {
        if (calendlyError) {
          calendlyError.textContent =
            'De agenda kon niet worden geladen. Probeer het opnieuw of neem contact met ons op.';
          calendlyError.hidden = false;
        }
      })
      .finally(() => {
        if (calendlyButton.isConnected) {
          calendlyButton.disabled = false;
          calendlyButton.innerHTML = originalButtonHtml;
        }
      });

    return;
  }

  const finalCheckoutButton = event.target.closest(
    '[data-kq-final-checkout]'
  );

  if (
    finalCheckoutButton &&
    root.contains(finalCheckoutButton)
  ) {
    if (finalCheckoutButton.disabled || submissionPending) return;
    event.preventDefault();

    const treatment = finalCheckoutButton.dataset.treatment || '';

    const variantId = finalCheckoutButton.dataset.variantId || '';

    const errorElement = questionRegion.querySelector(
      '[data-kq-apply-error]'
    );

    if (!treatment || !/^\d+$/.test(variantId) || /^0+$/.test(variantId)) {
      if (errorElement) {
        errorElement.textContent =
          'De gekozen behandeling kon niet worden teruggevonden. Ga terug naar het behandeladvies en kies de behandeling opnieuw.';
        errorElement.hidden = false;
      }

      return;
    }

    if (errorElement) {
      errorElement.hidden = true;
      errorElement.textContent = '';
    }
    submissionFailedDuringDispatch = false;
    submissionPending = true;

    const applicationEvent = new CustomEvent(
      'kearty:treatment-apply',
      {
        bubbles: true,
        cancelable: true,
        detail: {
          treatment,
          variantId,
          answers: serializeAnswers(),
          questions: serializeQuestions(),
          questionnaireKey: 'weight-loss-flow-1',
          questionnaireVersion: '2026-10-20'
        }
      }
    );

    const eventWasNotCancelled =
      root.dispatchEvent(applicationEvent);

    if (!eventWasNotCancelled) {
      // A synchronous handler error may already have restored the buttons.
      if (!submissionFailedDuringDispatch) {
        root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
          button.disabled = true;
          button.innerHTML = 'Aanvraag wordt verwerkt…';
        });
      }
      return;
    }

    submissionPending = false;
    // Without a submission handler, keep the answers here and show an error.
    if (errorElement) {
      errorElement.textContent =
        'De aanvraagkoppeling is nog niet geactiveerd. Probeer het later opnieuw of neem contact met ons op.';
      errorElement.hidden = false;
    }

    return;
  }

  const applyButton = event.target.closest(
    '[data-kq-treatment-select]'
  );

  if (
    !applyButton ||
    !root.contains(applyButton) ||
    applyButton.disabled
  ) {
    return;
  }

  const treatment =
    applyButton.dataset.treatment || '';

  const variantId =
    applyButton.dataset.variantId || '';

  const treatmentConfig =
    treatmentRecommendations[treatment];

  const treatmentName = treatmentConfig
    ? [
        treatmentConfig.displayName,
        treatmentConfig.dosage
      ]
        .filter(Boolean)
        .join(' ')
    : 'de gekozen behandeling';

  selectedTreatment = treatment;
  selectedVariantId = variantId;

  renderStatus({
    type: 'consent_intro',
    title: 'Rond je aanvraag af',
    message:
      `Je hebt gekozen voor ${treatmentName}. Voordat je verdergaat naar betalen hebben we alleen nog een paar gegevens en bevestigingen van je nodig.`,
    nextQuestionId: getFirstFinalQuestionId(),
    nextSection: 'treatment',
    nextButtonLabel: 'Verder met afronden'
  });

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
});

      renderQuestion();
    });

    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot = event.target.querySelector(
        '[data-kearty-questionnaire-flow-1]'
      );

      if (sectionRoot) {
        sectionRoot.removeAttribute('data-kq-flow-1-initialized');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kearty-questionnaire-flow-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFlow2Questionnaire = (root) => {
      if (
        !root ||
        root.hasAttribute('data-kq-flow-2-initialized')
      ) {
        return;
      }

      root.setAttribute('data-kq-flow-2-initialized', 'true');

      const questionRegion = root.querySelector(
        '[data-kq-question-region]'
      );
      const form = root.querySelector('[data-kq-form]');
      const backButton = root.querySelector('[data-kq-back]');
      const nextButton = root.querySelector('[data-kq-next]');
      const helpButton = root.querySelector('[data-kq-help]');

      const homeUrl = root.dataset.homeUrl || '/';
      const contactUrl =
        root.dataset.contactUrl || '/pages/contact';
      const termsUrl =
        root.dataset.termsUrl || '/pages/algemene-voorwaarden';
      const privacyUrl =
        root.dataset.privacyUrl || '/pages/privacy-statement';

      const countryCode =
        (root.dataset.countryCode || '').toUpperCase();

      const isNetherlands = countryCode === 'NL';

      const escapeHtml = (value) =>
        String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');

      const addLowestPriceToLabel = (label, price) => {
        return price
          ? `${label} – vanaf ${price}`
          : label;
      };

      const answers = {};
      const history = [];
      const shownQuestions = new Map();

      let selectedTreatment = '';
      let selectedVariantId = '';
      let selectedTreatmentAvailable = false;

      let currentQuestionId = 'dateOfBirth';
      let statusScreen = null;

      const questions = [
        {
          id: 'dateOfBirth',
          type: 'date',
          title: 'Wat is je geboortedatum?',
          help: 'Je geboortedatum gebruiken we om je leeftijd te bepalen en om deze op het e-recept te vermelden als de arts je aanvraag goedkeurt.'
        },
        {
          id: 'sex_at_birth',
          type: 'radio',
          title: 'Welk geslacht werd bij je geboorte geregistreerd?',
          options: [
            { value: 'male', label: 'Mannelijk' },
            { value: 'female', label: 'Vrouwelijk' },
            { value: 'intersex_or_other', label: 'Intersekse of anders' }
          ]
        },
        {
          id: 'pregnancy_status',
          type: 'radio',
          title: 'Probeer je op dit moment zwanger te worden, ben je zwanger of geef je borstvoeding?',
          condition: () => answers.sex_at_birth === 'female',
          options: [
            { value: 'pregnant', label: 'Ik ben zwanger' },
            { value: 'breastfeeding', label: 'Ik geef borstvoeding' },
            {
              value: 'trying_to_conceive',
              label: 'Ik probeer zwanger te worden'
            },
            {
              value: 'none',
              label: 'Nee, geen van bovenstaande'
            }
          ]
        },
        {
          id: 'body_measurements',
          type: 'measurements',
          title: 'Wat zijn je lengte en je gewicht?',
          help:
            'Met je lengte en huidige gewicht berekenen we automatisch je BMI.'
        },
        {
          id: 'previous_weight_loss_attempts',
          type: 'checkbox',
          title: 'Wat heb je eerder gedaan om af te vallen?',
          help: 'Je kunt meerdere antwoorden kiezen.',
          exclusiveValues: ['not_tried'],
          options: [
            {
              value: 'diet',
              label: 'Zelf mijn voeding of eetpatroon aangepast'
            },
            {
              value: 'exercise',
              label: 'Meer bewogen of gesport'
            },
            {
              value: 'dietitian',
              label:
                'Begeleiding gehad van een diëtist of voedingsdeskundige'
            },
            {
              value: 'gli',
              label: 'Een gecombineerde leefstijlinterventie (GLI) gevolgd'
            },
            {
              value: 'other_program',
              label: 'Een ander afvalprogramma of begeleidingstraject gevolgd'
            },
            {
              value: 'weight_loss_medication',
              label: 'Medicatie gebruikt om af te vallen'
            },
            {
              value: 'bariatric_surgery',
              label:
                'Een maagverkleining of andere operatie voor gewichtsverlies gehad'
            },
            {
              value: 'not_tried',
              label: 'Ik heb nog niet eerder geprobeerd af te vallen'
            },
            {
              value: 'other',
              label: 'Anders, namelijk'
            }
                    ]
        },
        {
          id: 'previous_weight_loss_medications',
          type: 'checkbox',
          title: 'Welke medicatie heb je eerder gebruikt om af te vallen?',
          help: 'Je kunt meerdere behandelingen selecteren.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_attempts) &&
            answers.previous_weight_loss_attempts.includes(
              'weight_loss_medication'
            ),
          options: [
            { value: 'wegovy', label: 'Wegovy®' },
            { value: 'mounjaro', label: 'Mounjaro®' },
            { value: 'ozempic', label: 'Ozempic®' },
            { value: 'saxenda', label: 'Saxenda®' },
            { value: 'mysimba', label: 'Mysimba®' },
            { value: 'rybelsus', label: 'Rybelsus®' },
            { value: 'other', label: 'Andere medicatie' }
          ]
        },
        {
          id: 'previous_weight_loss_medication_details',
          type: 'medication_history',
          title: 'Vertel ons iets meer over de medicatie die je hebt gebruikt',
          help:
            'Vul per behandeling de periode in waarin je deze hebt gebruikt. Waar relevant vragen we ook naar de laatst gebruikte dosering.',
          condition: () =>
            Array.isArray(answers.previous_weight_loss_medications) &&
            answers.previous_weight_loss_medications.length > 0
        },
        {
          id: 'weight_related_conditions',
          section: 'health',
          type: 'checkbox',
          title: 'Heb je één of meer van de volgende gewichtsgerelateerde aandoeningen of klachten?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'high_blood_pressure',
              label: 'Hoge bloeddruk'
            },
            {
              value: 'high_cholesterol',
              label: 'Verhoogd cholesterol of verhoogde bloedvetten'
            },
            {
              value: 'prediabetes',
              label: 'Prediabetes'
            },
            {
              value: 'type_2_diabetes',
              label: 'Diabetes type 2'
            },
            {
              value: 'type_1_or_other_diabetes',
              label: 'Diabetes type 1 of een andere vorm van diabetes'
            },
            {
              value: 'sleep_apnea',
              label: 'Slaapapneu (OSAS)'
            },
            {
              value: 'cardiovascular_disease',
              label: 'Een hart- of vaatziekte'
            },
            {
              value: 'fatty_liver',
              label: 'Leververvetting'
            },
            {
              value: 'pcos',
              label: 'PCOS'
            },
                        {
              value: 'osteoarthritis',
              label: 'Artrose aan de knie of heup'
            },
            {
              value: 'none',
              label: 'Geen van bovenstaande'
            },
            {
              value: 'other',
              label: 'Andere gewichtsgerelateerde aandoening, namelijk'
            }
          ]
        },
        {
          id: 'pancreas_conditions',
          section: 'health',
          type: 'checkbox',
          title:
            'Heb je één of meer van de volgende aandoeningen of behandelingen aan de alvleesklier gehad?',
          help: 'Selecteer alles wat op jou van toepassing is.',
          exclusiveValues: ['none'],
          options: [
            {
              value: 'pancreatitis',
              label: 'Een ontsteking van de alvleesklier (pancreatitis)'
            },
            {
              value: 'other_pancreas_condition',
              label: 'Een andere aandoening of afwijking aan de alvleesklier'
            },
            {
  value: 'pancreas_removed',
  label:
    'Mijn alvleesklier is gedeeltelijk of volledig verwijderd'
},
{
  value: 'none',
  label: 'Ik heb geen aandoeningen of behandelingen aan de alvleesklier gehad'
}
]
},
{
  id: 'gallbladder_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende galblaasproblemen gehad?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'gallstones',
      label: 'Galstenen'
    },
    {
      value: 'gallbladder_inflammation',
      label: 'Een ontsteking van de galblaas'
    },
    {
  value: 'gallbladder_removed',
  label: 'Mijn galblaas is verwijderd'
},
{
  value: 'none',
  label: 'Geen van bovenstaande'
}
]
},
{
  id: 'current_gallbladder_symptoms',
  section: 'health',
  type: 'radio',
  title:
    'Heb je op dit moment klachten die mogelijk te maken hebben met je galblaas of galwegen?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.gallbladder_conditions
    )
      ? answers.gallbladder_conditions
      : [];

    return [
      'gallstones',
      'gallbladder_inflammation',
      'gallbladder_removed'
    ].some((value) => selectedConditions.includes(value));
  },
    options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'other_health_conditions',
  section: 'health',
  type: 'checkbox',
  title: 'Heb je één of meer van de volgende aandoeningen?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'severe_gastrointestinal_condition',
      label: 'Een ernstige maag- of darmaandoening'
    },
    {
      value: 'kidney_condition',
      label: 'Een nierziekte of verminderde nierfunctie'
    },
    {
      value: 'liver_condition',
      label: 'Een leverziekte'
    },
    {
      value: 'thyroid_condition',
      label:
        'Een schildklieraandoening, schildklierknobbels of schildklierkanker'
    },
    {
      value: 'epilepsy',
      label: 'Epilepsie of andere aanvallen'
    },
    {
      value: 'cancer',
      label: 'Kanker'
    },
    {
      value: 'other',
      label: 'Een andere ernstige of chronische aandoening'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'health_conditions_treatment_status',
  section: 'health',
  type: 'radio',
  title:
    'Word je hiervoor momenteel behandeld of is de aandoening onder controle?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.other_health_conditions
    )
      ? answers.other_health_conditions
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication',
  section: 'health',
  type: 'radio',
  title:
    'Gebruik je op dit moment medicijnen, anders dan medicatie om af te vallen?',
  help:
    'Denk ook aan medicijnen die je alleen af en toe of zo nodig gebruikt.',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'current_medication_details',
  section: 'health',
  type: 'textarea',
  title: 'Welke medicijnen gebruik je op dit moment?',
  help:
    'Vermeld per medicijn de naam, dosering en hoe vaak je het gebruikt.',
  label: 'Medicijn(en)',
  placeholder:
    'Bijvoorbeeld: Metformine 500 mg, twee keer per dag',
  condition: () => answers.current_medication === 'yes'
},
{
  id: 'medication_allergies',
  section: 'health',
  type: 'radio',
  title:
    'Ben je allergisch of overgevoelig voor medicijnen of andere stoffen?',
  options: [
    {
      value: 'yes',
      label: 'Ja'
    },
    {
      value: 'no',
      label: 'Nee'
    }
  ]
},
{
  id: 'medication_allergy_details',
  section: 'health',
  type: 'textarea',
  title: 'Waar ben je allergisch of overgevoelig voor?',
  help:
    'Vermeld het medicijn of de stof en beschrijf welke reactie je krijgt.',
  label: 'Allergie of overgevoeligheid',
  placeholder:
    'Bijvoorbeeld: penicilline – huiduitslag en zwelling',
  errorMessage:
    'Vul in waarvoor je allergisch of overgevoelig bent en welke reactie je krijgt.',
  condition: () => answers.medication_allergies === 'yes'
},
{
  id: 'eating_disorder_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden last gehad van een eetstoornis of ernstige problemen met eten?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'anorexia',
      label: 'Anorexia nervosa'
    },
    {
      value: 'bulimia',
      label: 'Boulimia nervosa'
    },
    {
      value: 'binge_eating',
      label: 'Eetbuien of een eetbuistoornis'
    },
    {
      value: 'other',
      label: 'Een andere eetstoornis of ernstige problemen met eten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'eating_disorder_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze eetproblemen of deze eetstoornis op dit moment nog?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.eating_disorder_history
    )
      ? answers.eating_disorder_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current',
      label: 'Ja, dit speelt op dit moment'
    },
    {
      value: 'past',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'mental_health_history',
  section: 'health',
  type: 'checkbox',
  title:
    'Heb je nu of in het verleden te maken gehad met psychische klachten of een psychische aandoening?',
  help: 'Selecteer alles wat op jou van toepassing is.',
  exclusiveValues: ['none'],
  options: [
    {
      value: 'depression',
      label: 'Depressie'
    },
    {
      value: 'anxiety_or_panic',
      label: 'Angstklachten of een paniekstoornis'
    },
    {
      value: 'bipolar_disorder',
      label: 'Een bipolaire stoornis'
    },
    {
      value: 'psychosis',
      label: 'Een psychose of schizofrenie'
    },
    {
      value: 'other',
      label: 'Een andere psychische aandoening of ernstige psychische klachten'
    },
    {
      value: 'none',
      label: 'Geen van bovenstaande'
    }
  ]
},
{
  id: 'mental_health_current_status',
  section: 'health',
  type: 'radio',
  title:
    'Spelen deze psychische klachten op dit moment nog of word je hiervoor behandeld?',
  condition: () => {
    const selectedConditions = Array.isArray(
      answers.mental_health_history
    )
      ? answers.mental_health_history
      : [];

    return selectedConditions.some(
      (value) => value !== 'none'
    );
  },
  options: [
    {
      value: 'current_or_treatment',
      label:
        'Ja, ik heb op dit moment klachten en/of word hiervoor behandeld'
    },
    {
      value: 'past_only',
      label: 'Nee, dit speelde alleen in het verleden'
    }
  ]
},
{
  id: 'additional_health_information',
  section: 'health',
  type: 'textarea',
  title:
    'Is er nog iets over je gezondheid dat belangrijk kan zijn voor de beoordeling van je aanvraag?',
  help:
    'Denk aan klachten, onderzoeken, behandelingen of andere medische informatie die nog niet aan bod is gekomen.',
  label: 'Aanvullende informatie',
  placeholder: 'Vul hier eventueel een toelichting in',
  required: false
},
{
  id: 'lsp_consent',
  section: 'final',
  condition: () => isNetherlands,
  type: 'radio',
  title:
    'Geef je toestemming voor het delen van je medische gegevens via het Landelijk Schakelpunt?',
  help:
    'Het LSP (Landelijk Schakelpunt) is een beveiligd netwerk waarmee je arts en apotheek relevante medische gegevens kunnen uitwisselen. Met jouw toestemming kunnen zij je belangrijkste medische gegevens en medicatieoverzicht raadplegen. Dit helpt om te controleren of de behandeling veilig bij jouw situatie past. Let op: geef je geen toestemming, dan kan de apotheek je behandeling mogelijk niet uitleveren of kan er vertraging ontstaan.',
  defaultValue: 'yes',
    options: [
    {
      value: 'yes',
      label: 'Ja, ik geef toestemming'
    },
    {
      value: 'no',
      label: 'Nee, ik geef geen toestemming'
    }
  ]
},
{
  id: 'bsn',
  section: 'final',
  condition: () => isNetherlands,
  type: 'bsn',
  title: 'Wat is je burgerservicenummer (BSN)?',
  help:
    'Je BSN bestaat uit 9 cijfers. Je vindt het onder andere op je paspoort, identiteitskaart of rijbewijs.'
},
{
  id: 'final_declarations',
  section: 'final',
  type: 'checkbox',
  title: 'Bevestig de volgende verklaringen',
  help:
    'Vink alle verklaringen aan om verder te gaan.',
  requireAll: true,
  options: [
    {
      value: 'truthful_and_complete',
      label:
        'Ik verklaar dat ik alle vragen naar waarheid en zo volledig mogelijk heb beantwoord.'
    },
    {
      value: 'doctor_review',
      label:
        'Ik begrijp dat een arts mijn aanvraag beoordeelt en dat deze beoordeling niet automatisch betekent dat een behandeling wordt voorgeschreven.'
    },
        {
      value: 'personal_use',
      label:
        'Ik verklaar dat deze aanvraag uitsluitend voor mijzelf is en dat een eventueel voorgeschreven behandeling alleen door mij wordt gebruikt.'
    },
    {
      value: 'terms_and_privacy',
      label:
        'Ik ga akkoord met de Kearty algemene voorwaarden en het privacy statement.',
      labelHtml:
        `Ik ga akkoord met de <a class="kq__answer-link" href="${escapeHtml(termsUrl)}" target="_blank" rel="noopener noreferrer">Kearty algemene voorwaarden</a> en het <a class="kq__answer-link" href="${escapeHtml(privacyUrl)}" target="_blank" rel="noopener noreferrer">privacy statement</a>.`
    }
  ]
},
];

      const previousMedicationLabels = {
        wegovy: 'Wegovy®',
        mounjaro: 'Mounjaro®',
        ozempic: 'Ozempic®',
        saxenda: 'Saxenda®',
        mysimba: 'Mysimba®',
        rybelsus: 'Rybelsus®'
      };

      const previousMedicationDosages = {
        wegovy: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '1_7_mg', label: '1,7 mg' },
          { value: '2_4_mg', label: '2,4 mg' }
        ],
        mounjaro: [
          { value: '2_5_mg', label: '2,5 mg' },
          { value: '5_mg', label: '5 mg' },
          { value: '7_5_mg', label: '7,5 mg' },
          { value: '10_mg', label: '10 mg' },
          { value: '12_5_mg', label: '12,5 mg' },
          { value: '15_mg', label: '15 mg' }
        ],
        ozempic: [
          { value: '0_25_mg', label: '0,25 mg' },
          { value: '0_5_mg', label: '0,5 mg' },
          { value: '1_0_mg', label: '1 mg' },
          { value: '2_0_mg', label: '2 mg' }
        ],
        rybelsus: [
          { value: '1_5_mg', label: '1,5 mg' },
          { value: '4_mg', label: '4 mg' },
          { value: '9_mg', label: '9 mg' }
        ]
      };

      const medicationMonthOptions = [
        { value: '1', label: 'Januari' },
        { value: '2', label: 'Februari' },
        { value: '3', label: 'Maart' },
        { value: '4', label: 'April' },
        { value: '5', label: 'Mei' },
        { value: '6', label: 'Juni' },
        { value: '7', label: 'Juli' },
        { value: '8', label: 'Augustus' },
        { value: '9', label: 'September' },
        { value: '10', label: 'Oktober' },
        { value: '11', label: 'November' },
        { value: '12', label: 'December' }
      ];

      const getMedicationMonthLabel = (month) => {
        const option = medicationMonthOptions.find(
          (item) => Number(item.value) === Number(month)
        );

        return option?.label || String(month || '');
      };

      const getVisibleQuestions = () =>
        questions.filter(
          (question) =>
            typeof question.condition !== 'function' || question.condition()
        );

      // Remove obsolete branches before evaluating dependent conditions.
      const pruneHiddenAnswers = () => {
        questions.forEach((question) => {
          if (
            question.type === 'treatment_recommendation' ||
            (typeof question.condition === 'function' && !question.condition())
          ) {
            delete answers[question.id];
            delete answers[`${question.id}_other`];
          } else {
            const value = answers[question.id];
            const hasOther = Array.isArray(value)
              ? value.includes('other')
              : value === 'other';

            if (!hasOther) {
              delete answers[`${question.id}_other`];
            }
          }
        });
      };

      // The active route and rendered definitions determine the submission.
      // Only questions that are currently visible and were actually rendered are sent.
      const getSubmissionQuestions = () =>
        getVisibleQuestions().filter(
          (question) =>
            question.type !== 'treatment_recommendation' &&
            shownQuestions.has(question.id)
        );

      const serializeAnswers = () => {
        const result = {};

        getSubmissionQuestions().forEach((question) => {
          if (Object.prototype.hasOwnProperty.call(answers, question.id)) {
            result[question.id] = answers[question.id];
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));

          if (hasOtherAnswer) {
            const otherKey = `${question.id}_other`;

            if (Object.prototype.hasOwnProperty.call(answers, otherKey)) {
              result[otherKey] = answers[otherKey];
            }
          }
        });

        return structuredClone(result);
      };

      const getOtherFieldQuestionText = (question) => {
        if (question.type === 'radio') {
          return 'Welke behandeling heb je gebruikt?';
        }

        return 'Anders, namelijk';
      };

      const serializeQuestions = () => {
        const definitions = [];

        getSubmissionQuestions().forEach((question) => {
          const definition = shownQuestions.get(question.id);

          if (definition) {
            definitions.push(definition);
          }

          const value = answers[question.id];
          const hasOtherAnswer =
            value === 'other' ||
            (Array.isArray(value) && value.includes('other'));
          const otherKey = `${question.id}_other`;

          if (
            hasOtherAnswer &&
            Object.prototype.hasOwnProperty.call(answers, otherKey)
          ) {
            definitions.push({
              id: otherKey,
              type: 'textarea',
              question: getOtherFieldQuestionText(question),
              help: null,
              answers: null
            });
          }
        });

        return structuredClone(definitions);
      };

      // Composite medication_history fields must be described exactly as shown.
      // Definitions are nested under the parent question in detail.questions.
      const serializeMedicationSubquestions = (cards) =>
        cards.flatMap((card) => {
          const treatment = card.dataset.medicationKey || '';
          const medicationName = card.dataset.medicationName || treatment;
          const textContent = (element) =>
            element?.textContent.trim().replace(/\s+/g, ' ') || '';
          const definitions = [];

          definitions.push({
            id: `${treatment}.medication`,
            question: 'Welke medicatie heb je gebruikt?',
            type: 'select',
            answers: treatment
              ? { [treatment]: medicationName }
              : null
          });

          const dosageField = card.querySelector(
            '[data-kq-medication-dosage]'
          );

          if (dosageField) {
            const dosageDefinition = {
              id: `${treatment}.last_dosage`,
              question: 'Welke dosering gebruikte je het laatst?',
              type: dosageField.tagName === 'SELECT' ? 'select' : 'text'
            };

            if (dosageField.tagName === 'SELECT') {
              dosageDefinition.answers = Object.fromEntries(
                Array.from(dosageField.options)
                  .filter((option) => option.value !== '')
                  .map((option) => [option.value, textContent(option)])
              );
            }

            definitions.push(dosageDefinition);
          }

          definitions.push({
            id: `${treatment}.start_date`,
            question: 'Wanneer ben je met deze behandeling gestart?',
            type: 'month_year'
          });

          const statusField = card.querySelector(
            '[data-kq-medication-status]'
          );

          definitions.push({
            id: `${treatment}.usage_status`,
            question: 'Gebruik je deze behandeling op dit moment nog?',
            type: 'select',
            answers: statusField
              ? Object.fromEntries(
                  Array.from(statusField.options)
                    .filter((option) => option.value !== '')
                    .map((option) => [option.value, textContent(option)])
                )
              : {
                  still_using: 'Ja, ik gebruik deze behandeling nog',
                  stopped: 'Nee, ik ben hiermee gestopt'
                }
          });

          if (statusField?.value === 'stopped') {
            definitions.push({
              id: `${treatment}.end_date`,
              question: 'Wanneer ben je met deze behandeling gestopt?',
              type: 'month_year',
              condition: "usage_status === 'stopped'"
            });
          }

          return definitions;
        });

      const getQuestion = (questionId) =>
        questions.find((question) => question.id === questionId);

      const getFirstFinalQuestionId = () =>
        isNetherlands
          ? 'lsp_consent'
          : 'final_declarations';

      const setActiveSection = (sectionKey) => {
        const sectionOrder = ['about', 'health', 'final'];
        const activeIndex = sectionOrder.indexOf(sectionKey);

        root.querySelectorAll('[data-kq-progress-step]').forEach((step) => {
          const stepIndex = sectionOrder.indexOf(
            step.getAttribute('data-kq-progress-step')
          );

          step.classList.toggle('is-active', stepIndex === activeIndex);
          step.classList.toggle('is-complete', stepIndex < activeIndex);

          if (stepIndex === activeIndex) {
            step.setAttribute('aria-current', 'step');
          } else {
            step.removeAttribute('aria-current');
          }
        });

        const progressFill = root.querySelector('[data-kq-progress-fill]');

        if (progressFill) {
          progressFill.style.width =
            activeIndex === 0 ? '0%' : activeIndex === 1 ? '50%' : '100%';
        }
      };

      const renderError = (message) => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = message;
        errorElement.hidden = false;
      };

      const clearError = () => {
        const errorElement = questionRegion.querySelector('[data-kq-error]');

        if (!errorElement) return;

        errorElement.textContent = '';
        errorElement.hidden = true;

        questionRegion
          .querySelectorAll('.has-error')
          .forEach((field) => field.classList.remove('has-error'));
      };

      const updateSelectedRows = () => {
        questionRegion
          .querySelectorAll('.kq__answer-row')
          .forEach((row) => {
            const input = row.querySelector('input');
            row.classList.toggle('is-selected', Boolean(input?.checked));
          });
      };

      const calculateAge = (day, month, year) => {
        const today = new Date();
        let age = today.getFullYear() - year;

        const birthdayPassed =
          today.getMonth() + 1 > month ||
          (today.getMonth() + 1 === month && today.getDate() >= day);

        if (!birthdayPassed) age -= 1;

        return age;
      };

      const isValidDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);

        return (
          date.getFullYear() === year &&
          date.getMonth() === month - 1 &&
          date.getDate() === day
        );
      };

      const isPastDate = (day, month, year) => {
        const date = new Date(year, month - 1, day);
        const today = new Date();

        today.setHours(0, 0, 0, 0);

        return date < today;
      };

      const padDatePart = (value) =>
        String(value).padStart(2, '0');

      const formatDateOfBirth = (day, month, year) =>
        `${padDatePart(day)}-${padDatePart(month)}-${year}`;

      const parseDateOfBirth = (value) => {
        const match = /^(\d{2})-(\d{2})-(\d{4})$/.exec(
          String(value || '')
        );

        if (!match) return null;

        return {
          day: Number.parseInt(match[1], 10),
          month: Number.parseInt(match[2], 10),
          year: Number.parseInt(match[3], 10)
        };
      };

      const isValidBsn = (value) => {
        const bsn = String(value || '').replace(/\D/g, '');

        if (!/^\d{9}$/.test(bsn)) {
          return false;
        }

        if (bsn === '000000000') {
          return false;
        }

        const digits = bsn.split('').map(Number);

        const sum =
          digits[0] * 9 +
          digits[1] * 8 +
          digits[2] * 7 +
          digits[3] * 6 +
          digits[4] * 5 +
          digits[5] * 4 +
          digits[6] * 3 +
          digits[7] * 2 -
          digits[8];

        return sum % 11 === 0;
      };

      const renderDateQuestion = (question) => {
        const saved = parseDateOfBirth(answers[question.id]) || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__field-group">
            <div class="kq__date-grid">
              <label>
                <span class="kq__field-label">Dag</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-day"
                  maxlength="2"
                  placeholder="DD"
                  value="${escapeHtml(saved.day || '')}"
                  data-kq-date-day
                >
              </label>

              <label>
                <span class="kq__field-label">Maand</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-month"
                  maxlength="2"
                  placeholder="MM"
                  value="${escapeHtml(saved.month || '')}"
                  data-kq-date-month
                >
              </label>

              <label class="kq__date-year">
                <span class="kq__field-label">Jaar</span>
                <input
                  class="kq__field"
                  type="text"
                  inputmode="numeric"
                  autocomplete="bday-year"
                  maxlength="4"
                  placeholder="JJJJ"
                  value="${escapeHtml(saved.year || '')}"
                  data-kq-date-year
                >
              </label>
            </div>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderRadioQuestion = (question) => {
        const selectedValue =
  answers[question.id] ?? question.defaultValue ?? '';

  const options = question.options
    .map(
      (option) => `
        <label class="kq__answer-row ${
          selectedValue === option.value
            ? 'is-selected'
            : ''
        }">
          <input
            type="radio"
            name="kq-${question.id}"
            value="${escapeHtml(option.value)}"
            ${selectedValue === option.value ? 'checked' : ''}
          >

          <span class="kq__answer-label">
            ${escapeHtml(option.label)}
          </span>
        </label>
      `
    )
    .join('');

  const hasOtherOption = question.options.some(
    (option) => option.value === 'other'
  );

  const otherValue =
    answers[`${question.id}_other`] || '';

  const otherVisible =
    selectedValue === 'other';

  const otherFieldHtml = hasOtherOption
    ? `
      <div
        class="kq__other-field ${
          otherVisible ? 'is-visible' : ''
        }"
        data-kq-other-field
      >
        <label>
          <span class="kq__field-label">
            Welke behandeling heb je gebruikt?
          </span>

          <input
            class="kq__field"
            type="text"
            value="${escapeHtml(otherValue)}"
            placeholder="Vul de naam van de behandeling in"
            data-kq-other-input
          >
        </label>
      </div>
    `
    : '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `
          <p class="kq__question-help">
            ${escapeHtml(question.help)}
          </p>
        `
        : ''
    }

    <div class="kq__answer-list">
      ${options}
    </div>

    ${otherFieldHtml}

    <p
      class="kq__error"
      data-kq-error
      hidden
    ></p>
  `;
};

      const renderCheckboxQuestion = (question) => {
        const selectedValues = Array.isArray(answers[question.id])
          ? answers[question.id]
          : [];

        const options = question.options
          .map(
            (option) => `
              <label class="kq__answer-row ${
                selectedValues.includes(option.value) ? 'is-selected' : ''
              }">
                <input
                  type="checkbox"
                  name="kq-${question.id}"
                  value="${escapeHtml(option.value)}"
                  ${
                    selectedValues.includes(option.value)
                      ? 'checked'
                      : ''
                  }
                >
                <span class="kq__answer-label">
                  ${
                    option.labelHtml
                      ? option.labelHtml
                      : escapeHtml(option.label)
                  }
                </span>
              </label>
            `
          )
          .join('');

        const otherValue = answers[`${question.id}_other`] || '';
        const otherVisible = selectedValues.includes('other');

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

          ${
            question.help
              ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
              : ''
          }

          <div class="kq__answer-list">
            ${options}
          </div>

          <div class="kq__other-field ${
            otherVisible ? 'is-visible' : ''
          }" data-kq-other-field>
            <label>
              <span class="kq__field-label">Anders, namelijk</span>
              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(otherValue)}"
                data-kq-other-input
              >
            </label>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };
const renderMedicationHistoryQuestion = (question) => {
  const selectedMedications = Array.isArray(
    answers.previous_weight_loss_medications
  )
    ? answers.previous_weight_loss_medications
    : [];

  const savedHistory = Array.isArray(answers[question.id])
    ? answers[question.id]
    : [];

  const monthOptionsHtml = (selectedValue = '') =>
    `
      <option value="">Kies maand</option>
      ${medicationMonthOptions
        .map(
          (month) => `
            <option
              value="${escapeHtml(month.value)}"
              ${String(selectedValue) === month.value ? 'selected' : ''}
            >
              ${escapeHtml(month.label)}
            </option>
          `
        )
        .join('')}
    `;

  const cards = selectedMedications
    .map((medicationKey) => {
      const saved =
        savedHistory.find(
          (item) => item.treatment === medicationKey
        ) || {};

      const medicationName =
        medicationKey === 'other'
          ? answers.previous_weight_loss_medications_other?.trim() ||
            'Andere medicatie'
          : previousMedicationLabels[medicationKey] || medicationKey;

      const dosageOptions =
        previousMedicationDosages[medicationKey] || null;

      const dosageNotApplicable =
        ['saxenda', 'mysimba'].includes(medicationKey);

      const dosageField = dosageNotApplicable
        ? ''
        : dosageOptions
          ? `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <select
                class="kq__field"
                data-kq-medication-dosage
              >
                <option value="">Kies dosering</option>
                ${dosageOptions
                  .map(
                    (option) => `
                      <option
                        value="${escapeHtml(option.value)}"
                        ${saved.last_dosage === option.value ? 'selected' : ''}
                      >
                        ${escapeHtml(option.label)}
                      </option>
                    `
                  )
                  .join('')}
              </select>
            </label>
          `
          : `
            <label>
              <span class="kq__field-label">
                Welke dosering gebruikte je het laatst?
              </span>

              <input
                class="kq__field"
                type="text"
                value="${escapeHtml(saved.last_dosage || '')}"
                placeholder="Vul de dosering in"
                data-kq-medication-dosage
              >
            </label>
          `;

      const usageStatus = saved.still_using
        ? 'still_using'
        : saved.usage_status || '';

      return `
        <div
          class="kq__medication-card"
          data-kq-medication-card
          data-medication-key="${escapeHtml(medicationKey)}"
          data-medication-name="${escapeHtml(medicationName)}"
        >
          <h2 class="kq__medication-card-title">
            ${escapeHtml(medicationName)}
          </h2>

          <div class="kq__medication-fields">
            ${dosageField}

            <div>
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestart?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-start-month
                  >
                    ${monthOptionsHtml(saved.started_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.started_year || '')}"
                    data-kq-medication-start-year
                  >
                </label>
              </div>

              <p class="kq__medication-help">
                Een schatting van de maand is voldoende.
              </p>
            </div>

            <label class="kq__medication-status">
              <span class="kq__field-label">
                Gebruik je deze behandeling op dit moment nog?
              </span>

              <select
                class="kq__field"
                data-kq-medication-status
              >
                <option value="">Maak een keuze</option>
                <option
                  value="still_using"
                  ${usageStatus === 'still_using' ? 'selected' : ''}
                >
                  Ja, ik gebruik deze behandeling nog
                </option>
                <option
                  value="stopped"
                  ${usageStatus === 'stopped' ? 'selected' : ''}
                >
                  Nee, ik ben hiermee gestopt
                </option>
              </select>
            </label>

            <div
              class="kq__medication-end-date"
              data-kq-medication-end-date
              ${usageStatus === 'stopped' ? '' : 'hidden'}
            >
              <span class="kq__field-label">
                Wanneer ben je met deze behandeling gestopt?
              </span>

              <div class="kq__medication-period">
                <label>
                  <span class="kq__field-label">Maand</span>
                  <select
                    class="kq__field"
                    data-kq-medication-end-month
                  >
                    ${monthOptionsHtml(saved.ended_month || '')}
                  </select>
                </label>

                <label>
                  <span class="kq__field-label">Jaar</span>
                  <input
                    class="kq__field"
                    type="text"
                    inputmode="numeric"
                    maxlength="4"
                    placeholder="JJJJ"
                    value="${escapeHtml(saved.ended_year || '')}"
                    data-kq-medication-end-year
                  >
                </label>
              </div>
            </div>
          </div>
        </div>
      `;
    })
    .join('');

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__medication-history">
      ${cards}
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const saveMedicationHistoryDraft = (question) => {
  if (question.type !== 'medication_history') return;

  const historyItems = Array.from(
    questionRegion.querySelectorAll('[data-kq-medication-card]')
  ).map((card) => {
    const usageStatus =
      card.querySelector('[data-kq-medication-status]')?.value || '';

    const dosageField = card.querySelector(
      '[data-kq-medication-dosage]'
    );

    const item = {
      treatment: card.dataset.medicationKey || '',
      started_month:
        card.querySelector('[data-kq-medication-start-month]')?.value || '',
      started_year:
        card.querySelector('[data-kq-medication-start-year]')?.value.trim() || '',
      usage_status: usageStatus,
      still_using: usageStatus === 'still_using',
      ended_month:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-month]')?.value || ''
          : '',
      ended_year:
        usageStatus === 'stopped'
          ? card.querySelector('[data-kq-medication-end-year]')?.value.trim() || ''
          : ''
    };

    if (dosageField) {
      item.last_dosage = dosageField.value.trim();
    }

    return item;
  });

  answers[question.id] = historyItems;
};

const renderBsnQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">
      ${escapeHtml(question.title)}
    </h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group kq__bsn-field">
      <label>
        <span class="kq__field-label">
          Burgerservicenummer
        </span>

        <input
          class="kq__field"
          type="text"
          inputmode="numeric"
          maxlength="9"
          autocomplete="off"
          placeholder="123456789"
          value="${escapeHtml(savedValue)}"
          data-kq-bsn
        >
      </label>
    </div>

    <div class="kq__bsn-info">
      <span
        class="kq__bsn-info-icon"
        aria-hidden="true"
      >
        <svg
          viewBox="0 0 24 24"
          width="22"
          height="22"
          fill="none"
        >
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M12 10.5v6"></path>
          <circle
            cx="12"
            cy="7.5"
            r=".8"
            fill="currentColor"
            stroke="none"
          ></circle>
        </svg>
      </span>

      <div>
        <p class="kq__bsn-info-title">
          Waarom vragen we je BSN?
        </p>

        <p class="kq__bsn-info-text">
          Voor de uitvoering van medische zorg zijn de arts en apotheek wettelijk verplicht je BSN te gebruiken. Met je BSN kunnen zij controleren dat je aanvraag, medische gegevens en eventuele recept bij de juiste persoon horen.
          <br><br>
          Voor jouw veiligheid en om zorgvuldig met je gegevens om te gaan, slaat Kearty je BSN niet zelf op. Het nummer wordt alleen veilig doorgegeven aan de betrokken zorgverleners binnen jouw behandeling.
        </p>
      </div>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};

const renderTextareaQuestion = (question) => {
  const savedValue = answers[question.id] || '';

  return `
    <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>

    ${
      question.help
        ? `<p class="kq__question-help">${escapeHtml(question.help)}</p>`
        : ''
    }

    <div class="kq__field-group">
      <label>
        ${
          question.label
            ? `<span class="kq__field-label">${escapeHtml(question.label)}</span>`
            : ''
        }

        <textarea
          class="kq__field kq__textarea"
          rows="6"
          placeholder="${escapeHtml(question.placeholder || '')}"
          data-kq-textarea
        >${escapeHtml(savedValue)}</textarea>
      </label>
    </div>

    <p class="kq__error" data-kq-error hidden></p>
  `;
};
const treatmentRecommendations = {
  saxenda: {
    profile: 'saxenda',
    shopifyKey: 'saxenda',
    displayName: 'Saxenda®',
    dosage: '',
    subtitle: 'Dagelijkse injectie',
    quantity: '5 prikpennen'
  },

  mounjaro_2_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro25',
    displayName: 'Mounjaro®',
    dosage: '2,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro5',
    displayName: 'Mounjaro®',
    dosage: '5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_7_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro75',
    displayName: 'Mounjaro®',
    dosage: '7,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_10: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro10',
    displayName: 'Mounjaro®',
    dosage: '10 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_12_5: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro125',
    displayName: 'Mounjaro®',
    dosage: '12,5 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  mounjaro_15: {
    profile: 'mounjaro',
    shopifyKey: 'mounjaro15',
    displayName: 'Mounjaro®',
    dosage: '15 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },

  wegovy_0_25: {
    profile: 'wegovy',
    shopifyKey: 'wegovy025',
    displayName: 'Wegovy®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  wegovy_0_5: {
  profile: 'wegovy',
  shopifyKey: 'wegovy05',
  displayName: 'Wegovy®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1: {
  profile: 'wegovy',
  shopifyKey: 'wegovy1',
  displayName: 'Wegovy®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_1_7: {
  profile: 'wegovy',
  shopifyKey: 'wegovy17',
  displayName: 'Wegovy®',
  dosage: '1,7 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

wegovy_2_4: {
  profile: 'wegovy',
  shopifyKey: 'wegovy24',
  displayName: 'Wegovy®',
  dosage: '2,4 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

  ozempic_0_25: {
    profile: 'ozempic',
    shopifyKey: 'ozempic025',
    displayName: 'Ozempic®',
    dosage: '0,25 mg',
    subtitle: 'Wekelijkse injectie',
    quantity: '4 voorgevulde pennen (voor 4 weken)'
  },
  ozempic_0_5: {
  profile: 'ozempic',
  shopifyKey: 'ozempic05',
  displayName: 'Ozempic®',
  dosage: '0,5 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_1: {
  profile: 'ozempic',
  shopifyKey: 'ozempic1',
  displayName: 'Ozempic®',
  dosage: '1 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},

ozempic_2: {
  profile: 'ozempic',
  shopifyKey: 'ozempic2',
  displayName: 'Ozempic®',
  dosage: '2 mg',
  subtitle: 'Wekelijkse injectie',
  quantity: 'Behandeling voor 4 weken'
},
  mysimba: {
  profile: 'mysimba',
  shopifyKey: 'mysimba',
  displayName: 'Mysimba®',
  dosage: '',
  subtitle: 'Behandeling met tabletten',
  quantity: '112 tabletten'
},

rybelsus_1_5: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus15',
  displayName: 'Rybelsus®',
  dosage: '1,5 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_4: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus4',
  displayName: 'Rybelsus®',
  dosage: '4 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
},

rybelsus_9: {
  profile: 'rybelsus',
  shopifyKey: 'rybelsus9',
  displayName: 'Rybelsus®',
  dosage: '9 mg',
  subtitle: 'Dagelijkse tablet',
  quantity: '30 tabletten'
}
};

const getTreatmentDatasetValue = (shopifyKey, field) => {
  const datasetKey =
    shopifyKey +
    field.charAt(0).toUpperCase() +
    field.slice(1);

  return root.dataset[datasetKey] || '';
};


const getTreatmentName = (treatmentKey) => {
  const treatmentConfig = treatmentRecommendations[treatmentKey];

  if (!treatmentConfig) return '';

  return [
    treatmentConfig.displayName,
    treatmentConfig.dosage
  ]
    .filter(Boolean)
    .join(' ');
};

const resolveInitialTreatment = () => {
  const params = new URLSearchParams(window.location.search);
  const requestedTreatment = (params.get('treatment') || '').trim();
  const requestedVariantId = (
    params.get('variant') ||
    params.get('variantId') ||
    ''
  ).trim();

  if (requestedTreatment) {
    const treatmentConfig = treatmentRecommendations[requestedTreatment];

    if (!Object.prototype.hasOwnProperty.call(treatmentRecommendations, requestedTreatment)) {
      return { error: 'unknown_treatment' };
    }

    const configuredVariantId = getTreatmentDatasetValue(
      treatmentConfig.shopifyKey,
      'variantId'
    );

    const isAvailable =
      getTreatmentDatasetValue(
        treatmentConfig.shopifyKey,
        'available'
      ) === 'true';

    if (!/^[1-9]\d*$/.test(configuredVariantId)) {
      return { error: 'missing_variant' };
    }

    if (
      requestedVariantId &&
      String(requestedVariantId) !== String(configuredVariantId)
    ) {
      return { error: 'variant_mismatch' };
    }

    return {
      treatment: requestedTreatment,
      variantId: String(configuredVariantId),
      available: isAvailable
    };
  }

  if (requestedVariantId) {
    if (!/^[1-9]\d*$/.test(requestedVariantId)) {
      return { error: 'invalid_variant' };
    }
    const match = Object.entries(treatmentRecommendations).find(
      ([, treatmentConfig]) => {
        const configuredVariantId = getTreatmentDatasetValue(
          treatmentConfig.shopifyKey,
          'variantId'
        );

        return (
          configuredVariantId &&
          String(configuredVariantId) === String(requestedVariantId)
        );
      }
    );

    if (!match) {
      return { error: 'unknown_variant' };
    }

    const [treatment, treatmentConfig] = match;

    return {
      treatment,
      variantId: String(requestedVariantId),
      available:
        getTreatmentDatasetValue(
          treatmentConfig.shopifyKey,
          'available'
        ) === 'true'
    };
  }

  return { error: 'missing_selection' };
};

      const renderMeasurementsQuestion = (question) => {
      const saved = answers[question.id] || {};

        return `
          <h1 class="kq__question-title">${escapeHtml(question.title)}</h1>
          <p class="kq__question-help">${escapeHtml(question.help)}</p>

          <div class="kq__measurement-list">
            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Hoe lang ben je?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="numeric"
                min="120"
                max="230"
                step="1"
                value="${escapeHtml(saved.height || '')}"
                data-kq-height
              >
              <span class="kq__measurement-unit">cm</span>
            </label>

            <label class="kq__measurement-row">
              <span class="kq__measurement-label">Wat is je huidige gewicht?</span>
              <input
                class="kq__field"
                type="number"
                inputmode="decimal"
                min="35"
                max="350"
                step="0.1"
                value="${escapeHtml(saved.weight || '')}"
                data-kq-weight
              >
              <span class="kq__measurement-unit">kg</span>
            </label>
          </div>

          <div class="kq__bmi-result" data-kq-bmi-result>
            <p class="kq__bmi-value" data-kq-bmi-value></p>
            <p class="kq__bmi-description" data-kq-bmi-description></p>
          </div>

          <p class="kq__error" data-kq-error hidden></p>
        `;
      };

      const renderQuestion = () => {
  statusScreen = null;

  const question = getQuestion(currentQuestionId);

  if (!question) return;

  setActiveSection(question.section || 'about');

  if (question.type === 'date') {
    questionRegion.innerHTML = renderDateQuestion(question);
  }

  if (question.type === 'radio') {
    questionRegion.innerHTML = renderRadioQuestion(question);
  }

  if (question.type === 'checkbox') {
    questionRegion.innerHTML = renderCheckboxQuestion(question);
  }

  if (question.type === 'medication_history') {
    questionRegion.innerHTML =
      renderMedicationHistoryQuestion(question);
  }

  if (question.type === 'bsn') {
    questionRegion.innerHTML = renderBsnQuestion(question);
  }

  if (question.type === 'textarea') {
    questionRegion.innerHTML = renderTextareaQuestion(question);
  }

  if (question.type === 'measurements') {
    questionRegion.innerHTML = renderMeasurementsQuestion(question);
  }

  if (question.type !== 'treatment_recommendation') {
    const existingDefinition = shownQuestions.get(question.id);

    shownQuestions.set(question.id, {
      id: question.id,
      type: question.type === 'bsn' ? 'textarea' : question.type,
      question: question.title,
      help: question.help ?? null,
      answers: question.options
        ? Object.fromEntries(
            question.options.map((option) => [option.value, option.label])
          )
        : null,
      ...(question.type === 'medication_history'
        ? {
            subquestions:
              existingDefinition?.subquestions ?? []
          }
        : {})
    });
  }

  backButton.hidden = history.length === 0;

  nextButton.hidden = false;
  nextButton.innerHTML =
    'Verder <span aria-hidden="true">→</span>';

  bindQuestionEvents(question);


  if (question.type === 'measurements') {
    updateBmiPreview();
  }
};

    const renderStatus = ({
  title,
  message,
  type = 'stop',
  nextQuestionId = null,
  nextSection = null,
  nextButtonLabel = null
}) => {
  statusScreen = {
    title,
    message,
    type,
    nextQuestionId,
    nextSection,
    nextButtonLabel
  };

  const isAboutComplete =
    type === 'complete' &&
    nextSection === 'health';

  const isConsentIntro =
    type === 'consent_intro' &&
    nextSection === 'final';

  const isCheckoutReady =
    type === 'checkout_ready';

  const selectedTreatmentName =
    getTreatmentName(selectedTreatment);

  const stopActions =
    type === 'stop'
      ? `
        <div class="kq__status-actions">
          <a
            class="kq__status-button kq__status-button--secondary"
            href="${escapeHtml(homeUrl)}"
          >
            Naar de homepage
          </a>

          <a
            class="kq__status-button kq__status-button--primary"
            href="${escapeHtml(contactUrl)}"
          >
            Neem contact op
            <span aria-hidden="true">→</span>
          </a>
        </div>
      `
      : '';

  const aboutCompleteContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path
              d="M12 20s-7-4.35-7-10.1A4.4 4.4 0 0 1 12 6.35 4.4 4.4 0 0 1 19 9.9C19 15.65 12 20 12 20Z"
            ></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Je bent al goed op weg!
          </p>

          <p class="kq__status-motivation-text">
            In de volgende stap stellen we vragen over jouw gezondheidssituatie om te kijken of de gekozen behandeling mogelijk bij jou past.
          </p>
        </div>
      </div>

      <div class="kq__status-benefits">
        <div class="kq__status-benefit">
          <span class="kq__status-benefit-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"></path>
              <rect x="9" y="10.5" width="6" height="5" rx="1"></rect>
              <path d="M10.5 10.5V9a1.5 1.5 0 0 1 3 0v1.5"></path>
            </svg>
          </span>
          <p>100% vertrouwelijk en veilig</p>
        </div>

        <div class="kq__status-benefit">
          <span class="kq__status-benefit-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="8"></circle>
              <path d="M12 7.5V12l3 2"></path>
            </svg>
          </span>
          <p>Slechts enkele minuten</p>
        </div>

        <div class="kq__status-benefit">
          <span class="kq__status-benefit-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="6.5" r="3"></circle>
              <path d="M5.5 20v-2.2c0-4.3 2.7-7 6.5-7s6.5 2.7 6.5 7V20"></path>
              <path d="M12 13.8v4.4"></path>
              <path d="M9.8 16h4.4"></path>
            </svg>
          </span>
          <p>Beoordeeld door een arts</p>
        </div>
      </div>
    </div>
  `;

  const consentIntroText = isNetherlands
    ? 'Voordat je verdergaat naar betalen, vragen we nog om toestemming voor gegevensuitwisseling via het LSP, je BSN en een laatste bevestiging van je antwoorden. Na je betaling rond je eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.'
    : 'Voordat je verdergaat naar betalen, vragen we nog om een laatste bevestiging van je antwoorden. Na je betaling rond je eenmalig de identiteitscontrole af. Daarna beoordeelt de arts je aanvraag.';

  const consentIntroContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      <div class="kq__status-motivation">
        <span
          class="kq__status-motivation-icon"
          aria-hidden="true"
        >
          <svg viewBox="0 0 24 24">
            <path d="M12 3.5 18.5 6v5.2c0 4.2-2.8 7.9-6.5 9.1-3.7-1.2-6.5-4.9-6.5-9.1V6L12 3.5Z"></path>
            <path d="m9 12 2 2 4-4"></path>
          </svg>
        </span>

        <div class="kq__status-motivation-content">
          <p class="kq__status-motivation-title">
            Bijna klaar
          </p>

          <p class="kq__status-motivation-text">
            ${escapeHtml(consentIntroText)}
          </p>
        </div>
      </div>
    </div>
  `;

  const checkoutReadyContent = `
    <div class="kq__status-card kq__status-card--about-complete">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <span
        class="kq__status-accent-line"
        aria-hidden="true"
      ></span>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${
        selectedTreatmentName
          ? `
            <div class="kq__selected-treatment-notice">
              <span
                class="kq__selected-treatment-check"
                aria-hidden="true"
              >
                ✓
              </span>

              <p>
                Je vraagt aan: <strong>${escapeHtml(selectedTreatmentName)}</strong>
              </p>
            </div>
          `
          : ''
      }

      <div class="kq__status-actions" style="justify-content: center;">
        <button
          type="button"
          class="kq__status-button kq__status-button--primary"
          data-kq-final-checkout
          data-kq-treatment-apply
          data-treatment="${escapeHtml(selectedTreatment)}"
          data-variant-id="${escapeHtml(selectedVariantId)}"
        >
          Behandeling aanvragen
          <span aria-hidden="true">→</span>
        </button>
      </div>

      <p
        class="kq__error kq__apply-error"
        data-kq-apply-error
        hidden
      ></p>
    </div>
  `;

  const defaultStatusContent = `
    <div class="kq__status-card">
      <h1 class="kq__status-title">
        ${escapeHtml(title)}
      </h1>

      <p class="kq__status-message">
        ${escapeHtml(message)}
      </p>

      ${stopActions}
    </div>
  `;

  questionRegion.innerHTML =
    isAboutComplete
      ? aboutCompleteContent
      : isConsentIntro
        ? consentIntroContent
        : isCheckoutReady
          ? checkoutReadyContent
          : defaultStatusContent;

  if (
    type === 'complete' ||
    type === 'consent_intro'
  ) {
    setActiveSection(nextSection || 'health');

    nextButton.hidden = false;
    nextButton.innerHTML = `
      ${escapeHtml(nextButtonLabel || 'Verder')}
      <span aria-hidden="true">→</span>
    `;
  } else {
    nextButton.hidden = true;
  }
};

      const updateBmiPreview = () => {
        const heightInput = questionRegion.querySelector('[data-kq-height]');
        const weightInput = questionRegion.querySelector('[data-kq-weight]');
        const result = questionRegion.querySelector('[data-kq-bmi-result]');
        const valueElement = questionRegion.querySelector(
          '[data-kq-bmi-value]'
        );
        const descriptionElement = questionRegion.querySelector(
          '[data-kq-bmi-description]'
        );

        if (
          !heightInput ||
          !weightInput ||
          !result ||
          !valueElement ||
          !descriptionElement
        ) {
          return;
        }

        const height = Number.parseFloat(heightInput.value);
        const weight = Number.parseFloat(weightInput.value);

        if (!height || !weight || height <= 0 || weight <= 0) {
          result.classList.remove('is-visible');
          return;
        }

        const bmi = weight / Math.pow(height / 100, 2);
        const roundedBmi = bmi.toFixed(1);

      valueElement.textContent = `Jouw BMI is ${roundedBmi}`;

result.classList.remove('is-stop');

let bmiCategory = '';

if (bmi < 19) {
  bmiCategory = 'ondergewicht';
} else if (bmi < 25) {
  bmiCategory = 'gezond gewicht';
} else if (bmi < 30) {
  bmiCategory = 'overgewicht';
} else if (bmi < 35) {
  bmiCategory = 'obesitas';
} else if (bmi < 40) {
  bmiCategory = 'ernstige obesitas';
} else {
  bmiCategory = 'zeer ernstige obesitas';
}

descriptionElement.textContent =
  `Je BMI valt in de categorie ${bmiCategory}.`;

if (bmi < 25) {
  result.classList.add('is-stop');
}

result.classList.add('is-visible');
      };

      const bindQuestionEvents = (question) => {
        clearError();

        if (question.type === 'medication_history') {
          questionRegion
            .querySelectorAll(
              '[data-kq-medication-dosage], [data-kq-medication-start-month], [data-kq-medication-start-year], [data-kq-medication-status], [data-kq-medication-end-month], [data-kq-medication-end-year]'
            )
            .forEach((field) => {
              const eventName =
                field.tagName === 'SELECT' ? 'change' : 'input';

              field.addEventListener(eventName, () => {
                if (
                  field.matches(
                    '[data-kq-medication-start-year], [data-kq-medication-end-year]'
                  )
                ) {
                  field.value = field.value
                    .replace(/\D/g, '')
                    .slice(0, 4);
                }

                if (field.matches('[data-kq-medication-status]')) {
                  const card = field.closest(
                    '[data-kq-medication-card]'
                  );
                  const endDate = card?.querySelector(
                    '[data-kq-medication-end-date]'
                  );

                  if (endDate) {
                    endDate.hidden = field.value !== 'stopped';
                  }

                  if (field.value !== 'stopped' && card) {
                    const endMonth = card.querySelector(
                      '[data-kq-medication-end-month]'
                    );
                    const endYear = card.querySelector(
                      '[data-kq-medication-end-year]'
                    );

                    if (endMonth) endMonth.value = '';
                    if (endYear) endYear.value = '';
                  }
                }

                field.classList.remove('has-error');
                saveMedicationHistoryDraft(question);
                clearError();
              });
            });
        }

        questionRegion
  .querySelectorAll('input[type="radio"]')
  .forEach((input) => {
    input.addEventListener('change', () => {
      answers[question.id] = input.value;

      const otherField = questionRegion.querySelector(
        '[data-kq-other-field]'
      );

      const otherInput = questionRegion.querySelector(
        '[data-kq-other-input]'
      );

      otherField?.classList.toggle(
        'is-visible',
        input.value === 'other'
      );

      if (input.value === 'other') {
        otherInput?.focus();
      }

      updateSelectedRows();
      clearError();
    });
  });

        questionRegion
          .querySelectorAll('input[type="checkbox"]')
          .forEach((input) => {
            input.addEventListener('change', () => {
              const selectedInputs = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              );

              if (
                input.checked &&
                question.exclusiveValues?.includes(input.value)
              ) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    otherInput.checked = otherInput === input;
                  });
              } else if (input.checked) {
                questionRegion
                  .querySelectorAll('input[type="checkbox"]')
                  .forEach((otherInput) => {
                    if (
                      question.exclusiveValues?.includes(otherInput.value)
                    ) {
                      otherInput.checked = false;
                    }
                  });
              }

              answers[question.id] = Array.from(
                questionRegion.querySelectorAll(
                  'input[type="checkbox"]:checked'
                )
              ).map((checkedInput) => checkedInput.value);

              const otherField = questionRegion.querySelector(
                '[data-kq-other-field]'
              );

              otherField?.classList.toggle(
                'is-visible',
                answers[question.id].includes('other')
              );

              updateSelectedRows();
              clearError();
            });
          });

        const bsnInput = questionRegion.querySelector(
          '[data-kq-bsn]'
        );

        bsnInput?.addEventListener('input', () => {
          bsnInput.value = bsnInput.value
            .replace(/\D/g, '')
            .slice(0, 9);

          clearError();
        });

        const dateInputs = Array.from(
  questionRegion.querySelectorAll(
    '[data-kq-date-day], [data-kq-date-month], [data-kq-date-year]'
  )
);

dateInputs.forEach((input, index) => {
  input.addEventListener('input', () => {
    input.value = input.value.replace(/\D/g, '');

    const maxLength = Number.parseInt(
      input.getAttribute('maxlength'),
      10
    );

    if (
      input.value.length === maxLength &&
      dateInputs[index + 1]
    ) {
      dateInputs[index + 1].focus();
    }

    clearError();
  });

  input.addEventListener('keydown', (event) => {
    if (
      event.key === 'Backspace' &&
      input.value === '' &&
      dateInputs[index - 1]
    ) {
      dateInputs[index - 1].focus();
    }
  });
});

        questionRegion
          .querySelectorAll('[data-kq-height], [data-kq-weight]')
          .forEach((input) => {
            input.addEventListener('input', () => {
              updateBmiPreview();
              clearError();
            });
          });

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          textarea?.addEventListener('input', () => {
            answers[question.id] = textarea.value;
            textarea.classList.remove('has-error');
            clearError();
          });
        }

        questionRegion
          .querySelector('[data-kq-other-input]')
          ?.addEventListener('input', (event) => {
            answers[`${question.id}_other`] = event.target.value;
            clearError();
          });
      };

      const validateCurrentQuestion = () => {
        clearError();

        const question = getQuestion(currentQuestionId);

        if (!question) return false;

        if (question.type === 'date') {
  const dayInput = questionRegion.querySelector('[data-kq-date-day]');
  const monthInput = questionRegion.querySelector(
    '[data-kq-date-month]'
  );
  const yearInput = questionRegion.querySelector(
    '[data-kq-date-year]'
  );

  const day = Number.parseInt(dayInput.value, 10);
  const month = Number.parseInt(monthInput.value, 10);
  const year = Number.parseInt(yearInput.value, 10);

  if (!day || !month || !year) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul je volledige geboortedatum in.');
    return false;
  }

  if (!isValidDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geldige geboortedatum in.');
    return false;
  }

  if (!isPastDate(day, month, year)) {
    [dayInput, monthInput, yearInput].forEach((field) =>
      field.classList.add('has-error')
    );

    renderError('Vul een geboortedatum in het verleden in.');
    return false;
  }

  const age = calculateAge(day, month, year);

  answers[question.id] = formatDateOfBirth(day, month, year);

  if (age < 18) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
    });

    return false;
  }

  if (age > 76) {
    renderStatus({
      title:
        'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
      message:
        'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
    });

    return false;
  }

  return true;
}

        if (question.type === 'bsn') {
          const bsnInput = questionRegion.querySelector(
            '[data-kq-bsn]'
          );

          const bsn = bsnInput?.value
            .replace(/\D/g, '')
            .trim() || '';

          if (bsn.length !== 9) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Vul je BSN van 9 cijfers in.'
            );

            return false;
          }

          if (!isValidBsn(bsn)) {
            bsnInput?.classList.add('has-error');

            renderError(
              'Dit lijkt geen geldig BSN. Controleer de 9 cijfers en probeer het opnieuw.'
            );

            return false;
          }

          answers[question.id] = bsn;

          return true;
        }

        if (question.type === 'radio') {
  const checkedInput = questionRegion.querySelector(
    'input[type="radio"]:checked'
  );

  if (!checkedInput) {
    renderError('Kies één antwoord om verder te gaan.');
    return false;
  }

  answers[question.id] = checkedInput.value;

  if (checkedInput.value === 'other') {
    const otherInput = questionRegion.querySelector(
      '[data-kq-other-input]'
    );

    const otherValue =
      otherInput?.value.trim() || '';

    if (!otherValue) {
      otherInput?.classList.add('has-error');

      renderError(
        'Vul bij “Anders, namelijk” de naam van de behandeling in.'
      );

      return false;
    }

    answers[`${question.id}_other`] = otherValue;
  }

  return true;
}

        if (question.type === 'textarea') {
          const textarea = questionRegion.querySelector(
            '[data-kq-textarea]'
          );

          const value = textarea?.value.trim() || '';

          if (!value && question.required !== false) {
            textarea?.classList.add('has-error');

            renderError(
              question.errorMessage ||
                'Vul de gevraagde informatie in om verder te gaan.'
            );

            return false;
          }

          answers[question.id] = value;
          return true;
        }

        if (question.type === 'checkbox') {
          const checkedInputs = Array.from(
            questionRegion.querySelectorAll(
              'input[type="checkbox"]:checked'
            )
          );

          if (checkedInputs.length === 0) {
  renderError(
    question.requireAll
      ? 'Vink alle verklaringen aan om verder te gaan.'
      : 'Kies minimaal één antwoord om verder te gaan.'
  );

  return false;
}

if (
  question.requireAll &&
  checkedInputs.length !== question.options.length
) {
  renderError('Vink alle verklaringen aan om verder te gaan.');
  return false;
}

answers[question.id] = checkedInputs.map(
  (input) => input.value
);

if (question.id === 'previous_weight_loss_attempts') {
  if (!answers[question.id].includes('weight_loss_medication')) {
    delete answers.previous_weight_loss_medications;
    delete answers.previous_weight_loss_medications_other;
    delete answers.previous_weight_loss_medication_details;
  }
}

if (question.id === 'previous_weight_loss_medications') {
  const selectedTreatments = answers[question.id];

  if (!selectedTreatments.includes('other')) {
    delete answers.previous_weight_loss_medications_other;
  }

  if (
    Array.isArray(answers.previous_weight_loss_medication_details)
  ) {
    answers.previous_weight_loss_medication_details =
      answers.previous_weight_loss_medication_details.filter(
        (item) => selectedTreatments.includes(item.treatment)
      );
  }
}

          if (
            answers[question.id].includes('other') &&
            !questionRegion
              .querySelector('[data-kq-other-input]')
              ?.value.trim()
          ) {
            renderError('Vul bij “Anders, namelijk” een korte toelichting in.');
            return false;
          }

          return true;
        }

        if (question.type === 'medication_history') {
          const cards = Array.from(
            questionRegion.querySelectorAll(
              '[data-kq-medication-card]'
            )
          );

          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          const currentMonth = currentDate.getMonth() + 1;
          const validatedHistory = [];

          const markError = (field) => {
            field?.classList.add('has-error');
          };

          const isValidMonthYear = (month, year) => {
            return (
              month >= 1 &&
              month <= 12 &&
              year >= 1900 &&
              year <= currentYear
            );
          };

          const isFutureMonth = (month, year) => {
            return (
              year > currentYear ||
              (year === currentYear && month > currentMonth)
            );
          };

          for (const card of cards) {
            const treatment = card.dataset.medicationKey || '';
            const medicationName =
              card.dataset.medicationName || treatment;

            const dosageField = card.querySelector(
              '[data-kq-medication-dosage]'
            );
            const startMonthField = card.querySelector(
              '[data-kq-medication-start-month]'
            );
            const startYearField = card.querySelector(
              '[data-kq-medication-start-year]'
            );
            const statusField = card.querySelector(
              '[data-kq-medication-status]'
            );
            const endMonthField = card.querySelector(
              '[data-kq-medication-end-month]'
            );
            const endYearField = card.querySelector(
              '[data-kq-medication-end-year]'
            );

            const lastDosage = dosageField?.value.trim() || '';
            const startedMonth = Number.parseInt(
              startMonthField?.value || '',
              10
            );
            const startedYear = Number.parseInt(
              startYearField?.value || '',
              10
            );
            const usageStatus = statusField?.value || '';
            const stillUsing = usageStatus === 'still_using';

            if (dosageField && !lastDosage) {
              markError(dosageField);
              renderError(
                `Vul voor ${medicationName} de laatst gebruikte dosering in.`
              );
              return false;
            }

            if (
              !isValidMonthYear(startedMonth, startedYear) ||
              isFutureMonth(startedMonth, startedYear)
            ) {
              markError(startMonthField);
              markError(startYearField);
              renderError(
                `Vul voor ${medicationName} een geldige startmaand en een geldig startjaar in.`
              );
              return false;
            }

            if (!usageStatus) {
              markError(statusField);
              renderError(
                `Geef voor ${medicationName} aan of je deze behandeling nog gebruikt.`
              );
              return false;
            }

            let endedMonth = null;
            let endedYear = null;

            if (!stillUsing) {
              endedMonth = Number.parseInt(
                endMonthField?.value || '',
                10
              );
              endedYear = Number.parseInt(
                endYearField?.value || '',
                10
              );

              if (
                !isValidMonthYear(endedMonth, endedYear) ||
                isFutureMonth(endedMonth, endedYear)
              ) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `Vul voor ${medicationName} een geldige stopmaand en een geldig stopjaar in.`
                );
                return false;
              }

              const startValue = startedYear * 12 + startedMonth;
              const endValue = endedYear * 12 + endedMonth;

              if (endValue < startValue) {
                markError(endMonthField);
                markError(endYearField);
                renderError(
                  `De stopdatum van ${medicationName} kan niet vóór de startdatum liggen.`
                );
                return false;
              }
            }

            const historyItem = {
              treatment,
              started_month: getMedicationMonthLabel(startedMonth),
              started_year: startedYear,
              usage_status: usageStatus,
              still_using: stillUsing,
              ended_month: stillUsing
                ? null
                : getMedicationMonthLabel(endedMonth),
              ended_year: stillUsing ? null : endedYear
            };

            if (dosageField) {
              historyItem.last_dosage = lastDosage;
            }

            validatedHistory.push(historyItem);
          }

          const shownDefinition = shownQuestions.get(question.id);

          if (shownDefinition) {
            shownDefinition.subquestions =
              serializeMedicationSubquestions(cards);
          }

          answers[question.id] = validatedHistory;
          return true;
        }

        if (question.type === 'measurements') {
          const heightInput = questionRegion.querySelector('[data-kq-height]');
          const weightInput = questionRegion.querySelector('[data-kq-weight]');

          const height = Number.parseFloat(heightInput.value);
          const weight = Number.parseFloat(weightInput.value);

          if (!height || height < 120 || height > 230) {
            heightInput.classList.add('has-error');
            renderError('Vul een geldige lengte tussen 120 en 230 cm in.');
            return false;
          }

          if (!weight || weight < 35 || weight > 350) {
            weightInput.classList.add('has-error');
            renderError('Vul een geldig gewicht tussen 35 en 350 kg in.');
            return false;
          }

          const bmi = weight / Math.pow(height / 100, 2);

          answers[question.id] = {
            height,
            weight,
            bmi: Number.parseFloat(bmi.toFixed(1))
          };

          return true;
        }

        return true;
      };

      const getStopStatus = () => {
        if (currentQuestionId === 'dateOfBirth') {
          const birthDate = parseDateOfBirth(answers.dateOfBirth);

          if (!birthDate) return null;

          const age = calculateAge(
            birthDate.day,
            birthDate.month,
            birthDate.year
          );

          if (age < 18) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn alleen beschikbaar voor volwassenen vanaf 18 jaar. Bespreek met je huisarts welke ondersteuning bij jou past.'
            };
          }

          if (age > 76) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'De gewichtsverliesbehandelingen binnen dit Kearty-traject zijn beschikbaar voor cliënten tot en met 76 jaar. Bespreek met je huisarts of behandelend arts welke mogelijkheden in jouw situatie passend zijn.'
            };
          }
        }

        if (currentQuestionId === 'pregnancy_status') {
          const excludedStatuses = [
            'pregnant',
            'breastfeeding',
            'trying_to_conceive'
          ];

          if (excludedStatuses.includes(answers.pregnancy_status)) {
            return {
              title: 'Via Kearty kunnen we je op dit moment geen behandeling aanbieden',
              message:
                'Je hebt aangegeven dat je zwanger bent, borstvoeding geeft of probeert zwanger te worden. Daarom kun je via het huidige Kearty-traject geen gewichtsverliesbehandeling met medicatie aanvragen. Bespreek met je huisarts of behandelend arts welke ondersteuning in jouw situatie passend is.'
            };
          }
        }

        if (currentQuestionId === 'body_measurements') {
  const bmi = answers.body_measurements?.bmi;

  if (bmi < 19) {
    return {
      title: 'Op dit moment geen passende behandeling met medicatie',
      message:
        'Je BMI is lager dan 19. Op basis van deze uitkomst is een behandeling gericht op gewichtsverlies niet passend. Daarom kan Kearty je via deze route geen behandeling aanbieden. Bespreek met je huisarts welke ondersteuning in jouw situatie passend is.'
    };
  }

  if (bmi < 25) {
  return {
    title: 'Op dit moment geen passende behandeling met medicatie',
    message:
      'Je BMI valt binnen de categorie gezond gewicht. Op basis van deze uitkomst lijkt een behandeling met gewichtsverliesmedicatie op dit moment niet passend. Daarom kan Kearty je via deze route geen passende behandeling aanbieden.'
  };
}
}

if (currentQuestionId === 'pancreas_conditions') {
  const selectedConditions = Array.isArray(answers.pancreas_conditions)
    ? answers.pancreas_conditions
    : [];

  const stopValues = [
    'pancreatitis',
    'other_pancreas_condition',
    'pancreas_removed'
  ];

  const shouldStop = selectedConditions.some((value) =>
    stopValues.includes(value)
  );

  if (shouldStop) {
  return {
    type: 'stop',
    title: 'We kunnen je aanvraag niet via deze route voortzetten',
    message:
      'Je hebt aangegeven dat je een aandoening of behandeling aan de alvleesklier hebt gehad. Op basis van deze informatie kan Kearty je aanvraag niet via deze online vragenlijst voortzetten. Neem bij vragen gerust contact met ons op.'
  };
}
}

if (
  currentQuestionId === 'current_gallbladder_symptoms' &&
  answers.current_gallbladder_symptoms === 'yes'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment klachten hebt die mogelijk te maken hebben met je galblaas of galwegen. Daarom kunnen we je aanvraag niet direct via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken wat in jouw situatie de juiste vervolgstap is.'
  };
}

if (
  currentQuestionId === 'eating_disorder_current_status' &&
  answers.eating_disorder_current_status === 'current'
) {
  return {
    type: 'stop',
    title: 'Je aanvraag heeft extra medische beoordeling nodig',
    message:
      'Je hebt aangegeven dat je op dit moment last hebt van een eetstoornis of ernstige problemen met eten. Daarom kunnen we je aanvraag niet via deze online vragenlijst voortzetten. Neem contact met ons op, zodat we samen kunnen bekijken welke ondersteuning in jouw situatie passend is.'
  };
}

return null;
};

      const goToNextQuestion = () => {
  pruneHiddenAnswers();
  const stopStatus = getStopStatus();

  if (stopStatus) {
    renderStatus(stopStatus);
    return;
  }

  const visibleQuestions = getVisibleQuestions();

  const currentIndex = visibleQuestions.findIndex(
    (question) => question.id === currentQuestionId
  );

  const currentQuestion = visibleQuestions[currentIndex];
  const nextQuestion = visibleQuestions[currentIndex + 1];

  const currentSection = currentQuestion?.section || 'about';

const nextSection = nextQuestion
  ? nextQuestion.section || 'about'
  : null;

  /*
   * Eerst een overgangsscherm tonen wanneer
   * het volgende onderdeel begint.
   */
  if (nextQuestion && currentSection !== nextSection) {
  if (currentSection === 'about' && nextSection === 'health') {
    renderStatus({
      type: 'complete',
      title: 'De stap "Over jou" is afgerond',
      message:
        'We gaan nu verder met een aantal vragen over jouw gezondheid.',
      nextQuestionId: nextQuestion.id,
      nextSection: 'health',
      nextButtonLabel: 'Verder naar jouw gezondheid'
    });

    return;
  }

  if (currentSection === 'health' && nextSection === 'final') {
    renderStatus({
      type: 'consent_intro',
      title: 'Rond je aanvraag af',
      message:
        'Je hebt de stap "Jouw gezondheid" afgerond. Op basis van je gezondheidssituatie lijkt de gekozen behandeling mogelijk bij jou te passen. We hebben alleen nog een paar gegevens en bevestigingen van je nodig voordat je verder kunt naar betalen.',
      nextQuestionId: getFirstFinalQuestionId(),
      nextSection: 'final',
      nextButtonLabel: 'Verder met afronden'
    });

    return;
  }
}

  if (currentQuestionId === 'final_declarations') {
    renderStatus({
      type: 'checkout_ready',
      title: 'Je kunt verder naar betalen',
      message:
        'Je hebt alle benodigde gegevens en bevestigingen ingevuld. Je kunt nu verder naar betalen. Ben je nieuw bij Kearty? Rond dan na de betaling eenmalig de identiteitscontrole af. Daarna neemt de arts je aanvraag in behandeling.'
    });

    return;
  }

  /*
   * Tijdelijke afronding zolang nog niet alle
   * gezondheidsvragen zijn toegevoegd.
   */
  if (!nextQuestion) {
    renderStatus({
      type: 'health_complete',
      title: 'De stap "Jouw gezondheid" is afgerond',
      message:
        'Je hebt alle vragen in dit onderdeel beantwoord.'
    });

    return;
  }

  history.push(currentQuestionId);
  currentQuestionId = nextQuestion.id;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};

      form.addEventListener('submit', (event) => {
        event.preventDefault();

        if (
          statusScreen?.type === 'complete' ||
          statusScreen?.type === 'consent_intro'
        ) {
  if (
    statusScreen.type === 'complete' &&
    statusScreen.nextSection === 'health'
  ) {
    root.dispatchEvent(
      new CustomEvent('kearty:about-section-complete', {
        bubbles: true,
        detail: { answers: serializeAnswers() }
      })
    );
  }

  const nextQuestionId = statusScreen.nextQuestionId;

  if (!nextQuestionId) return;

  history.push(currentQuestionId);
  currentQuestionId = nextQuestionId;
  statusScreen = null;

  renderQuestion();

  root.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });

  return;
}

        if (!validateCurrentQuestion()) return;

        goToNextQuestion();
      });

      backButton.addEventListener('click', () => {
        if (statusScreen) {
          statusScreen = null;
          renderQuestion();
          return;
        }

        const previousQuestionId = history.pop();

        if (!previousQuestionId) return;

        currentQuestionId = previousQuestionId;
        renderQuestion();

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      });

      helpButton.addEventListener('click', () => {
        const chatSelector = root.dataset.chatSelector?.trim();
        const helpUrl = root.dataset.helpUrl?.trim();

        if (chatSelector) {
          const chatLauncher = document.querySelector(chatSelector);

          if (chatLauncher) {
            chatLauncher.click();
            return;
          }
        }

        const chatEvent = new CustomEvent('kearty:open-chat', {
          bubbles: true
        });

        root.dispatchEvent(chatEvent);

        if (helpUrl) {
          window.location.href = helpUrl;
        }
      });

      root.addEventListener('click', (event) => {
        const finalCheckoutButton = event.target.closest(
          '[data-kq-final-checkout]'
        );

        if (
          !finalCheckoutButton ||
          !root.contains(finalCheckoutButton) ||
          finalCheckoutButton.disabled
        ) {
          return;
        }

        const treatment = finalCheckoutButton.dataset.treatment || '';
        const variantId = finalCheckoutButton.dataset.variantId || '';

        const errorElement = questionRegion.querySelector(
          '[data-kq-apply-error]'
        );

        if (!treatment || !/^[1-9]\d*$/.test(variantId) || !selectedTreatmentAvailable) {
          if (errorElement) {
            errorElement.textContent =
              'De gekozen behandeling kon niet worden teruggevonden. Ga terug naar de behandeling en start je aanvraag opnieuw.';
            errorElement.hidden = false;
          }

          return;
        }

        if (errorElement) {
          errorElement.textContent = '';
          errorElement.hidden = true;
        }
        pruneHiddenAnswers();

        const applicationEvent = new CustomEvent(
          'kearty:treatment-apply',
          {
            bubbles: true,
            cancelable: true,
            detail: {
              treatment,
              variantId,
              answers: serializeAnswers(),
              questions: serializeQuestions(),
              questionnaireKey: 'weight-loss-flow-2',
              questionnaireVersion: '2026-10-13'
            }
          }
        );

        const eventWasNotCancelled =
          root.dispatchEvent(applicationEvent);

        if (!eventWasNotCancelled) {
          root.querySelectorAll('[data-kq-treatment-apply]').forEach((button) => {
            button.disabled = true;
            button.innerHTML = 'Aanvraag wordt verwerkt…';
          });
          return;
        }

        if (errorElement) {
          errorElement.textContent =
            'De aanvraagkoppeling is nog niet geactiveerd. Probeer het later opnieuw of neem contact met ons op.';
          errorElement.hidden = false;
        }
      });

      const initialTreatment = resolveInitialTreatment();
      const isThemeEditor = Boolean(window.Shopify?.designMode);

      if (initialTreatment.error && isThemeEditor) {
        /*
         * In de Shopify Theme Editor is er geen echte productinstroom
         * en dus meestal geen treatment/variant parameter in de URL.
         * Alleen voor preview/testing laten we de vragenlijst dan starten.
         * Op de live storefront blijft een geldige behandeling verplicht.
         */
        selectedTreatment = '';
        selectedVariantId = '';
        selectedTreatmentAvailable = false;

        renderQuestion();
      } else if (initialTreatment.error) {
        renderStatus({
          type: 'stop',
          title: 'We kunnen je gekozen behandeling niet openen',
          message:
            'De gekozen behandeling of dosering kon niet veilig worden teruggevonden. Ga terug naar de behandeling en start je aanvraag opnieuw.'
        });
      } else if (!initialTreatment.available) {
        selectedTreatment = initialTreatment.treatment;
        selectedVariantId = initialTreatment.variantId;
        selectedTreatmentAvailable = false;

        renderStatus({
          type: 'stop',
          title: 'Deze behandeling is op dit moment niet beschikbaar',
          message:
            'De behandeling of dosering die je hebt gekozen is momenteel niet beschikbaar. Kies een andere beschikbare behandeling of neem contact met ons op.'
        });
      } else {
        selectedTreatment = initialTreatment.treatment;
        selectedVariantId = initialTreatment.variantId;
        selectedTreatmentAvailable = true;

        renderQuestion();
      }

    };

    document
      .querySelectorAll('[data-kearty-questionnaire-flow-2]')
      .forEach(initFlow2Questionnaire);

    document.addEventListener('shopify:section:load', (event) => {
      const sectionRoot =
        event.target.matches?.('[data-kearty-questionnaire-flow-2]')
          ? event.target
          : event.target.querySelector(
              '[data-kearty-questionnaire-flow-2]'
            );

      if (sectionRoot) {
        initFlow2Questionnaire(sectionRoot);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
